!(function(e, t) {
  typeof exports === 'object' && typeof module === 'object' ? module.exports = t() : typeof define === 'function' && define.amd ? define([], t) : typeof exports === 'object' ? exports.wangEditor = t() : e.wangEditor = t()
}(window, () => {
  return o = {}, i.m = n = [function(e, t) {
    e.exports = function(e) {
      return e && e.__esModule ? e : { default: e }
    }, e.exports.default = e.exports, e.exports.__esModule = !0
  }, function(e, t, n) {
    e.exports = n(142)
  }, function(e, t, n) {
    'use strict'; n.r(t), n.d(t, '__extends', () => {
      return i
    }), n.d(t, '__assign', () => {
      return r
    }), n.d(t, '__rest', () => {
      return a
    }), n.d(t, '__decorate', () => {
      return l
    }), n.d(t, '__param', () => {
      return u
    }), n.d(t, '__metadata', () => {
      return s
    }), n.d(t, '__awaiter', () => {
      return c
    }), n.d(t, '__generator', () => {
      return f
    }), n.d(t, '__createBinding', () => {
      return d
    }), n.d(t, '__exportStar', () => {
      return p
    }), n.d(t, '__values', () => {
      return h
    }), n.d(t, '__read', () => {
      return A
    }), n.d(t, '__spread', () => {
      return v
    }), n.d(t, '__spreadArrays', () => {
      return m
    }), n.d(t, '__spreadArray', () => {
      return g
    }), n.d(t, '__await', () => {
      return y
    }), n.d(t, '__asyncGenerator', () => {
      return w
    }), n.d(t, '__asyncDelegator', () => {
      return x
    }), n.d(t, '__asyncValues', () => {
      return _
    }), n.d(t, '__makeTemplateObject', () => {
      return E
    }), n.d(t, '__importStar', () => {
      return C
    }), n.d(t, '__importDefault', () => {
      return S
    }), n.d(t, '__classPrivateFieldGet', () => {
      return D
    }), n.d(t, '__classPrivateFieldSet', () => {
      return M
    })
    /*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
    var o = function(e, t) {
      return (o = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(e, t) {
        e.__proto__ = t
      } || function(e, t) {
        for (const n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n])
      })(e, t)
    }; function i(e, t) {
      if (typeof t !== 'function' && t !== null) throw new TypeError(`Class extends value ${String(t)} is not a constructor or null`); function n() {
        this.constructor = e
      }o(e, t), e.prototype = t === null ? Object.create(t) : (n.prototype = t.prototype, new n())
    } var r = function() {
      return (r = Object.assign || function(e) {
        for (var t, n = 1, o = arguments.length; n < o; n++) for (const i in t = arguments[n])Object.prototype.hasOwnProperty.call(t, i) && (e[i] = t[i]); return e
      }).apply(this, arguments)
    }; function a(e, t) {
      const n = {}; for (i in e)Object.prototype.hasOwnProperty.call(e, i) && t.indexOf(i) < 0 && (n[i] = e[i]); if (e != null && typeof Object.getOwnPropertySymbols === 'function') for (var o = 0, i = Object.getOwnPropertySymbols(e); o < i.length; o++)t.indexOf(i[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, i[o]) && (n[i[o]] = e[i[o]]); return n
    } function l(e, t, n, o) {
      let i; const r = arguments.length; let a = r < 3 ? t : o === null ? o = Object.getOwnPropertyDescriptor(t, n) : o; if (typeof Reflect === 'object' && typeof Reflect.decorate === 'function')a = Reflect.decorate(e, t, n, o); else for (let l = e.length - 1; l >= 0; l--)(i = e[l]) && (a = (r < 3 ? i(a) : r > 3 ? i(t, n, a) : i(t, n)) || a); return r > 3 && a && Object.defineProperty(t, n, a), a
    } function u(n, o) {
      return function(e, t) {
        o(e, t, n)
      }
    } function s(e, t) {
      if (typeof Reflect === 'object' && typeof Reflect.metadata === 'function') return Reflect.metadata(e, t)
    } function c(e, a, l, u) {
      return new (l = l || Promise)((n, t) => {
        function o(e) {
          try {
            r(u.next(e))
          } catch (e) {
            t(e)
          }
        } function i(e) {
          try {
            r(u.throw(e))
          } catch (e) {
            t(e)
          }
        } function r(e) {
          let t; e.done
            ? n(e.value)
            : ((t = e.value) instanceof l
                ? t
                : new l((e) => {
                  e(t)
                })).then(o, i)
        }r((u = u.apply(e, a || [])).next())
      })
    } function f(n, o) {
      let i; let r; let a; let l = {
        label: 0,
        sent: function() {
          if (1 & a[0]) throw a[1]; return a[1]
        },
        trys: [],
        ops: []
      }; const e = { next: t(0), throw: t(1), return: t(2) }; return typeof Symbol === 'function' && (e[Symbol.iterator] = function() {
        return this
      }), e; function t(t) {
        return function(e) {
          return (function(t) {
            if (i) throw new TypeError('Generator is already executing.'); for (;l;) {
              try {
                if (i = 1, r && (a = 2 & t[0] ? r.return : t[0] ? r.throw || ((a = r.return) && a.call(r), 0) : r.next) && !(a = a.call(r, t[1])).done) return a; switch (r = 0, (t = a ? [2 & t[0], a.value] : t)[0]) {
                  case 0:case 1:a = t; break; case 4:return l.label++, { value: t[1], done: !1 }; case 5:l.label++, r = t[1], t = [0]; continue; case 7:t = l.ops.pop(), l.trys.pop(); continue; default:if (!(a = (a = l.trys).length > 0 && a[a.length - 1]) && (t[0] === 6 || t[0] === 2)) {
                    l = 0; continue
                  } if (t[0] === 3 && (!a || t[1] > a[0] && t[1] < a[3])) {
                      l.label = t[1]; break
                    } if (t[0] === 6 && l.label < a[1]) {
                      l.label = a[1], a = t; break
                    } if (a && l.label < a[2]) {
                      l.label = a[2], l.ops.push(t); break
                    }a[2] && l.ops.pop(), l.trys.pop(); continue
                }t = o.call(n, l)
              } catch (e) {
                t = [6, e], r = 0
              } finally {
                i = a = 0
              }
            } if (5 & t[0]) throw t[1]; return { value: t[0] ? t[1] : void 0, done: !0 }
          }([t, e]))
        }
      }
    } var d = Object.create
      ? function(e, t, n, o) {
        void 0 === o && (o = n), Object.defineProperty(e, o, {
          enumerable: !0,
          get: function() {
            return t[n]
          }
        })
      }
      : function(e, t, n, o) {
        e[o = void 0 === o ? n : o] = t[n]
      }; function p(e, t) {
      for (const n in e)n === 'default' || Object.prototype.hasOwnProperty.call(t, n) || d(t, e, n)
    } function h(e) {
      const t = typeof Symbol === 'function' && Symbol.iterator; const n = t && e[t]; let o = 0; if (n) return n.call(e); if (e && typeof e.length === 'number') {
        return {
          next: function() {
            return { value: (e = e && o >= e.length ? void 0 : e) && e[o++], done: !e }
          }
        }
      } throw new TypeError(t ? 'Object is not iterable.' : 'Symbol.iterator is not defined.')
    } function A(e, t) {
      let n = typeof Symbol === 'function' && e[Symbol.iterator]; if (!n) return e; let o; let i; const r = n.call(e); const a = []; try {
        for (;(void 0 === t || t-- > 0) && !(o = r.next()).done;)a.push(o.value)
      } catch (e) {
        i = { error: e }
      } finally {
        try {
          o && !o.done && (n = r.return) && n.call(r)
        } finally {
          if (i) throw i.error
        }
      } return a
    } function v() {
      for (var e = [], t = 0; t < arguments.length; t++)e = e.concat(A(arguments[t])); return e
    } function m() {
      for (var e = 0, t = 0, n = arguments.length; t < n; t++)e += arguments[t].length; for (var o = Array(e), i = 0, t = 0; t < n; t++) for (let r = arguments[t], a = 0, l = r.length; a < l; a++, i++)o[i] = r[a]; return o
    } function g(e, t) {
      for (let n = 0, o = t.length, i = e.length; n < o; n++, i++)e[i] = t[n]; return e
    } function y(e) {
      return this instanceof y ? (this.v = e, this) : new y(e)
    } function w(e, t, n) {
      if (!Symbol.asyncIterator) throw new TypeError('Symbol.asyncIterator is not defined.'); const i = n.apply(e, t || []); const r = []; const a = {}; return o('next'), o('throw'), o('return'), a[Symbol.asyncIterator] = function() {
        return this
      }, a; function o(o) {
        i[o] && (a[o] = function(n) {
          return new Promise((e, t) => {
            r.push([o, n, e, t]) > 1 || l(o, n)
          })
        })
      } function l(e, t) {
        try {
          (n = i[e](t)).value instanceof y ? Promise.resolve(n.value.v).then(u, s) : c(r[0][2], n)
        } catch (e) {
          c(r[0][3], e)
        } let n
      } function u(e) {
        l('next', e)
      } function s(e) {
        l('throw', e)
      } function c(e, t) {
        e(t), r.shift(), r.length && l(r[0][0], r[0][1])
      }
    } function x(o) {
      let i; const e = {}; return t('next'), t('throw', (e) => {
        throw e
      }), t('return'), e[Symbol.iterator] = function() {
        return this
      }, e; function t(t, n) {
        e[t] = o[t]
          ? function(e) {
            return (i = !i) ? { value: y(o[t](e)), done: t === 'return' } : n ? n(e) : e
          }
          : n
      }
    } function _(a) {
      if (!Symbol.asyncIterator) throw new TypeError('Symbol.asyncIterator is not defined.'); let e; const t = a[Symbol.asyncIterator]; return t
        ? t.call(a)
        : (a = h(a), e = {}, n('next'), n('throw'), n('return'), e[Symbol.asyncIterator] = function() {
            return this
          }, e); function n(r) {
        e[r] = a[r] && function(i) {
          return new Promise((e, t) => {
            let n; let o; i = a[r](i), n = e, e = t, o = i.done, t = i.value, Promise.resolve(t).then((e) => {
              n({ value: e, done: o })
            }, e)
          })
        }
      }
    } function E(e, t) {
      return Object.defineProperty ? Object.defineProperty(e, 'raw', { value: t }) : e.raw = t, e
    } const b = Object.create
      ? function(e, t) {
        Object.defineProperty(e, 'default', { enumerable: !0, value: t })
      }
      : function(e, t) {
        e.default = t
      }; function C(e) {
      if (e && e.__esModule) return e; const t = {}; if (e != null) for (const n in e)n !== 'default' && Object.prototype.hasOwnProperty.call(e, n) && d(t, e, n); return b(t, e), t
    } function S(e) {
      return e && e.__esModule ? e : { default: e }
    } function D(e, t, n, o) {
      if (n === 'a' && !o) throw new TypeError('Private accessor was defined without a getter'); if (typeof t === 'function' ? e !== t || !o : !t.has(e)) throw new TypeError('Cannot read private member from an object whose class did not declare it'); return n === 'm' ? o : n === 'a' ? o.call(e) : o ? o.value : t.get(e)
    } function M(e, t, n, o, i) {
      if (o === 'm') throw new TypeError('Private method is not writable'); if (o === 'a' && !i) throw new TypeError('Private accessor was defined without a setter'); if (typeof t === 'function' ? e !== t || !i : !t.has(e)) throw new TypeError('Cannot write private member to an object whose class did not declare it'); return o === 'a' ? i.call(e, n) : i ? i.value = n : t.set(e, n), n
    }
  }, function(e, t, n) {
    'use strict'; const o = n(0); const i = o(n(1)); const r = o(n(92)); const u = o(n(4)); const a = o(n(26)); const l = o(n(19)); const s = o(n(120)); const c = o(n(27)); const f = o(n(94)); const d = o(n(73)); const p = o(n(56)); const h = o(n(57)); (0, i.default)(t, '__esModule', { value: !0 }), t.DomElement = void 0; const A = n(2); const v = n(6); const m = []; function g(e) {
      var t = []; const n = []; var t = (0, r.default)(e) ? e : e.split(';'); return (0, u.default)(t).call(t, (e) => {
        e = (0, a.default)(e = e.split(':')).call(e, (e) => {
          return (0, l.default)(e).call(e)
        }); e.length === 2 && n.push(`${e[0]}:${e[1]}`)
      }), n
    } const y = ((0, i.default)(w.prototype, 'id', {
      get: function() {
        return this.elems[0].id
      },
      enumerable: !1,
      configurable: !0
    }), w.prototype.forEach = function(e) {
      for (let t = 0; t < this.length; t++) {
        const n = this.elems[t]; if (!1 === e.call(n, n, t)) break
      } return this
    }, w.prototype.clone = function(t) {
      let e; void 0 === t && (t = !1); const n = []; return (0, u.default)(e = this.elems).call(e, (e) => {
        n.push(e.cloneNode(!!t))
      }), x(n)
    }, w.prototype.get = function(e) {
      const t = this.length; return t <= (e = void 0 === e ? 0 : e) && (e %= t), x(this.elems[e])
    }, w.prototype.first = function() {
      return this.get(0)
    }, w.prototype.last = function() {
      const e = this.length; return this.get(e - 1)
    }, w.prototype.on = function(n, o, i) {
      return n
        ? (typeof o === 'function' && (i = o, o = ''), (0, u.default)(this).call(this, (e) => {
            let t; o
              ? (e.addEventListener(n, t = function(e) {
                  const t = e.target; t.matches(o) && i.call(t, e)
                }), m.push({ elem: e, selector: o, fn: i, agentFn: t }))
              : e.addEventListener(n, i)
          }))
        : this
    }, w.prototype.off = function(r, a, l) {
      return r
        ? (typeof a === 'function' && (l = a, a = ''), (0, u.default)(this).call(this, (e) => {
            if (a) {
              for (var t, n = -1, o = 0; o < m.length; o++) {
                const i = m[o]; if (i.selector === a && i.fn === l && i.elem === e) {
                  n = o; break
                }
              }n !== -1 && (t = (0, f.default)(m).call(m, n, 1)[0].agentFn, e.removeEventListener(r, t))
            } else e.removeEventListener(r, l)
          }))
        : this
    }, w.prototype.attr = function(t, n) {
      return n == null
        ? this.elems[0].getAttribute(t) || ''
        : (0, u.default)(this).call(this, (e) => {
            e.setAttribute(t, n)
          })
    }, w.prototype.removeAttr = function(t) {
      (0, u.default)(this).call(this, (e) => {
        e.removeAttribute(t)
      })
    }, w.prototype.addClass = function(n) {
      return n
        ? (0, u.default)(this).call(this, (e) => {
            let t; e.className
              ? (t = e.className.split(/\s/), t = (0, d.default)(t).call(t, (e) => {
                  return !!(0, l.default)(e).call(e)
                }), (0, c.default)(t).call(t, n) < 0 && t.push(n), e.className = t.join(' '))
              : e.className = n
          })
        : this
    }, w.prototype.removeClass = function(n) {
      return n
        ? (0, u.default)(this).call(this, (e) => {
            let t; e.className && (t = e.className.split(/\s/), t = (0, d.default)(t).call(t, (e) => {
              return !(!(e = (0, l.default)(e).call(e)) || e === n)
            }), e.className = t.join(' '))
          })
        : this
    }, w.prototype.hasClass = function(e) {
      if (!e) return !1; let t = this.elems[0]; if (!t.className) return !1; t = t.className.split(/\s/); return (0, p.default)(t).call(t, e)
    }, w.prototype.css = function(n, e) {
      const o = e == '' ? '' : `${n}:${e};`; return (0, u.default)(this).call(this, (e) => {
        var t = (0, l.default)(t = e.getAttribute('style') || '').call(t); t
          ? (t = g(t), t = (0, a.default)(t).call(t, (e) => {
              return (0, c.default)(e).call(e, n) === 0 ? o : e
            }), o != '' && (0, c.default)(t).call(t, o) < 0 && t.push(o), o == '' && (t = g(t)), e.setAttribute('style', t.join('; ')))
          : e.setAttribute('style', o)
      })
    }, w.prototype.getBoundingClientRect = function() {
      return this.elems[0].getBoundingClientRect()
    }, w.prototype.show = function() {
      return this.css('display', 'block')
    }, w.prototype.hide = function() {
      return this.css('display', 'none')
    }, w.prototype.children = function() {
      const e = this.elems[0]; return e ? x(e.children) : null
    }, w.prototype.childNodes = function() {
      const e = this.elems[0]; return e ? x(e.childNodes) : null
    }, w.prototype.replaceChildAll = function(e) {
      for (let t = this.getNode(), n = this.elems[0]; n.hasChildNodes();)t.firstChild && n.removeChild(t.firstChild); this.append(e)
    }, w.prototype.append = function(e) {
      return (0, u.default)(this).call(this, (t) => {
        (0, u.default)(e).call(e, (e) => {
          t.appendChild(e)
        })
      })
    }, w.prototype.remove = function() {
      return (0, u.default)(this).call(this, (e) => {
        let t; e.remove ? e.remove() : (t = e.parentElement) && t.removeChild(e)
      })
    }, w.prototype.isContain = function(e) {
      const t = this.elems[0]; var e = e.elems[0]; return t.contains(e)
    }, w.prototype.getNodeName = function() {
      return this.elems[0].nodeName
    }, w.prototype.getNode = function(e) {
      return this.elems[e = void 0 === e ? 0 : e]
    }, w.prototype.find = function(e) {
      return x(this.elems[0].querySelectorAll(e))
    }, w.prototype.text = function(t) {
      return t
        ? (0, u.default)(this).call(this, (e) => {
            e.innerHTML = t
          })
        : this.elems[0].innerHTML.replace(/<[^>]+>/g, () => {
          return ''
        })
    }, w.prototype.html = function(e) {
      const t = this.elems[0]; return e ? (t.innerHTML = e, this) : t.innerHTML
    }, w.prototype.val = function() {
      let e = this.elems[0]; return (0, l.default)(e = e.value).call(e)
    }, w.prototype.focus = function() {
      return (0, u.default)(this).call(this, (e) => {
        e.focus()
      })
    }, w.prototype.prev = function() {
      return x(this.elems[0].previousElementSibling)
    }, w.prototype.next = function() {
      return x(this.elems[0].nextElementSibling)
    }, w.prototype.getNextSibling = function() {
      return x(this.elems[0].nextSibling)
    }, w.prototype.parent = function() {
      return x(this.elems[0].parentElement)
    }, w.prototype.parentUntil = function(e, t) {
      t = t || this.elems[0]; if (t.nodeName === 'BODY') return null; t = t.parentElement; return t === null ? null : t.matches(e) ? x(t) : this.parentUntil(e, t)
    }, w.prototype.parentUntilEditor = function(e, t, n) {
      n = n || this.elems[0]; if (x(n).equal(t.$textContainerElem) || x(n).equal(t.$toolbarElem)) return null; n = n.parentElement; return n === null ? null : n.matches(e) ? x(n) : this.parentUntilEditor(e, t, n)
    }, w.prototype.equal = function(e) {
      return e instanceof w ? this.elems[0] === e.elems[0] : e instanceof HTMLElement && this.elems[0] === e
    }, w.prototype.insertBefore = function(e) {
      const t = x(e).elems[0]; return t
        ? (0, u.default)(this).call(this, (e) => {
            t.parentNode.insertBefore(e, t)
          })
        : this
    }, w.prototype.insertAfter = function(e) {
      const n = x(e).elems[0]; const o = n && n.nextSibling; return n
        ? (0, u.default)(this).call(this, (e) => {
            const t = n.parentNode; o ? t.insertBefore(e, o) : t.appendChild(e)
          })
        : this
    }, w.prototype.data = function(e, t) {
      if (t == null) return this.dataSource.get(e); this.dataSource.set(e, t)
    }, w.prototype.getNodeTop = function(e) {
      if (this.length < 1) return this; const t = this.parent(); return e.$textElem.equal(this) || e.$textElem.equal(t) ? this : (t.prior = this, t.getNodeTop(e))
    }, w.prototype.getOffsetData = function() {
      const e = this.elems[0]; return { top: e.offsetTop, left: e.offsetLeft, width: e.offsetWidth, height: e.offsetHeight, parent: e.offsetParent }
    }, w.prototype.scrollTop = function(e) {
      this.elems[0].scrollTo({ top: e })
    }, w); function w(e) {
      if (this.elems = [], this.length = this.elems.length, this.dataSource = new s.default(), e) {
        if (e instanceof w) return e; let t; let n = []; let o = e instanceof Node ? e.nodeType : -1; this.selector = e, o === 1 || o === 9 ? n = [e] : (t = e) && (t instanceof HTMLCollection || t instanceof NodeList) ? n = v.toArray(e) : e instanceof Array ? n = e : typeof e === 'string' && (t = (0, l.default)(o = e.replace('/\n/mg', '')).call(o), n = (0, c.default)(t).call(t, '<') === 0 ? (e = t, (o = document.createElement('div')).innerHTML = e, o = o.children, v.toArray(o)) : (t = t, t = document.querySelectorAll(t), v.toArray(t))); const i = n.length; if (!i) return this; for (let r = 0; r < i; r++) this.elems.push(n[r]); this.length = i
      }
    } function x() {
      for (var e = [], t = 0; t < arguments.length; t++)e[t] = arguments[t]; return new ((0, h.default)(y).apply(y, A.__spreadArray([void 0], e)))()
    }t.DomElement = y, t.default = x
  }, function(e, t, n) {
    e.exports = n(183)
  }, function(e, t, n) {
    'use strict'; function h(o) {
      function e(e, t, n) {
        if (this instanceof o) {
          switch (arguments.length) {
            case 0:return new o(); case 1:return new o(e); case 2:return new o(e, t)
          } return new o(e, t, n)
        } return o.apply(this, arguments)
      } return e.prototype = o.prototype, e
    } const A = n(8); const v = n(74).f; const m = n(102); const g = n(10); const y = n(38); const w = n(17); const x = n(16); e.exports = function(e, t) {
      let n; let o; let i; let r; let a; const l = e.target; const u = e.global; const s = e.stat; const c = e.proto; const f = u ? A : s ? A[l] : (A[l] || {}).prototype; const d = u ? g : g[l] || (g[l] = {}); const p = d.prototype; for (n in t)r = !m(u ? n : l + (s ? '.' : '#') + n, e.forced) && f && x(f, n), o = d[n], r && (i = e.noTargetGet ? (a = v(f, n)) && a.value : f[n]), a = r && i ? i : t[n], r && typeof o === typeof a || (r = e.bind && r ? y(a, A) : e.wrap && r ? h(a) : c && typeof a === 'function' ? y(Function.call, a) : a, (e.sham || a && a.sham || o && o.sham) && w(r, 'sham', !0), d[n] = r, c && (x(g, r = `${l}Prototype`) || w(g, r, {}), g[r][n] = a, e.real && p && !p[n] && w(p, n, a)))
    }
  }, function(e, t, n) {
    'use strict'; const o = n(0); const i = o(n(95)); const r = o(n(1)); const a = o(n(262)); const l = o(n(44)); const u = o(n(45)); const s = o(n(92)); const c = o(n(26)); (0, r.default)(t, '__esModule', { value: !0 }), t.hexToRgb = t.getRandomCode = t.toArray = t.deepClone = t.isFunction = t.debounce = t.throttle = t.arrForEach = t.forEach = t.replaceSpecialSymbol = t.replaceHtmlSymbol = t.getRandom = t.UA = void 0; const f = n(2); var n = (d.prototype.isIE = function() {
      return 'ActiveXObject' in window
    }, d.prototype.isWebkit = function() {
      return /webkit/i.test(this._ua)
    }, d); function d() {
      this._ua = navigator.userAgent; const e = this._ua.match(/(Edge?)\/(\d+)/); this.isOldEdge = !!(e && e[1] == 'Edge' && (0, a.default)(e[2]) < 19), this.isFirefox = !(!/Firefox\/\d+/.test(this._ua) || /Seamonkey\/\d+/.test(this._ua))
    }t.UA = new n(), t.getRandom = function(e) {
      return (e = void 0 === e ? '' : e) + (0, l.default)(e = Math.random().toString()).call(e, 2)
    }, t.replaceHtmlSymbol = function(e) {
      return e.replace(/</gm, '&lt;').replace(/>/gm, '&gt;')
        .replace(/"/gm, '&quot;')
        .replace(/(\r\n|\r|\n)/g, '<br/>')
    }, t.replaceSpecialSymbol = function(e) {
      return e.replace(/&lt;/gm, '<').replace(/&gt;/gm, '>')
        .replace(/&quot;/gm, '"')
    }, t.forEach = function(e, t) {
      for (const n in e) if (Object.prototype.hasOwnProperty.call(e, n)) if (!1 === t(n, e[n])) break
    }, t.arrForEach = function(e, t) {
      for (var n, o = e.length || 0, i = 0; i < o && (n = e[i], !1 !== t.call(e, n, i)); i++);
    }, t.throttle = function(o, i) {
      void 0 === i && (i = 200); let r = !1; return function() {
        for (var e = this, t = [], n = 0; n < arguments.length; n++)t[n] = arguments[n]; r || (r = !0, (0, u.default)(() => {
          r = !1, o.call.apply(o, f.__spreadArray([e], t))
        }, i))
      }
    }, t.debounce = function(o, i) {
      void 0 === i && (i = 200); let r = 0; return function() {
        for (var e = this, t = [], n = 0; n < arguments.length; n++)t[n] = arguments[n]; r && window.clearTimeout(r), r = (0, u.default)(() => {
          r = 0, o.call.apply(o, f.__spreadArray([e], t))
        }, i)
      }
    }, t.isFunction = function(e) {
      return typeof e === 'function'
    }, t.deepClone = function e(t) {
      if ((0, i.default)(t) !== 'object' || typeof t === 'function' || t === null) return t; let n; let o; for (o in (0, s.default)(t) && (n = []), (0, s.default)(t) || (n = {}), t)Object.prototype.hasOwnProperty.call(t, o) && (n[o] = e(t[o])); return n
    }, t.toArray = function(e) {
      return (0, l.default)(Array.prototype).call(e)
    }, t.getRandomCode = function() {
      let e; return (0, l.default)(e = Math.random().toString(36)).call(e, -5)
    }, t.hexToRgb = function(e) {
      return (e = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(e)) == null
        ? null
        : `rgb(${(e = (0, c.default)(e).call(e, (e) => {
        return (0, a.default)(e, 16)
      }))[1]}, ${e[2]}, ${e[3]})`
    }
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }), t.EMPTY_P_REGEX = t.EMPTY_P_LAST_REGEX = t.EMPTY_P = t.urlRegex = t.EMPTY_FN = void 0, t.EMPTY_FN = function() {}, t.urlRegex = /^(http|ftp|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-.,@?^=%&amp;:/~+#]*[\w\-@?^=%&amp;/~+#])?/, t.EMPTY_P = '<p data-we-empty-p=""><br></p>', t.EMPTY_P_LAST_REGEX = /<p data-we-empty-p=""><br\/?><\/p>$/gim, t.EMPTY_P_REGEX = /<p data-we-empty-p="">/gim
  }, function(n, e, t) {
    !function(e) {
      function t(e) {
        return e && e.Math == Math && e
      }n.exports = t(typeof globalThis === 'object' && globalThis) || t(typeof window === 'object' && window) || t(typeof self === 'object' && self) || t(typeof e === 'object' && e) || (function() {
        return this
      }()) || Function('return this')()
    }.call(this, t(145))
  }, function(e, t, n) {
    const o = n(10); const i = n(16); const r = n(96); const a = n(18).f; e.exports = function(e) {
      const t = o.Symbol || (o.Symbol = {}); i(t, e) || a(t, e, { value: r.f(e) })
    }
  }, function(e, t) {
    e.exports = {}
  }, function(e, t, n) {
    const o = n(8); const i = n(78); const r = n(16); const a = n(62); const l = n(84); var n = n(106); const u = i('wks'); const s = o.Symbol; const c = n ? s : s && s.withoutSetter || a; e.exports = function(e) {
      return r(u, e) && (l || typeof u[e] === 'string') || (l && r(s, e) ? u[e] = s[e] : u[e] = c(`Symbol.${e}`)), u[e]
    }
  }, function(e, t) {
    e.exports = function(e) {
      try {
        return !!e()
      } catch (e) {
        return !0
      }
    }
  }, function(e, t) {
    e.exports = function(e) {
      return typeof e === 'object' ? e !== null : typeof e === 'function'
    }
  }, function(e, t, n) {
    const o = n(10); e.exports = function(e) {
      return o[`${e}Prototype`]
    }
  }, function(e, t, n) {
    n = n(12); e.exports = !n(() => {
      return Object.defineProperty({}, 1, {
        get: function() {
          return 7
        }
      })[1] != 7
    })
  }, function(e, t, n) {
    const o = n(25); const i = {}.hasOwnProperty; e.exports = function(e, t) {
      return i.call(o(e), t)
    }
  }, function(e, t, n) {
    const o = n(15); const i = n(18); const r = n(37); e.exports = o
      ? function(e, t, n) {
        return i.f(e, t, r(1, n))
      }
      : function(e, t, n) {
        return e[t] = n, e
      }
  }, function(e, t, n) {
    const o = n(15); const i = n(101); const r = n(20); const a = n(60); const l = Object.defineProperty; t.f = o
      ? l
      : function(e, t, n) {
        if (r(e), t = a(t, !0), r(n), i) {
          try {
            return l(e, t, n)
          } catch (e) {}
        } if ('get' in n || 'set' in n) throw TypeError('Accessors not supported'); return 'value' in n && (e[t] = n.value), e
      }
  }, function(e, t, n) {
    e.exports = n(195)
  }, function(e, t, n) {
    const o = n(13); e.exports = function(e) {
      if (!o(e)) throw TypeError(`${String(e)} is not an object`); return e
    }
  }, function(e, t, i) {
    'use strict'; let n; let o; const l = function() {
      return n = void 0 === n ? Boolean(window && document && document.all && !window.atob) : n
    }; const r = (o = {}, function(e) {
      if (void 0 === o[e]) {
        let t = document.querySelector(e); if (window.HTMLIFrameElement && t instanceof window.HTMLIFrameElement) {
          try {
            t = t.contentDocument.head
          } catch (e) {
            t = null
          }
        }o[e] = t
      } return o[e]
    }); const s = []; function c(e) {
      for (var t = -1, n = 0; n < s.length; n++) {
        if (s[n].identifier === e) {
          t = n; break
        }
      } return t
    } function u(e, t) {
      for (var n = {}, o = [], i = 0; i < e.length; i++) {
        let r = e[i]; const a = t.base ? r[0] + t.base : r[0]; let l = n[a] || 0; const u = ''.concat(a, ' ').concat(l); n[a] = l + 1; l = c(u), r = { css: r[1], media: r[2], sourceMap: r[3] }; l !== -1
          ? (s[l].references++, s[l].updater(r))
          : s.push({
            identifier: u,
            updater: (function(t, e) {
              let n; let o; let i; { let r; i = e.singleton
                ? (r = A++, n = h = h || f(e), o = p.bind(null, n, r, !1), p.bind(null, n, r, !0))
                : (n = f(e), o = function(e, t, n) {
                    let o = n.css; const i = n.media; var n = n.sourceMap; i ? e.setAttribute('media', i) : e.removeAttribute('media'); n && typeof btoa !== 'undefined' && (o += '\n/*# sourceMappingURL=data:application/json;base64,'.concat(btoa(unescape(encodeURIComponent(JSON.stringify(n)))), ' */')); if (e.styleSheet)e.styleSheet.cssText = o; else {
                      for (;e.firstChild;)e.removeChild(e.firstChild); e.appendChild(document.createTextNode(o))
                    }
                  }.bind(null, n, e), function() {
                    !(function(e) {
                      if (e.parentNode === null) return; e.parentNode.removeChild(e)
                    }(n))
                  }) } return o(t), function(e) {
                e ? e.css === t.css && e.media === t.media && e.sourceMap === t.sourceMap || o(t = e) : i()
              }
            }(r, t)),
            references: 1
          }), o.push(u)
      } return o
    } function f(e) {
      let t; const n = document.createElement('style'); const o = e.attributes || {}; if (void 0 !== o.nonce || (t = i.nc) && (o.nonce = t), Object.keys(o).forEach((e) => {
        n.setAttribute(e, o[e])
      }), typeof e.insert === 'function')e.insert(n); else {
        e = r(e.insert || 'head'); if (!e) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid."); e.appendChild(n)
      } return n
    } let a; const d = (a = [], function(e, t) {
      return a[e] = t, a.filter(Boolean).join('\n')
    }); function p(e, t, n, o) {
      n = n ? '' : o.media ? '@media '.concat(o.media, ' {').concat(o.css, '}') : o.css; e.styleSheet ? e.styleSheet.cssText = d(t, n) : (o = document.createTextNode(n), (n = e.childNodes)[t] && e.removeChild(n[t]), n.length ? e.insertBefore(o, n[t]) : e.appendChild(o))
    } var h = null; var A = 0; e.exports = function(e, r) {
      (r = r || {}).singleton || typeof r.singleton === 'boolean' || (r.singleton = l()); let a = u(e = e || [], r); return function(e) {
        if (e = e || [], Object.prototype.toString.call(e) === '[object Array]') {
          for (let t = 0; t < a.length; t++) {
            const n = c(a[t]); s[n].references--
          } for (var e = u(e, r), o = 0; o < a.length; o++) {
            const i = c(a[o]); s[i].references === 0 && (s[i].updater(), s.splice(i, 1))
          }a = e
        }
      }
    }
  }, function(e, t, n) {
    'use strict'; e.exports = function(n) {
      const u = []; return u.toString = function() {
        return this.map((e) => {
          const t = (function(e, t) {
            const n = e[1] || ''; const o = e[3]; if (!o) return n; if (t && typeof btoa === 'function') {
              e = (function(e) {
                e = btoa(unescape(encodeURIComponent(JSON.stringify(e)))), e = 'sourceMappingURL=data:application/json;charset=utf-8;base64,'.concat(e); return '/*# '.concat(e, ' */')
              }(o)), t = o.sources.map((e) => {
                return '/*# sourceURL='.concat(o.sourceRoot || '').concat(e, ' */')
              }); return [n].concat(t).concat([e])
                .join('\n')
            } return [n].join('\n')
          }(e, n)); return e[2] ? '@media '.concat(e[2], ' {').concat(t, '}') : t
        }).join('')
      }, u.i = function(e, t, n) {
        typeof e === 'string' && (e = [[null, e, '']]); const o = {}; if (n) {
          for (let i = 0; i < this.length; i++) {
            const r = this[i][0]; r != null && (o[r] = !0)
          }
        } for (let a = 0; a < e.length; a++) {
          const l = [].concat(e[a]); n && o[l[0]] || (t && (l[2] ? l[2] = ''.concat(t, ' and ').concat(l[2]) : l[2] = t), u.push(l))
        }
      }, u
    }
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); let o; var i = n(2); var n = i.__importDefault(n(97)); var i = (o = n.default, i.__extends(r, o), r); function r(e, t) {
      return o.call(this, e, t) || this
    }t.default = i
  }, function(e, t, n) {
    'use strict'; var o = n(0); var i = o(n(1)); const l = o(n(4)); const u = o(n(45)); (0, i.default)(t, '__esModule', { value: !0 }); let s; var o = n(2); const c = o.__importDefault(n(3)); var i = o.__importDefault(n(97)); const f = o.__importDefault(n(133)); var o = (s = i.default, o.__extends(r, s), r); function r(t, n, e) {
      const o = s.call(this, t, n) || this; e.title = n.i18next.t(`menus.dropListMenu.${e.title}`); let i; const r = n.config.lang === 'zh-CN' ? '' : 'w-e-drop-list-tl'; r && e.type === 'list' && (0, l.default)(i = e.list).call(i, (e) => {
        const t = e.$elem; var e = c.default(t.children()); e.length > 0 && ((e = e == null ? void 0 : e.getNodeName()) && e === 'I' && t.addClass(r))
      }); const a = new f.default(o, e); return o.dropList = a, t.on('click', () => {
        let e; n.selection.getRange() != null && (t.css('z-index', n.zIndex.get('menu')), (0, l.default)(e = n.txt.eventHooks.dropListMenuHoverEvents).call(e, (e) => {
          return e()
        }), a.show())
      }).on('mouseleave', () => {
        t.css('z-index', 'auto'), a.hideTimeoutId = (0, u.default)(() => {
          a.hide()
        })
      }), o
    }t.default = o
  }, function(e, t, n) {
    const o = n(48); e.exports = function(e) {
      return Object(o(e))
    }
  }, function(e, t, n) {
    e.exports = n(191)
  }, function(e, t, n) {
    e.exports = n(204)
  }, function(e, t, n) {
    const o = n(75); const i = n(48); e.exports = function(e) {
      return o(i(e))
    }
  }, function(e, t, n) {
    function o(e) {
      return typeof e === 'function' ? e : void 0
    } const i = n(10); const r = n(8); e.exports = function(e, t) {
      return arguments.length < 2 ? o(i[e]) || o(r[e]) : i[e] && i[e][t] || r[e] && r[e][t]
    }
  }, function(e, t, n) {
    const w = n(38); const x = n(75); const _ = n(25); const E = n(34); const b = n(91); const C = [].push; var n = function(d) {
      const p = d == 1; const h = d == 2; const A = d == 3; const v = d == 4; const m = d == 6; const g = d == 7; const y = d == 5 || m; return function(e, t, n, o) {
        for (var i, r, a = _(e), l = x(a), u = w(t, n, 3), s = E(l.length), c = 0, o = o || b, f = p ? o(e, s) : h || g ? o(e, 0) : void 0; c < s; c++) {
          if ((y || c in l) && (r = u(i = l[c], c, a), d)) {
            if (p)f[c] = r; else if (r) {
              switch (d) {
                case 3:return !0; case 5:return i; case 6:return c; case 2:C.call(f, i)
              }
            } else {
              switch (d) {
                case 4:return !1; case 7:C.call(f, i)
              }
            }
          }
        } return m ? -1 : A || v ? v : f
      }
    }; e.exports = { forEach: n(0), map: n(1), filter: n(2), some: n(3), every: n(4), find: n(5), findIndex: n(6), filterOut: n(7) }
  }, function(e, t, n) {
    e.exports = n(290)
  }, function(e, t, n) {
    'use strict'; var o = n(0); const i = o(n(1)); const d = o(n(4)); const p = o(n(31)); var o = o(n(130)); (0, i.default)(t, '__esModule', { value: !0 }); const h = n(2); const A = h.__importDefault(n(3)); const v = n(7); var o = (m.prototype.create = function() {
      let e; let t; let n; let r; let a; let o; let i; let l; let u; let s; const c = this; const f = this.menu; m.createdMenus.has(f) || (i = this.conf, s = this.$container, e = i.width || 300, t = f.editor.$toolbarElem.getBoundingClientRect(), o = f.$elem.getBoundingClientRect(), n = t.height + t.top - o.top, o = (t.width - e) / 2 + t.left - o.left, s.css('width', `${e}px`).css('margin-top', `${n}px`)
        .css('margin-left', `${o}px`)
        .css('z-index', f.editor.zIndex.get('panel')), o = A.default('<i class="w-e-icon-close w-e-panel-close"></i>'), s.append(o), o.on('click', () => {
        c.remove()
      }), r = A.default('<ul class="w-e-panel-tab-title"></ul>'), a = A.default('<div class="w-e-panel-tab-content"></div>'), s.append(r).append(a), (o = i.height) && a.css('height', `${o}px`).css('overflow-y', 'auto'), i = i.tabs || [], l = [], u = [], (0, d.default)(i).call(i, (e, t) => {
        let n; let o; let i; e && (n = e.title || '', e = e.tpl || '', o = A.default(`<li class="w-e-item">${n}</li>`), r.append(o), i = A.default(e), a.append(i), l.push(o), u.push(i), t === 0 ? (o.data('active', !0), o.addClass('w-e-active')) : i.hide(), o.on('click', () => {
          o.data('active') || ((0, d.default)(l).call(l, (e) => {
            e.data('active', !1), e.removeClass('w-e-active')
          }), (0, d.default)(u).call(u, (e) => {
            e.hide()
          }), o.data('active', !0), o.addClass('w-e-active'), i.show())
        }))
      }), s.on('click', (e) => {
        e.stopPropagation()
      }), f.$elem.append(s), (0, d.default)(i).call(i, (e, i) => {
        e && (e = e.events || [], (0, d.default)(e).call(e, (e) => {
          const t = e.selector; const n = e.type; const o = e.fn || v.EMPTY_FN; var e = u[i]; (0, p.default)(e).call(e, t)
            .on(n, (t) => {
              return h.__awaiter(c, void 0, void 0, function() {
                return h.__generator(this, function(e) {
                  switch (e.label) {
                    case 0:return t.stopPropagation(), [4, o(t)]; case 1:return e.sent() && this.remove(), [2]
                  }
                })
              })
            })
        }))
      }), (s = (0, p.default)(s).call(s, 'input[type=text],textarea')).length && s.get(0).focus(), m.hideCurAllPanels(), f.setPanel(this), m.createdMenus.add(f))
    }, m.prototype.remove = function() {
      const e = this.menu; const t = this.$container; t && t.remove(), m.createdMenus.delete(e)
    }, m.hideCurAllPanels = function() {
      let e; m.createdMenus.size !== 0 && (0, d.default)(e = m.createdMenus).call(e, (e) => {
        e = e.panel; e && e.remove()
      })
    }, m.createdMenus = new o.default(), m); function m(e, t) {
      this.menu = e, this.conf = t, this.$container = A.default('<div class="w-e-panel-container"></div>'); e = e.editor; e.txt.eventHooks.clickEvents.push(m.hideCurAllPanels), e.txt.eventHooks.toolbarClickEvents.push(m.hideCurAllPanels), e.txt.eventHooks.dropListMenuHoverEvents.push(m.hideCurAllPanels)
    }t.default = o
  }, function(e, t) {
    e.exports = function(e) {
      if (typeof e !== 'function') throw TypeError(`${String(e)} is not a function`); return e
    }
  }, function(e, t, n) {
    const o = n(64); const i = Math.min; e.exports = function(e) {
      return e > 0 ? i(o(e), 9007199254740991) : 0
    }
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); let o; var i = n(2); var n = i.__importDefault(n(97)); var i = (o = n.default, i.__extends(r, o), r.prototype.setPanel = function(e) {
      this.panel = e
    }, r); function r(e, t) {
      return o.call(this, e, t) || this
    }t.default = i
  }, function(e, t, n) {
    'use strict'; const o = n(0); var i = o(n(1)); const u = o(n(4)); const r = o(n(57)); (0, i.default)(t, '__esModule', { value: !0 }); const f = n(2).__importDefault(n(3)); var i = (a.prototype.getPositionData = function() {
      let e; let t; const n = this.$container; let o = 0; let i = 0; const r = document.documentElement.scrollTop; const a = this.$targetElem.getBoundingClientRect(); const l = this.editor.$textElem.getBoundingClientRect(); let u = this.$targetElem.getOffsetData(); let s = f.default(u.parent); let c = this.editor.$textElem.elems[0].scrollTop; return this._isInsertTextContainer = s.equal(this.editor.$textContainerElem), i = this._isInsertTextContainer ? (e = s.getBoundingClientRect().height, t = u.top, s = u.left, u = u.height, (c = t - c) > 25 ? (o = c - 20 - 15, n.addClass('w-e-tooltip-up')) : (o = c + u + 20 < e ? c + u + 10 : 20 + (c > 0 ? c : 0) + 10, n.addClass('w-e-tooltip-down')), s < 0 ? 0 : s) : (a.top < 20 || a.top - l.top < 20 ? (o = a.bottom + r + 5, n.addClass('w-e-tooltip-down')) : (o = a.top + r - 20 - 15, n.addClass('w-e-tooltip-up')), a.left < 0 ? 0 : a.left), { top: o, left: i }
    }, a.prototype.appendMenus = function() {
      const i = this; const e = this.conf; const r = this.editor; const a = this.$targetElem; const l = this.$container; (0, u.default)(e).call(e, (t, e) => {
        const n = t.$elem; const o = f.default('<div></div>'); o.addClass('w-e-tooltip-item-wrapper '), o.append(n), l.append(o), n.on('click', (e) => {
          e.preventDefault(), t.onClick(r, a) && i.remove()
        })
      })
    }, a.prototype.create = function() {
      let e = this.editor; let t = this.$container; this.appendMenus(); var n = this.getPositionData(); const o = n.top; var n = n.left; t.css('top', `${o}px`), t.css('left', `${n}px`), t.css('z-index', e.zIndex.get('tooltip')), (this._isInsertTextContainer ? this.editor.$textContainerElem : f.default('body')).append(t), this._show = !0, e.beforeDestroy((0, r.default)(t = this.remove).call(t, this)), e.txt.eventHooks.onBlurEvents.push((0, r.default)(e = this.remove).call(e, this))
    }, a.prototype.remove = function() {
      this.$container.remove(), this._show = !1
    }, (0, i.default)(a.prototype, 'isShow', {
      get: function() {
        return this._show
      },
      enumerable: !1,
      configurable: !0
    }), a); function a(e, t, n) {
      this.editor = e, this.$targetElem = t, this.conf = n, this._show = !1, this._isInsertTextContainer = !1; n = f.default('<div></div>'); n.addClass('w-e-tooltip'), this.$container = n
    }t.default = i
  }, function(e, t) {
    e.exports = function(e, t) {
      return { enumerable: !(1 & e), configurable: !(2 & e), writable: !(4 & e), value: t }
    }
  }, function(e, t, n) {
    const r = n(33); e.exports = function(o, i, e) {
      if (r(o), void 0 === i) return o; switch (e) {
        case 0:return function() {
          return o.call(i)
        }; case 1:return function(e) {
          return o.call(i, e)
        }; case 2:return function(e, t) {
          return o.call(i, e, t)
        }; case 3:return function(e, t, n) {
          return o.call(i, e, t, n)
        }
      } return function() {
        return o.apply(i, arguments)
      }
    }
  }, function(e, t) {
    e.exports = !0
  }, function(e, t, n) {
    function v(e, t) {
      this.stopped = e, this.result = t
    } const m = n(20); const g = n(105); const y = n(34); const w = n(38); const x = n(107); const _ = n(108); e.exports = function(e, t, n) {
      function o(e) {
        return r && _(r), new v(!0, e)
      } function i(e) {
        return d ? (m(e), h ? A(e[0], e[1], o) : A(e[0], e[1])) : h ? A(e, o) : A(e)
      } let r; let a; let l; let u; let s; let c; const f = n && n.that; var d = !(!n || !n.AS_ENTRIES); let p = !(!n || !n.IS_ITERATOR); var h = !(!n || !n.INTERRUPTED); var A = w(t, f, 1 + d + h); if (p)r = e; else {
        if (typeof (p = x(e)) !== 'function') throw TypeError('Target is not iterable'); if (g(p)) {
          for (a = 0, l = y(e.length); a < l; a++) if ((u = i(e[a])) && u instanceof v) return u; return new v(!1)
        }r = p.call(e)
      } for (s = r.next; !(c = s.call(r)).done;) {
        try {
          u = i(c.value)
        } catch (e) {
          throw _(r), e
        } if (typeof u === 'object' && u && u instanceof v) return u
      } return new v(!1)
    }
  }, function(e, t) {
    e.exports = {}
  }, function(e, t, n) {
    const i = n(85); const r = n(18).f; const a = n(17); const l = n(16); const u = n(170); const s = n(11)('toStringTag'); e.exports = function(e, t, n, o) {
      e && (e = n ? e : e.prototype, l(e, s) || r(e, s, { configurable: !0, value: t }), o && !i && a(e, 'toString', u))
    }
  }, function(e, t, n) {
    let o; let i; let r; let a; let l; let u; let s; let c; const f = n(174); var d = n(8); const p = n(13); const h = n(17); const A = n(16); const v = n(79); const m = n(61); var n = n(50); const g = 'Object already initialized'; var d = d.WeakMap; s = f
      ? (o = v.state || (v.state = new d()), i = o.get, r = o.has, a = o.set, l = function(e, t) {
          if (r.call(o, e)) throw new TypeError(g); return t.facade = e, a.call(o, e, t), t
        }, u = function(e) {
          return i.call(o, e) || {}
        }, function(e) {
          return r.call(o, e)
        })
      : (n[c = m('state')] = !0, l = function(e, t) {
          if (A(e, c)) throw new TypeError(g); return t.facade = e, h(e, c, t), t
        }, u = function(e) {
          return A(e, c) ? e[c] : {}
        }, function(e) {
          return A(e, c)
        }), e.exports = {
      set: l,
      get: u,
      has: s,
      enforce: function(e) {
        return s(e) ? u(e) : l(e, {})
      },
      getterFor: function(n) {
        return function(e) {
          let t; if (!p(e) || (t = u(e)).type !== n) throw TypeError(`Incompatible receiver, ${n} required`); return t
        }
      }
    }
  }, function(e, t, n) {
    e.exports = n(267)
  }, function(e, t, n) {
    e.exports = n(271)
  }, function(e, t, n) {
    'use strict'; const o = n(0); var i = o(n(1)); const r = o(n(4)); (0, i.default)(t, '__esModule', { value: !0 }), t.createElementFragment = t.createDocumentFragment = t.createElement = t.insertBefore = t.getEndPoint = t.getStartPoint = t.updateRange = t.filterSelectionNodes = void 0; var i = n(2); const a = n(137); const l = i.__importDefault(n(3)); function u(e) {
      return document.createElement(e)
    }t.filterSelectionNodes = function(e) {
      const n = []; return (0, r.default)(e).call(e, (e) => {
        const t = e.getNodeName(); t !== a.ListType.OrderedList && t !== a.ListType.UnorderedList
          ? n.push(e)
          : e.prior
            ? n.push(e.prior)
            : (e = e.children()) != null && (0, r.default)(e).call(e, (e) => {
                n.push(l.default(e))
              })
      }), n
    }, t.updateRange = function(e, t, n) {
      const o = e.selection; var e = document.createRange(); t.length > 1 ? (e.setStart(t.elems[0], 0), e.setEnd(t.elems[t.length - 1], t.elems[t.length - 1].childNodes.length)) : e.selectNodeContents(t.elems[0]), n && e.collapse(!1), o.saveRange(e), o.restoreSelection()
    }, t.getStartPoint = function(e) {
      return e.prior || l.default((e = e.children()) === null || void 0 === e ? void 0 : e.elems[0])
    }, t.getEndPoint = function(e) {
      return e.prior || l.default((e = e.children()) === null || void 0 === e ? void 0 : e.last().elems[0])
    }, t.insertBefore = function(e, t, n) {
      void 0 === n && (n = null), e.parent().elems[0].insertBefore(t, n)
    }, t.createElement = u, t.createDocumentFragment = function() {
      return document.createDocumentFragment()
    }, t.createElementFragment = function(e, n, o) {
      return void 0 === o && (o = 'li'), (0, r.default)(e).call(e, (e) => {
        const t = u(o); t.innerHTML = e.html(), n.append(t), e.remove()
      }), n
    }
  }, function(e, t) {
    const n = {}.toString; e.exports = function(e) {
      return n.call(e).slice(8, -1)
    }
  }, function(e, t) {
    e.exports = function(e) {
      if (e == null) throw TypeError(`Can't call method on ${e}`); return e
    }
  }, function(e, t, n) {
    const o = n(103); const i = n(83); e.exports = Object.keys || function(e) {
      return o(e, i)
    }
  }, function(e, t) {
    e.exports = {}
  }, function(e, t, n) {
    const i = n(17); e.exports = function(e, t, n, o) {
      o && o.enumerable ? e[t] = n : i(e, t, n)
    }
  }, function(e, t, n) {
    'use strict'; const o = n(179).charAt; const i = n(43); var n = n(89); const r = 'String Iterator'; const a = i.set; const l = i.getterFor(r); n(String, 'String', function(e) {
      a(this, { type: r, string: String(e), index: 0 })
    }, function() {
      const e = l(this); const t = e.string; let n = e.index; return n >= t.length ? { value: void 0, done: !0 } : (n = o(t, n), e.index += n.length, { value: n, done: !1 })
    })
  }, function(e, t, n) {
    n(181); let o; const i = n(182); const r = n(8); const a = n(67); const l = n(17); const u = n(41); const s = n(11)('toStringTag'); for (o in i) {
      var c = r[o]; var c = c && c.prototype; c && a(c) !== s && l(c, s, o), u[o] = u.Array
    }
  }, function(e, t, n) {
    const o = n(47); e.exports = Array.isArray || function(e) {
      return o(e) == 'Array'
    }
  }, function(e, t, n) {
    const o = n(12); const i = n(11); const r = n(65); const a = i('species'); e.exports = function(t) {
      return r >= 51 || !o(() => {
        const e = []; return (e.constructor = {})[a] = function() {
          return { foo: 1 }
        }, e[t](Boolean).foo !== 1
      })
    }
  }, function(e, t, n) {
    e.exports = n(216)
  }, function(e, t, n) {
    e.exports = n(225)
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }), t.ListHandle = void 0; const o = n(2).__importDefault(n(379)); t.ListHandle = function(e) {
      this.options = e, this.selectionRangeElem = new o.default()
    }
  }, function(e, t, n) {
    'use strict'; const o = {}.propertyIsEnumerable; const i = Object.getOwnPropertyDescriptor; const r = i && !o.call({ 1: 2 }, 1); t.f = r
      ? function(e) {
        e = i(this, e); return !!e && e.enumerable
      }
      : o
  }, function(e, t, n) {
    const i = n(13); e.exports = function(e, t) {
      if (!i(e)) return e; let n; let o; if (t && typeof (n = e.toString) === 'function' && !i(o = n.call(e))) return o; if (typeof (n = e.valueOf) === 'function' && !i(o = n.call(e))) return o; if (!t && typeof (n = e.toString) === 'function' && !i(o = n.call(e))) return o; throw TypeError("Can't convert object to primitive value")
    }
  }, function(e, t, n) {
    const o = n(78); const i = n(62); const r = o('keys'); e.exports = function(e) {
      return r[e] || (r[e] = i(e))
    }
  }, function(e, t) {
    let n = 0; const o = Math.random(); e.exports = function(e) {
      return `Symbol(${String(void 0 === e ? '' : e)})_${(++n + o).toString(36)}`
    }
  }, function(e, t, n) {
    function o() {} function i(e) {
      return `<script>${e}</${p}>`
    } let r; const a = n(20); const l = n(168); const u = n(83); const s = n(50); const c = n(104); const f = n(76); var n = n(61); const d = 'prototype'; var p = 'script'; const h = n('IE_PROTO'); var A = function() {
      try {
        r = document.domain && new ActiveXObject('htmlfile')
      } catch (e) {} let e; A = r
        ? (function(e) {
            e.write(i('')), e.close(); const t = e.parentWindow.Object; return e = null, t
          }(r))
        : ((e = f('iframe')).style.display = 'none', c.appendChild(e), e.src = String('javascript:'), (e = e.contentWindow.document).open(), e.write(i('document.F=Object')), e.close(), e.F); for (let t = u.length; t--;) delete A[d][u[t]]; return A()
    }; s[h] = !0, e.exports = Object.create || function(e, t) {
      let n; return e !== null ? (o[d] = a(e), n = new o(), o[d] = null, n[h] = e) : n = A(), void 0 === t ? n : l(n, t)
    }
  }, function(e, t) {
    const n = Math.ceil; const o = Math.floor; e.exports = function(e) {
      return isNaN(e = +e) ? 0 : (e > 0 ? o : n)(e)
    }
  }, function(e, t, n) {
    let o; let i; var r = n(8); var n = n(66); var r = r.process; var r = r && r.versions; var r = r && r.v8; r ? i = (o = r.split('.'))[0] < 4 ? 1 : o[0] + o[1] : n && (!(o = n.match(/Edge\/(\d+)/)) || o[1] >= 74) && (o = n.match(/Chrome\/(\d+)/)) && (i = o[1]), e.exports = i && +i
  }, function(e, t, n) {
    n = n(29); e.exports = n('navigator', 'userAgent') || ''
  }, function(e, t, n) {
    const o = n(85); const i = n(47); const r = n(11)('toStringTag'); const a = i(function() {
      return arguments
    }()) == 'Arguments'; e.exports = o
      ? i
      : function(e) {
        let t; return void 0 === e
          ? 'Undefined'
          : e === null
            ? 'Null'
            : typeof (e = (function(e, t) {
              try {
                return e[t]
              } catch (e) {}
            }(t = Object(e), r))) === 'string'
              ? e
              : a ? i(t) : (e = i(t)) == 'Object' && typeof t.callee === 'function' ? 'Arguments' : e
      }
  }, function(e, t) {}, function(e, t, n) {
    'use strict'; function o(e) {
      let n; let o; this.promise = new e((e, t) => {
        if (void 0 !== n || void 0 !== o) throw TypeError('Bad Promise constructor'); n = e, o = t
      }), this.resolve = i(n), this.reject = i(o)
    } var i = n(33); e.exports.f = function(e) {
      return new o(e)
    }
  }, function(e, t, n) {
    'use strict'; const o = n(12); e.exports = function(e, t) {
      const n = [][e]; return !!n && o(() => {
        n.call(null, t || (() => {
          throw 1
        }), 1)
      })
    }
  }, function(e, t) {
    e.exports = '\t\n\v\f\r                　\u2028\u2029\ufeff'
  }, function(e, t, n) {
    'use strict'; const o = n(60); const i = n(18); const r = n(37); e.exports = function(e, t, n) {
      t = o(t); t in e ? i.f(e, t, r(0, n)) : e[t] = n
    }
  }, function(e, t, n) {
    e.exports = n(212)
  }, function(e, t, n) {
    const o = n(15); const i = n(59); const r = n(37); const a = n(28); const l = n(60); const u = n(16); const s = n(101); const c = Object.getOwnPropertyDescriptor; t.f = o
      ? c
      : function(e, t) {
        if (e = a(e), t = l(t, !0), s) {
          try {
            return c(e, t)
          } catch (e) {}
        } if (u(e, t)) return r(!i.f.call(e, t), e[t])
      }
  }, function(e, t, n) {
    const o = n(12); const i = n(47); const r = ''.split; e.exports = o(() => {
      return !Object('z').propertyIsEnumerable(0)
    })
      ? function(e) {
        return i(e) == 'String' ? r.call(e, '') : Object(e)
      }
      : Object
  }, function(e, t, n) {
    const o = n(8); var n = n(13); const i = o.document; const r = n(i) && n(i.createElement); e.exports = function(e) {
      return r ? i.createElement(e) : {}
    }
  }, function(e, t, n) {
    const o = n(16); const i = n(25); const r = n(61); var n = n(166); const a = r('IE_PROTO'); const l = Object.prototype; e.exports = n
      ? Object.getPrototypeOf
      : function(e) {
        return e = i(e), o(e, a) ? e[a] : typeof e.constructor === 'function' && e instanceof e.constructor ? e.constructor.prototype : e instanceof Object ? l : null
      }
  }, function(e, t, n) {
    const o = n(39); const i = n(79); (e.exports = function(e, t) {
      return i[e] || (i[e] = void 0 !== t ? t : {})
    })('versions', []).push({ version: '3.12.0', mode: o ? 'pure' : 'global', copyright: '© 2021 Denis Pushkarev (zloirock.ru)' })
  }, function(e, t, n) {
    const o = n(8); const i = n(165); var n = '__core-js_shared__'; var n = o[n] || i(n, {}); e.exports = n
  }, function(e, t, n) {
    const i = n(20); const r = n(167); e.exports = Object.setPrototypeOf || ('__proto__' in {}
      ? (function() {
          let n; let o = !1; const e = {}; try {
            (n = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set).call(e, []), o = e instanceof Array
          } catch (e) {} return function(e, t) {
            return i(e), r(t), o ? n.call(e, t) : e.__proto__ = t, e
          }
        }())
      : void 0)
  }, function(e, t, n) {
    const u = n(28); const s = n(34); const c = n(82); var n = function(l) {
      return function(e, t, n) {
        let o; const i = u(e); const r = s(i.length); let a = c(n, r); if (l && t != t) {
          for (;a < r;) if ((o = i[a++]) != o) return !0
        } else for (;a < r; a++) if ((l || a in i) && i[a] === t) return l || a || 0; return !l && -1
      }
    }; e.exports = { includes: n(!0), indexOf: n(!1) }
  }, function(e, t, n) {
    const o = n(64); const i = Math.max; const r = Math.min; e.exports = function(e, t) {
      e = o(e); return e < 0 ? i(e + t, 0) : r(e, t)
    }
  }, function(e, t) {
    e.exports = ['constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toLocaleString', 'toString', 'valueOf']
  }, function(e, t, n) {
    const o = n(65); var n = n(12); e.exports = !!Object.getOwnPropertySymbols && !n(() => {
      return !String(Symbol()) || !Symbol.sham && o && o < 41
    })
  }, function(e, t, n) {
    const o = {}; o[n(11)('toStringTag')] = 'z', e.exports = String(o) === '[object z]'
  }, function(e, t) {
    e.exports = function(e, t, n) {
      if (!(e instanceof t)) throw TypeError(`Incorrect ${n ? `${n} ` : ''}invocation`); return e
    }
  }, function(e, t, n) {
    const o = n(47); var n = n(8); e.exports = o(n.process) == 'process'
  }, function(e, t) {
    e.exports = function(e) {
      try {
        return { error: !1, value: e() }
      } catch (e) {
        return { error: !0, value: e }
      }
    }
  }, function(e, t, n) {
    'use strict'; function A() {
      return this
    } const v = n(5); const m = n(180); const g = n(77); const y = n(80); const w = n(42); const x = n(17); const _ = n(51); const o = n(11); const E = n(39); const b = n(41); var n = n(118); const C = n.IteratorPrototype; const S = n.BUGGY_SAFARI_ITERATORS; const D = o('iterator'); const M = 'values'; const N = 'entries'; e.exports = function(e, t, n, o, i, r, a) {
      m(n, t, o); function l(e) {
        if (e === i && h) return h; if (!S && e in d) return d[e]; switch (e) {
          case 'keys':case M:case N:return function() {
            return new n(this, e)
          }
        } return function() {
          return new n(this)
        }
      } let u; let s; const c = `${t} Iterator`; let f = !1; var d = e.prototype; const p = d[D] || d['@@iterator'] || i && d[i]; var h = !S && p || l(i); var o = t == 'Array' && d.entries || p; if (o && (e = g(o.call(new e())), C !== Object.prototype && e.next && (E || g(e) === C || (y ? y(e, C) : typeof e[D] !== 'function' && x(e, D, A)), w(e, c, !0, !0), E && (b[c] = A))), i == M && p && p.name !== M && (f = !0, h = function() {
        return p.call(this)
      }), E && !a || d[D] === h || x(d, D, h), b[t] = h, i) if (u = { values: l(M), keys: r ? h : l('keys'), entries: l(N) }, a) for (s in u)!S && !f && s in d || _(d, s, u[s]); else v({ target: t, proto: !0, forced: S || f }, u); return u
    }
  }, function(e, t) {
    e.exports = function() {}
  }, function(e, t, n) {
    const o = n(13); const i = n(54); const r = n(11)('species'); e.exports = function(e, t) {
      let n; return new (void 0 === (n = i(e) && (typeof (n = e.constructor) === 'function' && (n === Array || i(n.prototype)) || o(n) && (n = n[r]) === null) ? void 0 : n) ? Array : n)(t === 0 ? 0 : t)
    }
  }, function(e, t, n) {
    e.exports = n(188)
  }, function(e, t, n) {
    const o = n(48); var n = `[${n(71)}]`; const i = RegExp(`^${n}${n}*`); const r = RegExp(`${n + n}*$`); var n = function(t) {
      return function(e) {
        e = String(o(e)); return 1 & t && (e = e.replace(i, '')), e = 2 & t ? e.replace(r, '') : e
      }
    }; e.exports = { start: n(1), end: n(2), trim: n(3) }
  }, function(e, t, n) {
    e.exports = n(208)
  }, function(t, e, n) {
    const o = n(230); const i = n(259); function r(e) {
      return t.exports = r = typeof o === 'function' && typeof i === 'symbol'
        ? function(e) {
          return typeof e
        }
        : function(e) {
          return e && typeof o === 'function' && e.constructor === o && e !== o.prototype ? 'symbol' : typeof e
        }, t.exports.default = t.exports, t.exports.__esModule = !0, r(e)
    }t.exports = r, t.exports.default = t.exports, t.exports.__esModule = !0
  }, function(e, t, n) {
    n = n(11); t.f = n
  }, function(e, t, n) {
    'use strict'; const o = n(0); var i = o(n(1)); const r = o(n(4)); (0, i.default)(t, '__esModule', { value: !0 }); const a = n(2).__importDefault(n(32)); var i = (l.prototype.clickHandler = function(e) {}, l.prototype.active = function() {
      this._active = !0, this.$elem.addClass('w-e-active')
    }, l.prototype.unActive = function() {
      this._active = !1, this.$elem.removeClass('w-e-active')
    }, (0, i.default)(l.prototype, 'isActive', {
      get: function() {
        return this._active
      },
      enumerable: !1,
      configurable: !0
    }), l); function l(e, n) {
      const o = this; this.$elem = e, this.editor = n, this._active = !1, e.on('click', (e) => {
        let t; a.default.hideCurAllPanels(), (0, r.default)(t = n.txt.eventHooks.menuClickEvents).call(t, (e) => {
          return e()
        }), e.stopPropagation(), n.selection.getRange() != null && o.clickHandler(e)
      })
    }t.default = i
  }, function(e, t, n) {
    'use strict'; const o = n(0); var i = o(n(1)); const _ = o(n(57)); const E = o(n(4)); const b = o(n(27)); (0, i.default)(t, '__esModule', { value: !0 }); var i = n(2); const C = n(6); const S = i.__importDefault(n(135)); const D = i.__importDefault(n(136)); var n = (r.prototype.insertImg = function(e, t, n) {
      function o(e, t) {
        return i.i18next.t((t = void 0 === t ? 'validate.' : t) + e)
      } var i = this.editor; const r = i.config; const a = t ? `alt="${t}" ` : ''; const l = n ? `data-href="${encodeURIComponent(n)}" ` : ''; i.cmd.do('insertHTML', `<img src="${e}" ${a}${l}style="max-width:100%;" contenteditable="false"/>`), r.linkImgCallback(e, t, n); let u = document.createElement('img'); u.onload = function() {
        u = null
      }, u.onerror = function() {
        r.customAlert(o('插入图片错误'), 'error', `wangEditor: ${o('插入图片错误')}，${o('图片链接')} "${e}"，${o('下载链接失败')}`), u = null
      }, u.onabort = function() {
        return u = null
      }, u.src = e
    }, r.prototype.uploadImg = function(e) {
      let i; let o; let r; let t; let a; let l; let n; let u; let s; let c; let f; let d; let p; let h; let A; let v; let m; let g; let y; let w; const x = this; e.length && (i = this.editor, o = i.config, r = function(e) {
        return i.i18next.t(`validate.${e}`)
      }, g = o.uploadImgServer, t = o.uploadImgShowBase64, a = o.uploadImgMaxSize, l = a / 1024 / 1024, n = o.uploadImgMaxLength, u = o.uploadFileName, s = o.uploadImgParams, c = o.uploadImgParamsWithUrl, f = o.uploadImgHeaders, d = o.uploadImgHooks, p = o.uploadImgTimeout, w = o.withCredentials, ((h = o.customUploadImg) || g || t) && (A = [], v = [], C.arrForEach(e, (e) => {
        let t; const n = e.name || e.type.replace('/', '.'); const o = e.size; n && o && (t = i.config.uploadImgAccept.join('|'), !1 !== new RegExp(`.(${t})$`, 'i').test(n) ? a < o ? v.push(`【${n}】${r('大于')} ${l}M`) : A.push(e) : v.push(`【${n}】${r('不是图片')}`))
      }), v.length
        ? o.customAlert(`${r('图片验证未通过')}: \n${v.join('\n')}`, 'warning')
        : A.length !== 0
          ? A.length > n
            ? o.customAlert(r('一次最多上传') + n + r('张图片'), 'warning')
            : h && typeof h === 'function'
              ? h(A, (0, _.default)(y = this.insertImg).call(y, this))
              : (m = new FormData(), (0, E.default)(A).call(A, (e, t) => {
                  let n = u || e.name; A.length > 1 && (n += t + 1), m.append(n, e)
                }), g
                  ? (g = (y = g.split('#'))[0], y = y[1] || '', (0, E.default)(C).call(C, s, (e, t) => {
                      c && ((0, b.default)(g).call(g, '?') > 0 ? g += '&' : g += '?', g = `${g + e}=${t}`), m.append(e, t)
                    }), y && (g += `#${y}`), typeof (w = S.default(g, {
                      timeout: p,
                      formData: m,
                      headers: f,
                      withCredentials: !!w,
                      beforeSend: function(e) {
                        if (d.before) return d.before(e, i, A)
                      },
                      onTimeout: function(e) {
                        o.customAlert(r('上传图片超时'), 'error'), d.timeout && d.timeout(e, i)
                      },
                      onProgress: function(e, t) {
                        const n = new D.default(i); t.lengthComputable && (e = t.loaded / t.total, n.show(e))
                      },
                      onError: function(e) {
                        o.customAlert(r('上传图片错误'), 'error', `${r('上传图片错误')}，${r('服务器返回状态')}: ${e.status}`), d.error && d.error(e, i)
                      },
                      onFail: function(e, t) {
                        o.customAlert(r('上传图片失败'), 'error', `${r('上传图片返回结果错误')}，${r('返回结果')}` + `: ${t}`), d.fail && d.fail(e, i, t)
                      },
                      onSuccess: function(e, t) {
                        if (d.customInsert)d.customInsert((0, _.default)(n = x.insertImg).call(n, x), t, i); else {
                          if (t.errno != '0') return o.customAlert(r('上传图片失败'), 'error', `${r('上传图片返回结果错误')}，${r('返回结果')} errno=${t.errno}`), void (d.fail && d.fail(e, i, t)); var n = t.data; (0, E.default)(n).call(n, (e) => {
                            typeof e === 'string' ? x.insertImg(e) : x.insertImg(e.url, e.alt, e.href)
                          }), d.success && d.success(e, i, t)
                        }
                      }
                    })) === 'string' && o.customAlert(w, 'error'))
                  : t && C.arrForEach(e, (e) => {
                    const t = x; const n = new FileReader(); n.readAsDataURL(e), n.onload = function() {
                      let e; this.result && (e = this.result.toString(), t.insertImg(e, e))
                    }
                  }))
          : o.customAlert(r('传入的文件不合法'), 'warning')))
    }, r); function r(e) {
      this.editor = e
    }t.default = n
  }, function(e, t, n) {
    'use strict'; const o = n(0); const i = o(n(1)); const r = o(n(417)); const u = o(n(4)); const a = o(n(44)); function l(e) {
      return !!e.length && e.attr('class') === 'w-e-todo'
    } function s(e, t) {
      return e.nodeType === 3 ? e.nodeValue === t.nodeValue : e.contains(t)
    } function c(e, t, n) {
      void 0 === n && (n = !0); let o = e.nodeValue; let i = o == null ? void 0 : (0, a.default)(o).call(o, 0, t); return o = o == null ? void 0 : (0, a.default)(o).call(o, t), n || (n = o, o = i, i = n), e.nodeValue = i, o
    }(0, i.default)(t, '__esModule', { value: !0 }), t.dealTextNode = t.isAllTodo = t.isTodo = t.getCursorNextNode = void 0, t.isTodo = l, t.isAllTodo = function(e) {
      if ((e = e.selection.getSelectionRangeTopNodes()).length !== 0) return (0, r.default)(e).call(e, l)
    }, t.getCursorNextNode = function n(e, o, i) {
      if (e.hasChildNodes()) {
        const r = e.cloneNode(); let a = !1; o.nodeValue === '' && (a = !0); const l = []; return (0, u.default)(e = e.childNodes).call(e, (e) => {
          let t; !s(e, o) && a && (r.appendChild(e.cloneNode(!0)), e.nodeName !== 'BR' && l.push(e)), s(e, o) && (e.nodeType !== 1 || (t = n(e, o, i)) && t.textContent !== '' && r != null && r.appendChild(t), e.nodeType === 3 && o.isEqualNode(e) && (e = c(e, i), r.textContent = e), a = !0)
        }), (0, u.default)(l).call(l, (e) => {
          e.remove()
        }), r
      }
    }, t.dealTextNode = c
  }, function(e, t, n) {
    'use strict'; var o = n(0)(n(1)); (0, o.default)(t, '__esModule', { value: !0 }); const i = n(437); var o = ((0, o.default)(r.prototype, 'size', {
      get: function() {
        return [this.data.size, this.revokeData.size]
      },
      enumerable: !1,
      configurable: !0
    }), r.prototype.resetMaxSize = function(e) {
      this.data.resetMax(e), this.revokeData.resetMax(e)
    }, r.prototype.save = function(e) {
      return this.isRe && (this.revokeData.clear(), this.isRe = !1), this.data.instack(e), this
    }, r.prototype.revoke = function(e) {
      this.isRe || (this.isRe = !0); const t = this.data.outstack(); return !!t && (this.revokeData.instack(t), e(t), !0)
    }, r.prototype.restore = function(e) {
      this.isRe || (this.isRe = !0); const t = this.revokeData.outstack(); return !!t && (this.data.instack(t), e(t), !0)
    }, r); function r(e) {
      this.maxSize = e, this.isRe = !1, this.data = new i.CeilStack(e), this.revokeData = new i.CeilStack(e)
    }t.default = o
  }, function(e, t, n) {
    const o = n(15); const i = n(12); const r = n(76); e.exports = !o && !i(() => {
      return Object.defineProperty(r('div'), 'a', {
        get: function() {
          return 7
        }
      }).a != 7
    })
  }, function(e, t, n) {
    const o = n(12); const i = /#|\.prototype\./; var n = function(e, t) {
      e = a[r(e)]; return e == u || e != l && (typeof t === 'function' ? o(t) : !!t)
    }; var r = n.normalize = function(e) {
      return String(e).replace(i, '.')
        .toLowerCase()
    }; var a = n.data = {}; var l = n.NATIVE = 'N'; var u = n.POLYFILL = 'P'; e.exports = n
  }, function(e, t, n) {
    const a = n(16); const l = n(28); const u = n(81).indexOf; const s = n(50); e.exports = function(e, t) {
      let n; const o = l(e); let i = 0; const r = []; for (n in o)!a(s, n) && a(o, n) && r.push(n); for (;t.length > i;)a(o, n = t[i++]) && (~u(r, n) || r.push(n)); return r
    }
  }, function(e, t, n) {
    n = n(29); e.exports = n('document', 'documentElement')
  }, function(e, t, n) {
    const o = n(11); const i = n(41); const r = o('iterator'); const a = Array.prototype; e.exports = function(e) {
      return void 0 !== e && (i.Array === e || a[r] === e)
    }
  }, function(e, t, n) {
    n = n(84); e.exports = n && !Symbol.sham && typeof Symbol.iterator === 'symbol'
  }, function(e, t, n) {
    const o = n(67); const i = n(41); const r = n(11)('iterator'); e.exports = function(e) {
      if (e != null) return e[r] || e['@@iterator'] || i[o(e)]
    }
  }, function(e, t, n) {
    const o = n(20); e.exports = function(e) {
      const t = e.return; if (void 0 !== t) return o(t.call(e)).value
    }
  }, function(e, t, n) {
    n = n(8); e.exports = n.Promise
  }, function(e, t, n) {
    const i = n(51); e.exports = function(e, t, n) {
      for (const o in t)n && n.unsafe && e[o] ? e[o] = t[o] : i(e, o, t[o], n); return e
    }
  }, function(e, t, n) {
    'use strict'; const o = n(29); const i = n(18); const r = n(11); const a = n(15); const l = r('species'); e.exports = function(e) {
      const t = o(e); var e = i.f; a && t && !t[l] && e(t, l, {
        configurable: !0,
        get: function() {
          return this
        }
      })
    }
  }, function(e, t, n) {
    var n = n(79); const o = Function.toString; typeof n.inspectSource !== 'function' && (n.inspectSource = function(e) {
      return o.call(e)
    }), e.exports = n.inspectSource
  }, function(e, t, n) {
    const i = n(11)('iterator'); let r = !1; try {
      let o = 0; const a = {
        next: function() {
          return { done: !!o++ }
        },
        return: function() {
          r = !0
        }
      }; a[i] = function() {
        return this
      }, Array.from(a, () => {
        throw 2
      })
    } catch (e) {}e.exports = function(e, t) {
      if (!t && !r) return !1; let n = !1; try {
        const o = {}; o[i] = function() {
          return {
            next: function() {
              return { done: n = !0 }
            }
          }
        }, e(o)
      } catch (e) {} return n
    }
  }, function(e, t, n) {
    const o = n(20); const i = n(33); const r = n(11)('species'); e.exports = function(e, t) {
      let n; var e = o(e).constructor; return void 0 === e || (n = o(e)[r]) == null ? t : i(n)
    }
  }, function(e, t, n) {
    function o(e) {
      let t; x.hasOwnProperty(e) && (t = x[e], delete x[e], t())
    } function i(e) {
      return function() {
        o(e)
      }
    } function r(e) {
      o(e.data)
    } let a; const l = n(8); const u = n(12); const s = n(38); const c = n(104); const f = n(76); let d = n(116); const p = n(87); const h = l.location; let A = l.setImmediate; let v = l.clearImmediate; const m = l.process; let g = l.MessageChannel; const y = l.Dispatch; let w = 0; var x = {}; const _ = 'onreadystatechange'; var n = function(e) {
      l.postMessage(`${e}`, `${h.protocol}//${h.host}`)
    }; A && v || (A = function(e) {
      for (var t = [], n = 1; n < arguments.length;)t.push(arguments[n++]); return x[++w] = function() {
        (typeof e === 'function' ? e : Function(e)).apply(void 0, t)
      }, a(w), w
    }, v = function(e) {
      delete x[e]
    }, p
      ? a = function(e) {
        m.nextTick(i(e))
      }
      : y && y.now
        ? a = function(e) {
          y.now(i(e))
        }
        : g && !d
          ? (g = (d = new g()).port2, d.port1.onmessage = r, a = s(g.postMessage, g, 1))
          : l.addEventListener && typeof postMessage === 'function' && !l.importScripts && h && h.protocol !== 'file:' && !u(n)
            ? (a = n, l.addEventListener('message', r, !1))
            : a = _ in f('script')
              ? function(e) {
                c.appendChild(f('script'))[_] = function() {
                  c.removeChild(this), o(e)
                }
              }
              : function(e) {
                setTimeout(i(e), 0)
              }), e.exports = { set: A, clear: v }
  }, function(e, t, n) {
    n = n(66); e.exports = /(?:iphone|ipod|ipad).*applewebkit/i.test(n)
  }, function(e, t, n) {
    const o = n(20); const i = n(13); const r = n(69); e.exports = function(e, t) {
      if (o(e), i(t) && t.constructor === e) return t; e = r.f(e); return (0, e.resolve)(t), e.promise
    }
  }, function(e, t, n) {
    'use strict'; let o; let i = n(12); const r = n(77); const a = n(17); const l = n(16); let u = n(11); const s = n(39); const c = u('iterator'); var n = !1; [].keys && ('next' in (u = [].keys()) ? (u = r(r(u))) !== Object.prototype && (o = u) : n = !0); i = o == null || i(() => {
      const e = {}; return o[c].call(e) !== e
    }); i && (o = {}), s && !i || l(o, c) || a(o, c, function() {
      return this
    }), e.exports = { IteratorPrototype: o, BUGGY_SAFARI_ITERATORS: n }
  }, function(e, t, n) {
    'use strict'; var o = n(0); var i = o(n(1)); const r = o(n(4)); (0, i.default)(t, '__esModule', { value: !0 }); const a = n(2); const l = a.__importDefault(n(3)); const u = n(6); const s = a.__importDefault(n(273)); const c = a.__importDefault(n(287)); const f = a.__importDefault(n(288)); const d = a.__importDefault(n(289)); const p = a.__importDefault(n(308)); const h = a.__importStar(n(423)); const A = a.__importDefault(n(424)); const v = a.__importDefault(n(425)); const m = a.__importDefault(n(426)); const g = a.__importStar(n(427)); const y = a.__importDefault(n(430)); const w = a.__importDefault(n(431)); const x = a.__importDefault(n(432)); const _ = a.__importDefault(n(434)); const E = a.__importDefault(n(444)); const b = a.__importDefault(n(23)); const C = a.__importDefault(n(133)); const S = a.__importDefault(n(24)); var o = a.__importDefault(n(32)); var i = a.__importDefault(n(35)); var n = a.__importDefault(n(36)); let D = 1; var n = (M.prototype.initSelection = function(e) {
      A.default(this, e)
    }, M.prototype.create = function() {
      this.zIndex.init(this), this.isCompatibleMode = this.config.compatibleMode(), this.isCompatibleMode || (this.config.onchangeTimeout = 30), m.default(this), h.default(this), this.txt.init(), this.menus.init(), g.default(this), this.initSelection(!0), v.default(this), this.change.observe(), this.history.observe()
    }, M.prototype.beforeDestroy = function(e) {
      return this.beforeDestroyHooks.push(e), this
    }, M.prototype.destroy = function() {
      let e; const t = this; (0, r.default)(e = this.beforeDestroyHooks).call(e, (e) => {
        return e.call(t)
      }), this.$toolbarElem.remove(), this.$textContainerElem.remove()
    }, M.prototype.fullScreen = function() {
      g.setFullScreen(this)
    }, M.prototype.unFullScreen = function() {
      g.setUnFullScreen(this)
    }, M.prototype.scrollToHead = function(e) {
      y.default(this, e)
    }, M.registerMenu = function(e, t) {
      t && typeof t === 'function' && (M.globalCustomMenuConstructorList[e] = t)
    }, M.$ = l.default, M.BtnMenu = b.default, M.DropList = C.default, M.DropListMenu = S.default, M.Panel = o.default, M.PanelMenu = i.default, M.Tooltip = n.default, M.globalCustomMenuConstructorList = {}, M); function M(e, t) {
      this.beforeDestroyHooks = [], this.id = `wangEditor-${D++}`, this.toolbarSelector = e, this.textSelector = t, h.selectorValidator(this), this.config = u.deepClone(s.default), this.$toolbarElem = l.default('<div></div>'), this.$textContainerElem = l.default('<div></div>'), this.$textElem = l.default('<div></div>'), this.toolbarElemId = '', this.textElemId = '', this.isFocus = !1, this.isComposing = !1, this.isCompatibleMode = !1, this.selection = new c.default(this), this.cmd = new f.default(this), this.txt = new d.default(this), this.menus = new p.default(this), this.zIndex = new w.default(), this.change = new x.default(this), this.history = new _.default(this); e = E.default(this), t = e.disable, e = e.enable; this.disable = t, this.enable = e
    }t.default = n
  }, function(e, t, n) {
    e.exports = n(200)
  }, function(e, t, n) {
    'use strict'; const f = n(5); const d = n(8); const p = n(122); const h = n(12); const A = n(17); const v = n(40); const m = n(86); const g = n(13); const y = n(42); const w = n(18).f; const x = n(30).forEach; const _ = n(15); var n = n(43); const E = n.set; const b = n.getterFor; e.exports = function(n, e, t) {
      let r; let a; const o = n.indexOf('Map') !== -1; const l = n.indexOf('Weak') !== -1; const i = o ? 'set' : 'add'; const u = d[n]; const s = u && u.prototype; const c = {}; return _ && typeof u === 'function' && (l || s.forEach && !h(() => {
        (new u()).entries()
          .next()
      }))
        ? (r = e((e, t) => {
            E(m(e, r, n), { type: n, collection: new u() }), t != null && v(t, e[i], { that: e, AS_ENTRIES: o })
          }), a = b(n), x(['add', 'clear', 'delete', 'forEach', 'get', 'has', 'set', 'keys', 'values', 'entries'], (o) => {
            const i = o == 'add' || o == 'set'; o in s && (!l || o != 'clear') && A(r.prototype, o, function(e, t) {
              const n = a(this).collection; if (!i && l && !g(e)) return o == 'get' && void 0; t = n[o](e === 0 ? 0 : e, t); return i ? this : t
            })
          }), l || w(r.prototype, 'size', {
            configurable: !0,
            get: function() {
              return a(this).collection.size
            }
          }))
        : (r = t.getConstructor(e, n, o, i), p.REQUIRED = !0), y(r, n, !1, !0), c[n] = r, f({ global: !0, forced: !0 }, c), l || t.setStrong(r, n, o), r
    }
  }, function(e, t, n) {
    function o(e) {
      l(e, c, { value: { objectID: `O${++f}`, weakData: {} } })
    } const i = n(50); const r = n(13); const a = n(16); var l = n(18).f; const u = n(62); const s = n(203); var c = u('meta'); var f = 0; const d = Object.isExtensible || function() {
      return !0
    }; var p = e.exports = {
      REQUIRED: !1,
      fastKey: function(e, t) {
        if (!r(e)) return typeof e === 'symbol' ? e : (typeof e === 'string' ? 'S' : 'P') + e; if (!a(e, c)) {
          if (!d(e)) return 'F'; if (!t) return 'E'; o(e)
        } return e[c].objectID
      },
      getWeakData: function(e, t) {
        if (!a(e, c)) {
          if (!d(e)) return !0; if (!t) return !1; o(e)
        } return e[c].weakData
      },
      onFreeze: function(e) {
        return s && p.REQUIRED && d(e) && !a(e, c) && o(e), e
      }
    }; i[c] = !0
  }, function(e, t, n) {
    'use strict'; const s = n(18).f; const c = n(63); const f = n(110); const d = n(38); const p = n(86); const h = n(40); const a = n(89); const l = n(111); const A = n(15); const v = n(122).fastKey; var n = n(43); const m = n.set; const g = n.getterFor; e.exports = {
      getConstructor: function(e, n, o, i) {
        function r(e, t, n) {
          let o; const i = l(e); let r = u(e, t); return r ? r.value = n : (i.last = r = { index: o = v(t, !0), key: t, value: n, previous: n = i.last, next: void 0, removed: !1 }, i.first || (i.first = r), n && (n.next = r), A ? i.size++ : e.size++, o !== 'F' && (i.index[o] = r)), e
        } var a = e((e, t) => {
          p(e, a, n), m(e, { type: n, index: c(null), first: void 0, last: void 0, size: 0 }), A || (e.size = 0), t != null && h(t, e[i], { that: e, AS_ENTRIES: o })
        }); var l = g(n); var u = function(e, t) {
          let n; const o = l(e); var e = v(t); if (e !== 'F') return o.index[e]; for (n = o.first; n; n = n.next) if (n.key == t) return n
        }; return f(a.prototype, {
          clear: function() {
            for (var e = l(this), t = e.index, n = e.first; n;)n.removed = !0, n.previous && (n.previous = n.previous.next = void 0), delete t[n.index], n = n.next; e.first = e.last = void 0, A ? e.size = 0 : this.size = 0
          },
          delete: function(e) {
            let t; const n = l(this); const o = u(this, e); return o && (t = o.next, e = o.previous, delete n.index[o.index], o.removed = !0, e && (e.next = t), t && (t.previous = e), n.first == o && (n.first = t), n.last == o && (n.last = e), A ? n.size-- : this.size--), !!o
          },
          forEach: function(e) {
            for (var t, n = l(this), o = d(e, arguments.length > 1 ? arguments[1] : void 0, 3); t = t ? t.next : n.first;) for (o(t.value, t.key, this); t && t.removed;)t = t.previous
          },
          has: function(e) {
            return !!u(this, e)
          }
        }), f(a.prototype, o
          ? {
              get: function(e) {
                e = u(this, e); return e && e.value
              },
              set: function(e, t) {
                return r(this, e === 0 ? 0 : e, t)
              }
            }
          : {
              add: function(e) {
                return r(this, e = e === 0 ? 0 : e, e)
              }
            }), A && s(a.prototype, 'size', {
          get: function() {
            return l(this).size
          }
        }), a
      },
      setStrong: function(e, t, n) {
        const o = `${t} Iterator`; const i = g(t); const r = g(o); a(e, t, function(e, t) {
          m(this, { type: o, target: e, state: i(e), kind: t, last: void 0 })
        }, function() {
          for (var e = r(this), t = e.kind, n = e.last; n && n.removed;)n = n.previous; return e.target && (e.last = n = n ? n.next : e.state.first) ? t == 'keys' ? { value: n.key, done: !1 } : t == 'values' ? { value: n.value, done: !1 } : { value: [n.key, n.value], done: !1 } : { value: e.target = void 0, done: !0 }
        }, n ? 'entries' : 'values', !n, !0), l(t)
      }
    }
  }, function(e, t, n) {
    const o = n(103); const i = n(83).concat('length', 'prototype'); t.f = Object.getOwnPropertyNames || function(e) {
      return o(e, i)
    }
  }, function(e, t) {
    t.f = Object.getOwnPropertySymbols
  }, function(e, t, n) {
    n(9)('iterator')
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }), t.default = { zIndex: 1e4 }
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }), t.default = { focus: !0, height: 300, placeholder: '请输入正文', zIndexFullScreen: 10002, showFullScreen: !0 }
  }, function(e, t, n) {
    'use strict'; const o = n(0); var i = o(n(1)); const r = o(n(4)); (0, i.default)(t, '__esModule', { value: !0 }), t.getPasteImgs = t.getPasteHtml = t.getPasteText = void 0; var i = n(2); const a = n(6); const l = i.__importDefault(n(299)); function u(e) {
      const t = e.clipboardData; var e = ''; var e = t == null ? window.clipboardData && window.clipboardData.getData('text') : t.getData('text/plain'); return a.replaceHtmlSymbol(e)
    }t.getPasteText = u, t.getPasteHtml = function(e, t, n) {
      void 0 === t && (t = !0), void 0 === n && (n = !1); const o = e.clipboardData; let i = ''; if (!(i = o ? o.getData('text/html') : i)) {
        e = u(e); if (!e) return ''; i = `<p>${e}</p>`
      } return i = (i = i.replace(/<(\d)/gm, (e, t) => {
        return `&lt;${t}`
      })).replace(/<meta.*charset=("|').*("|').*?>/gim, ''), i = l.default(i, t, n)
    }, t.getPasteImgs = function(e) {
      const o = []; return u(e) || (e = (e = e.clipboardData) === null || void 0 === e ? void 0 : e.items) && (0, r.default)(a).call(a, e, (e, t) => {
        const n = t.type; /image/i.test(n) && o.push(t.getAsFile())
      }), o
    }
  }, function(e, t, n) {
    e.exports = n(301)
  }, function(e, t, n) {
    e.exports = n(313)
  }, function(e, t, n) {
    e.exports = n(317)
  }, function(e, t, n) {
    'use strict'; const o = n(0); var i = o(n(1)); const l = o(n(4)); const u = o(n(45)); (0, i.default)(t, '__esModule', { value: !0 }); const s = n(2).__importDefault(n(3)); const c = n(7); var i = (r.prototype.show = function() {
      this.hideTimeoutId && clearTimeout(this.hideTimeoutId); let e; let t; const n = this.menu.$elem; const o = this.$container; this._show || (this.rendered ? o.show() : (e = n.getBoundingClientRect().height || 0, t = this.conf.width || 100, o.css('margin-top', `${e}px`).css('width', `${t}px`), n.append(o), this.rendered = !0), this._show = !0)
    }, r.prototype.hide = function() {
      const e = this.$container; this._show && (e.hide(), this._show = !1)
    }, (0, i.default)(r.prototype, 'isShow', {
      get: function() {
        return this._show
      },
      enumerable: !1,
      configurable: !0
    }), r); function r(e, t) {
      const o = this; this.hideTimeoutId = 0, this.menu = e, this.conf = t; const n = s.default('<div class="w-e-droplist"></div>'); var i = s.default(`<p>${t.title}</p>`); i.addClass('w-e-dp-title'), n.append(i); var e = t.list || []; var i = t.type || 'list'; const r = t.clickHandler || c.EMPTY_FN; const a = s.default(`<ul class="${i === 'list' ? 'w-e-list' : 'w-e-block'}"></ul>`); (0, l.default)(e).call(e, (e) => {
        const t = e.$elem; const n = e.value; var e = s.default('<li class="w-e-item"></li>'); t && (e.append(t), a.append(e), e.on('click', (e) => {
          r(n), e.stopPropagation(), o.hideTimeoutId = (0, u.default)(() => {
            o.hide()
          })
        }))
      }), n.append(a), n.on('mouseleave', () => {
        o.hideTimeoutId = (0, u.default)(() => {
          o.hide()
        })
      }), this.$container = n, this.rendered = !1, this._show = !1
    }t.default = i
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }), t.default = function(e) {
      return !((e = e.selection.getSelectionContainerElem()) == null || !e.length) && e.getNodeName() === 'A'
    }
  }, function(e, t, n) {
    'use strict'; const o = n(0); const i = o(n(95)); const r = o(n(1)); const a = o(n(4)); (0, r.default)(t, '__esModule', { value: !0 }); const l = n(6); t.default = function(e, n) {
      const o = new XMLHttpRequest(); if (o.open('POST', e), o.timeout = n.timeout || 1e4, o.ontimeout = function() {
        console.error('wangEditor - 请求超时'), n.onTimeout && n.onTimeout(o)
      }, o.upload && (o.upload.onprogress = function(e) {
        const t = e.loaded / e.total; n.onProgress && n.onProgress(t, e)
      }), n.headers && (0, a.default)(l).call(l, n.headers, (e, t) => {
        o.setRequestHeader(e, t)
      }), o.withCredentials = !!n.withCredentials, n.beforeSend) {
        e = n.beforeSend(o); if (e && (0, i.default)(e) === 'object' && e.prevent) return e.msg
      } return o.onreadystatechange = function() {
        if (o.readyState === 4) {
          var t = o.status; if (!(t < 200 || t >= 300 && t < 400)) {
            if (t >= 400) return console.error(`wangEditor - XHR 报错，状态码 ${t}`), void (n.onError && n.onError(o)); let e; var t = o.responseText; if ((0, i.default)(t) !== 'object') {
              try {
                e = JSON.parse(t)
              } catch (e) {
                return console.error('wangEditor - 返回结果不是 JSON 格式', t), void (n.onFail && n.onFail(o, t))
              }
            } else e = t; n.onSuccess(o, e)
          }
        }
      }, o.send(n.formData || null), o
    }
  }, function(e, t, n) {
    'use strict'; const o = n(0); const i = o(n(1)); const r = o(n(349)); const a = o(n(45)); (0, i.default)(t, '__esModule', { value: !0 }); const l = n(2).__importDefault(n(3)); var n = (u.prototype.show = function(e) {
      let t; const n = this; this.isShow || (this.isShow = !0, t = this.$bar, this.$textContainer.append(t), (0, r.default)() - this.time > 100 && e <= 1 && (t.css('width', `${100 * e}%`), this.time = (0, r.default)()), (e = this.timeoutId) && clearTimeout(e), this.timeoutId = (0, a.default)(() => {
        n.hide()
      }, 500))
    }, u.prototype.hide = function() {
      this.$bar.remove(), this.isShow = !1, this.time = 0, this.timeoutId = 0
    }, u); function u(e) {
      this.editor = e, this.$textContainer = e.$textContainerElem, this.$bar = l.default('<div class="w-e-progress"></div>'), this.isShow = !1, this.time = 0, this.timeoutId = 0
    }t.default = n
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }), t.ListType = void 0; let i; var o = n(2); const r = o.__importDefault(n(3)); const a = o.__importDefault(n(24)); const u = n(46); const s = o.__importStar(n(377)); (n = i = t.ListType || (t.ListType = {})).OrderedList = 'OL', n.UnorderedList = 'UL'; let l; var o = (l = a.default, o.__extends(c, l), c.prototype.command = function(e) {
      void 0 !== this.editor.selection.getSelectionContainerElem() && (this.handleSelectionRangeNodes(e), this.tryChangeActive())
    }, c.prototype.validator = function(e, t, n) {
      return !(!e.length || !t.length || n.equal(e) || n.equal(t))
    }, c.prototype.handleSelectionRangeNodes = function(e) {
      let t; const n = this.editor; let o = n.selection; let i = e.toLowerCase(); let r = o.getSelectionContainerElem(); const a = o.getSelectionStartElem().getNodeTop(n); let l = o.getSelectionEndElem().getNodeTop(n); this.validator(a, l, n.$textElem) && (o = (t = o.getRange()) == null ? void 0 : t.collapsed, n.$textElem.equal(r) || (r = r.getNodeTop(n)), i = { editor: n, listType: e, listTarget: i, $selectionElem: r, $startElem: a, $endElem: l }, l = this.isOrderElem(r) ? s.ClassType.Wrap : this.isOrderElem(a) && this.isOrderElem(l) ? s.ClassType.Join : this.isOrderElem(a) ? s.ClassType.StartJoin : this.isOrderElem(l) ? s.ClassType.EndJoin : s.ClassType.Other, t = new s.default(s.createListHandle(l, i, t)), u.updateRange(n, t.getSelectionRangeElem(), !!o))
    }, c.prototype.isOrderElem = function(e) {
      e = e.getNodeName(); return e === i.OrderedList || e === i.UnorderedList
    }, c.prototype.tryChangeActive = function() {}, c); function c(e) {
      let t = this; const n = r.default('<div class="w-e-menu" data-title="序列">\n                <i class="w-e-icon-list2"></i>\n            </div>'); const o = {
        width: 130,
        title: '序列',
        type: 'list',
        list: [{ $elem: r.default(`\n                        <p>\n                            <i class="w-e-icon-list2 w-e-drop-list-item"></i>\n                            ${e.i18next.t('menus.dropListMenu.list.无序列表')}\n                        <p>`), value: i.UnorderedList }, { $elem: r.default(`<p>\n                            <i class="w-e-icon-list-numbered w-e-drop-list-item"></i>\n                            ${e.i18next.t('menus.dropListMenu.list.有序列表')}\n                        <p>`), value: i.OrderedList }],
        clickHandler: function(e) {
          t.command(e)
        }
      }; return t = l.call(this, n, e, o) || this
    }t.default = o
  }, function(e, t, n) {
    e.exports = n(401)
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }), t.default = function(e) {
      return !((e = e.selection.getSelectionContainerElem()) == null || !e.length) && !(e.getNodeName() != 'CODE' && e.getNodeName() != 'PRE' && e.parent().getNodeName() != 'CODE' && e.parent().getNodeName() != 'PRE' && !/hljs/.test(e.parent().attr('class')))
    }
  }, function(e, t, n) {
    'use strict'; const o = n(0); const i = o(n(1)); const r = o(n(31)); (0, i.default)(t, '__esModule', { value: !0 }), t.todo = void 0; const a = n(2).__importDefault(n(3)); const l = (u.prototype.init = function() {
      const e = this.$child; const t = this.getInputContainer(); e && e.insertAfter(t)
    }, u.prototype.getInput = function() {
      const e = this.$todo; return (0, r.default)(e).call(e, 'input')
    }, u.prototype.getInputContainer = function() {
      return this.getInput().parent()
    }, u.prototype.getTodo = function() {
      return this.$todo
    }, u); function u(e) {
      this.template = '<ul class="w-e-todo"><li><span contenteditable="false"><input type="checkbox"></span></li></ul>', this.checked = !1, this.$todo = a.default(this.template), this.$child = (e = e == null ? void 0 : e.childNodes()) === null || void 0 === e ? void 0 : e.clone(!0)
    }t.todo = l, t.default = function(e) {
      return (e = new l(e)).init(), e
    }
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); const o = n(2); n(146), n(148), n(152), n(154), n(156), n(158), n(160); const i = o.__importDefault(n(119)); o.__exportStar(n(447), t); try {
      document
    } catch (e) {
      throw new Error('请在浏览器环境下运行')
    }t.default = i.default
  }, function(e, t, n) {
    n = n(143); e.exports = n
  }, function(e, t, n) {
    n(144); const o = n(10).Object; var e = e.exports = function(e, t, n) {
      return o.defineProperty(e, t, n)
    }; o.defineProperty.sham && (e.sham = !0)
  }, function(e, t, n) {
    const o = n(5); const i = n(15); o({ target: 'Object', stat: !0, forced: !i, sham: !i }, { defineProperty: n(18).f })
  }, function(e, t) {
    let n = (function() {
      return this
    }()); try {
      n = n || new Function('return this')()
    } catch (e) {
      typeof window === 'object' && (n = window)
    }e.exports = n
  }, function(e, t, n) {
    const o = n(21); let i = n(147); var n = { insert: 'head', singleton: !1 }; o(i = typeof (i = i.__esModule ? i.default : i) === 'string' ? [[e.i, i, '']] : i, n); e.exports = i.locals || {}
  }, function(e, t, n) {
    (t = n(22)(!1)).push([e.i, '.w-e-toolbar,\n.w-e-text-container,\n.w-e-menu-panel {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n  background-color: #fff;\n  /*表情菜单样式*/\n  /*分割线样式*/\n}\n.w-e-toolbar h1,\n.w-e-text-container h1,\n.w-e-menu-panel h1 {\n  font-size: 32px !important;\n}\n.w-e-toolbar h2,\n.w-e-text-container h2,\n.w-e-menu-panel h2 {\n  font-size: 24px !important;\n}\n.w-e-toolbar h3,\n.w-e-text-container h3,\n.w-e-menu-panel h3 {\n  font-size: 18.72px !important;\n}\n.w-e-toolbar h4,\n.w-e-text-container h4,\n.w-e-menu-panel h4 {\n  font-size: 16px !important;\n}\n.w-e-toolbar h5,\n.w-e-text-container h5,\n.w-e-menu-panel h5 {\n  font-size: 13.28px !important;\n}\n.w-e-toolbar p,\n.w-e-text-container p,\n.w-e-menu-panel p {\n  font-size: 16px !important;\n}\n.w-e-toolbar .eleImg,\n.w-e-text-container .eleImg,\n.w-e-menu-panel .eleImg {\n  cursor: pointer;\n  display: inline-block;\n  font-size: 18px;\n  padding: 0 3px;\n}\n.w-e-toolbar *,\n.w-e-text-container *,\n.w-e-menu-panel * {\n  padding: 0;\n  margin: 0;\n  box-sizing: border-box;\n}\n.w-e-toolbar hr,\n.w-e-text-container hr,\n.w-e-menu-panel hr {\n  cursor: pointer;\n  display: block;\n  height: 0px;\n  border: 0;\n  border-top: 3px solid #ccc;\n  margin: 20px 0;\n}\n.w-e-clear-fix:after {\n  content: "";\n  display: table;\n  clear: both;\n}\n.w-e-drop-list-item {\n  position: relative;\n  top: 1px;\n  padding-right: 7px;\n  color: #333 !important;\n}\n.w-e-drop-list-tl {\n  padding-left: 10px;\n  text-align: left;\n}\n', '']), e.exports = t
  }, function(e, t, n) {
    const o = n(21); let i = n(149); var n = { insert: 'head', singleton: !1 }; o(i = typeof (i = i.__esModule ? i.default : i) === 'string' ? [[e.i, i, '']] : i, n); e.exports = i.locals || {}
  }, function(e, t, n) {
    const o = n(22); const i = n(150); var n = n(151); t = o(!1); n = i(n); t.push([e.i, `@font-face {\n  font-family: 'w-e-icon';\n  src: url(${n}) format('truetype');\n  font-weight: normal;\n  font-style: normal;\n}\n[class^="w-e-icon-"],\n[class*=" w-e-icon-"] {\n  /* use !important to prevent issues with browser extensions that change fonts */\n  font-family: 'w-e-icon' !important;\n  speak: none;\n  font-style: normal;\n  font-weight: normal;\n  font-variant: normal;\n  text-transform: none;\n  line-height: 1;\n  /* Better Font Rendering =========== */\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n.w-e-icon-close:before {\n  content: "\\f00d";\n}\n.w-e-icon-upload2:before {\n  content: "\\e9c6";\n}\n.w-e-icon-trash-o:before {\n  content: "\\f014";\n}\n.w-e-icon-header:before {\n  content: "\\f1dc";\n}\n.w-e-icon-pencil2:before {\n  content: "\\e906";\n}\n.w-e-icon-paint-brush:before {\n  content: "\\f1fc";\n}\n.w-e-icon-image:before {\n  content: "\\e90d";\n}\n.w-e-icon-play:before {\n  content: "\\e912";\n}\n.w-e-icon-location:before {\n  content: "\\e947";\n}\n.w-e-icon-undo:before {\n  content: "\\e965";\n}\n.w-e-icon-redo:before {\n  content: "\\e966";\n}\n.w-e-icon-quotes-left:before {\n  content: "\\e977";\n}\n.w-e-icon-list-numbered:before {\n  content: "\\e9b9";\n}\n.w-e-icon-list2:before {\n  content: "\\e9bb";\n}\n.w-e-icon-link:before {\n  content: "\\e9cb";\n}\n.w-e-icon-happy:before {\n  content: "\\e9df";\n}\n.w-e-icon-bold:before {\n  content: "\\ea62";\n}\n.w-e-icon-underline:before {\n  content: "\\ea63";\n}\n.w-e-icon-italic:before {\n  content: "\\ea64";\n}\n.w-e-icon-strikethrough:before {\n  content: "\\ea65";\n}\n.w-e-icon-table2:before {\n  content: "\\ea71";\n}\n.w-e-icon-paragraph-left:before {\n  content: "\\ea77";\n}\n.w-e-icon-paragraph-center:before {\n  content: "\\ea78";\n}\n.w-e-icon-paragraph-right:before {\n  content: "\\ea79";\n}\n.w-e-icon-paragraph-justify:before {\n  content: "\\ea7a";\n}\n.w-e-icon-terminal:before {\n  content: "\\f120";\n}\n.w-e-icon-page-break:before {\n  content: "\\ea68";\n}\n.w-e-icon-cancel-circle:before {\n  content: "\\ea0d";\n}\n.w-e-icon-font:before {\n  content: "\\ea5c";\n}\n.w-e-icon-text-heigh:before {\n  content: "\\ea5f";\n}\n.w-e-icon-paint-format:before {\n  content: "\\e90c";\n}\n.w-e-icon-indent-increase:before {\n  content: "\\ea7b";\n}\n.w-e-icon-indent-decrease:before {\n  content: "\\ea7c";\n}\n.w-e-icon-row-height:before {\n  content: "\\e9be";\n}\n.w-e-icon-fullscreen_exit:before {\n  content: "\\e900";\n}\n.w-e-icon-fullscreen:before {\n  content: "\\e901";\n}\n.w-e-icon-split-line:before {\n  content: "\\ea0b";\n}\n.w-e-icon-checkbox-checked:before {\n  content: "\\ea52";\n}\n`, '']), e.exports = t
  }, function(e, t, n) {
    'use strict'; e.exports = function(e, t) {
      return t = t || {}, typeof (e = e && e.__esModule ? e.default : e) !== 'string' ? e : (/^['"].*['"]$/.test(e) && (e = e.slice(1, -1)), t.hash && (e += t.hash), /["'() \t\n]/.test(e) || t.needQuotes ? '"'.concat(e.replace(/"/g, '\\"').replace(/\n/g, '\\n'), '"') : e)
    }
  }, function(e, t, n) {
    'use strict'; n.r(t), t.default = 'data:font/woff;base64,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'
  }, function(e, t, n) {
    const o = n(21); let i = n(153); var n = { insert: 'head', singleton: !1 }; o(i = typeof (i = i.__esModule ? i.default : i) === 'string' ? [[e.i, i, '']] : i, n); e.exports = i.locals || {}
  }, function(e, t, n) {
    (t = n(22)(!1)).push([e.i, '.w-e-toolbar {\n  display: flex;\n  padding: 0 6px;\n  flex-wrap: wrap;\n  position: relative;\n  /* 单个菜单 */\n}\n.w-e-toolbar .w-e-menu {\n  position: relative;\n  display: flex;\n  width: 40px;\n  height: 40px;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  cursor: pointer;\n}\n.w-e-toolbar .w-e-menu i {\n  color: #999;\n}\n.w-e-toolbar .w-e-menu:hover {\n  background-color: #F6F6F6;\n}\n.w-e-toolbar .w-e-menu:hover i {\n  color: #333;\n}\n.w-e-toolbar .w-e-active i {\n  color: #1e88e5;\n}\n.w-e-toolbar .w-e-active:hover i {\n  color: #1e88e5;\n}\n.w-e-menu-tooltip {\n  position: absolute;\n  display: flex;\n  color: #f1f1f1;\n  background-color: rgba(0, 0, 0, 0.75);\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n  padding: 4px 5px 6px;\n  justify-content: center;\n  align-items: center;\n}\n.w-e-menu-tooltip-up::after {\n  content: "";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  margin-left: -5px;\n  border: 5px solid rgba(0, 0, 0, 0);\n  border-top-color: rgba(0, 0, 0, 0.73);\n}\n.w-e-menu-tooltip-down::after {\n  content: "";\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  margin-left: -5px;\n  border: 5px solid rgba(0, 0, 0, 0);\n  border-bottom-color: rgba(0, 0, 0, 0.73);\n}\n.w-e-menu-tooltip-item-wrapper {\n  font-size: 14px;\n  margin: 0 5px;\n}\n', '']), e.exports = t
  }, function(e, t, n) {
    const o = n(21); let i = n(155); var n = { insert: 'head', singleton: !1 }; o(i = typeof (i = i.__esModule ? i.default : i) === 'string' ? [[e.i, i, '']] : i, n); e.exports = i.locals || {}
  }, function(e, t, n) {
    (t = n(22)(!1)).push([e.i, '.w-e-text-container {\n  position: relative;\n  height: 100%;\n}\n.w-e-text-container .w-e-progress {\n  position: absolute;\n  background-color: #1e88e5;\n  top: 0;\n  left: 0;\n  height: 1px;\n}\n.w-e-text-container .placeholder {\n  color: #D4D4D4;\n  position: absolute;\n  font-size: 11pt;\n  line-height: 22px;\n  left: 10px;\n  top: 10px;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  z-index: -1;\n}\n.w-e-text {\n  padding: 0 10px;\n  overflow-y: auto;\n}\n.w-e-text p,\n.w-e-text h1,\n.w-e-text h2,\n.w-e-text h3,\n.w-e-text h4,\n.w-e-text h5,\n.w-e-text table,\n.w-e-text pre {\n  margin: 10px 0;\n  line-height: 1.5;\n}\n.w-e-text ul,\n.w-e-text ol {\n  margin: 10px 0 10px 20px;\n}\n.w-e-text blockquote {\n  display: block;\n  border-left: 8px solid #d0e5f2;\n  padding: 5px 10px;\n  margin: 10px 0;\n  line-height: 1.4;\n  font-size: 100%;\n  background-color: #f1f1f1;\n}\n.w-e-text code {\n  display: inline-block;\n  background-color: #f1f1f1;\n  border-radius: 3px;\n  padding: 3px 5px;\n  margin: 0 3px;\n}\n.w-e-text pre code {\n  display: block;\n}\n.w-e-text table {\n  border-top: 1px solid #ccc;\n  border-left: 1px solid #ccc;\n}\n.w-e-text table td,\n.w-e-text table th {\n  border-bottom: 1px solid #ccc;\n  border-right: 1px solid #ccc;\n  padding: 3px 5px;\n  min-height: 30px;\n}\n.w-e-text table th {\n  border-bottom: 2px solid #ccc;\n  text-align: center;\n  background-color: #f1f1f1;\n}\n.w-e-text:focus {\n  outline: none;\n}\n.w-e-text img {\n  cursor: pointer;\n}\n.w-e-text img:hover {\n  box-shadow: 0 0 5px #333;\n}\n.w-e-text .w-e-todo {\n  margin: 0 0 0 20px;\n}\n.w-e-text .w-e-todo li {\n  list-style: none;\n  font-size: 1em;\n}\n.w-e-text .w-e-todo li span:nth-child(1) {\n  position: relative;\n  left: -18px;\n}\n.w-e-text .w-e-todo li span:nth-child(1) input {\n  position: absolute;\n  margin-right: 3px;\n}\n.w-e-text .w-e-todo li span:nth-child(1) input[type=checkbox] {\n  top: 50%;\n  margin-top: -6px;\n}\n.w-e-tooltip {\n  position: absolute;\n  display: flex;\n  color: #f1f1f1;\n  background-color: rgba(0, 0, 0, 0.75);\n  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.15);\n  border-radius: 4px;\n  padding: 4px 5px 6px;\n  justify-content: center;\n  align-items: center;\n}\n.w-e-tooltip-up::after {\n  content: "";\n  position: absolute;\n  top: 100%;\n  left: 50%;\n  margin-left: -5px;\n  border: 5px solid rgba(0, 0, 0, 0);\n  border-top-color: rgba(0, 0, 0, 0.73);\n}\n.w-e-tooltip-down::after {\n  content: "";\n  position: absolute;\n  bottom: 100%;\n  left: 50%;\n  margin-left: -5px;\n  border: 5px solid rgba(0, 0, 0, 0);\n  border-bottom-color: rgba(0, 0, 0, 0.73);\n}\n.w-e-tooltip-item-wrapper {\n  cursor: pointer;\n  font-size: 14px;\n  margin: 0 5px;\n}\n.w-e-tooltip-item-wrapper:hover {\n  color: #ccc;\n  text-decoration: underline;\n}\n', '']), e.exports = t
  }, function(e, t, n) {
    const o = n(21); let i = n(157); var n = { insert: 'head', singleton: !1 }; o(i = typeof (i = i.__esModule ? i.default : i) === 'string' ? [[e.i, i, '']] : i, n); e.exports = i.locals || {}
  }, function(e, t, n) {
    (t = n(22)(!1)).push([e.i, '.w-e-menu .w-e-panel-container {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  border: 1px solid #ccc;\n  border-top: 0;\n  box-shadow: 1px 1px 2px #ccc;\n  color: #333;\n  background-color: #fff;\n  text-align: left;\n  /* 为 emotion panel 定制的样式 */\n  /* 上传图片、上传视频的 panel 定制样式 */\n}\n.w-e-menu .w-e-panel-container .w-e-panel-close {\n  position: absolute;\n  right: 0;\n  top: 0;\n  padding: 5px;\n  margin: 2px 5px 0 0;\n  cursor: pointer;\n  color: #999;\n}\n.w-e-menu .w-e-panel-container .w-e-panel-close:hover {\n  color: #333;\n}\n.w-e-menu .w-e-panel-container .w-e-panel-tab-title {\n  list-style: none;\n  display: flex;\n  font-size: 14px;\n  margin: 2px 10px 0 10px;\n  border-bottom: 1px solid #f1f1f1;\n}\n.w-e-menu .w-e-panel-container .w-e-panel-tab-title .w-e-item {\n  padding: 3px 5px;\n  color: #999;\n  cursor: pointer;\n  margin: 0 3px;\n  position: relative;\n  top: 1px;\n}\n.w-e-menu .w-e-panel-container .w-e-panel-tab-title .w-e-active {\n  color: #333;\n  border-bottom: 1px solid #333;\n  cursor: default;\n  font-weight: 700;\n}\n.w-e-menu .w-e-panel-container .w-e-panel-tab-content {\n  padding: 10px 15px 10px 15px;\n  font-size: 16px;\n  /* 输入框的样式 */\n  /* 按钮的样式 */\n}\n.w-e-menu .w-e-panel-container .w-e-panel-tab-content input:focus,\n.w-e-menu .w-e-panel-container .w-e-panel-tab-content textarea:focus,\n.w-e-menu .w-e-panel-container .w-e-panel-tab-content button:focus {\n  outline: none;\n}\n.w-e-menu .w-e-panel-container .w-e-panel-tab-content textarea {\n  width: 100%;\n  border: 1px solid #ccc;\n  padding: 5px;\n  margin-top: 10px;\n}\n.w-e-menu .w-e-panel-container .w-e-panel-tab-content textarea:focus {\n  border-color: #1e88e5;\n}\n.w-e-menu .w-e-panel-container .w-e-panel-tab-content input[type=text] {\n  border: none;\n  border-bottom: 1px solid #ccc;\n  font-size: 14px;\n  height: 20px;\n  color: #333;\n  text-align: left;\n}\n.w-e-menu .w-e-panel-container .w-e-panel-tab-content input[type=text].small {\n  width: 30px;\n  text-align: center;\n}\n.w-e-menu .w-e-panel-container .w-e-panel-tab-content input[type=text].block {\n  display: block;\n  width: 100%;\n  margin: 10px 0;\n}\n.w-e-menu .w-e-panel-container .w-e-panel-tab-content input[type=text]:focus {\n  border-bottom: 2px solid #1e88e5;\n}\n.w-e-menu .w-e-panel-container .w-e-panel-tab-content .w-e-button-container button {\n  font-size: 14px;\n  color: #1e88e5;\n  border: none;\n  padding: 5px 10px;\n  background-color: #fff;\n  cursor: pointer;\n  border-radius: 3px;\n}\n.w-e-menu .w-e-panel-container .w-e-panel-tab-content .w-e-button-container button.left {\n  float: left;\n  margin-right: 10px;\n}\n.w-e-menu .w-e-panel-container .w-e-panel-tab-content .w-e-button-container button.right {\n  float: right;\n  margin-left: 10px;\n}\n.w-e-menu .w-e-panel-container .w-e-panel-tab-content .w-e-button-container button.gray {\n  color: #999;\n}\n.w-e-menu .w-e-panel-container .w-e-panel-tab-content .w-e-button-container button.red {\n  color: #c24f4a;\n}\n.w-e-menu .w-e-panel-container .w-e-panel-tab-content .w-e-button-container button:hover {\n  background-color: #f1f1f1;\n}\n.w-e-menu .w-e-panel-container .w-e-panel-tab-content .w-e-button-container:after {\n  content: "";\n  display: table;\n  clear: both;\n}\n.w-e-menu .w-e-panel-container .w-e-emoticon-container .w-e-item {\n  cursor: pointer;\n  font-size: 18px;\n  padding: 0 3px;\n  display: inline-block;\n}\n.w-e-menu .w-e-panel-container .w-e-up-img-container,\n.w-e-menu .w-e-panel-container .w-e-up-video-container {\n  text-align: center;\n}\n.w-e-menu .w-e-panel-container .w-e-up-img-container .w-e-up-btn,\n.w-e-menu .w-e-panel-container .w-e-up-video-container .w-e-up-btn {\n  display: inline-block;\n  color: #999;\n  cursor: pointer;\n  font-size: 60px;\n  line-height: 1;\n}\n.w-e-menu .w-e-panel-container .w-e-up-img-container .w-e-up-btn:hover,\n.w-e-menu .w-e-panel-container .w-e-up-video-container .w-e-up-btn:hover {\n  color: #333;\n}\n', '']), e.exports = t
  }, function(e, t, n) {
    const o = n(21); let i = n(159); var n = { insert: 'head', singleton: !1 }; o(i = typeof (i = i.__esModule ? i.default : i) === 'string' ? [[e.i, i, '']] : i, n); e.exports = i.locals || {}
  }, function(e, t, n) {
    (t = n(22)(!1)).push([e.i, '.w-e-toolbar .w-e-droplist {\n  position: absolute;\n  left: 0;\n  top: 0;\n  background-color: #fff;\n  border: 1px solid #f1f1f1;\n  border-right-color: #ccc;\n  border-bottom-color: #ccc;\n}\n.w-e-toolbar .w-e-droplist .w-e-dp-title {\n  text-align: center;\n  color: #999;\n  line-height: 2;\n  border-bottom: 1px solid #f1f1f1;\n  font-size: 13px;\n}\n.w-e-toolbar .w-e-droplist ul.w-e-list {\n  list-style: none;\n  line-height: 1;\n}\n.w-e-toolbar .w-e-droplist ul.w-e-list li.w-e-item {\n  color: #333;\n  padding: 5px 0;\n}\n.w-e-toolbar .w-e-droplist ul.w-e-list li.w-e-item:hover {\n  background-color: #f1f1f1;\n}\n.w-e-toolbar .w-e-droplist ul.w-e-block {\n  list-style: none;\n  text-align: left;\n  padding: 5px;\n}\n.w-e-toolbar .w-e-droplist ul.w-e-block li.w-e-item {\n  display: inline-block;\n  padding: 3px 5px;\n}\n.w-e-toolbar .w-e-droplist ul.w-e-block li.w-e-item:hover {\n  background-color: #f1f1f1;\n}\n', '']), e.exports = t
  }, function(e, t, n) {
    'use strict'; n = n(0)(n(161)); Element.prototype.matches || (Element.prototype.matches = function(e) {
      for (var t = this.ownerDocument.querySelectorAll(e), n = t.length; n >= 0 && t.item(n) !== this; n--);return n > -1
    }), n.default || (window.Promise = n.default)
  }, function(e, t, n) {
    e.exports = n(162)
  }, function(e, t, n) {
    n = n(163); e.exports = n
  }, function(e, t, n) {
    n(164), n(68), n(169), n(176), n(177), n(178), n(52), n(53); n = n(10); e.exports = n.Promise
  }, function(e, t, n) {
    'use strict'; const o = n(5); const i = n(77); const r = n(80); const a = n(63); const l = n(17); const u = n(37); const s = n(40); var c = function(e, t) {
      let n = this; if (!(n instanceof c)) return new c(e, t); r && (n = r(new Error(void 0), i(n))), void 0 !== t && l(n, 'message', String(t)); t = []; return s(e, t.push, { that: t }), l(n, 'errors', t), n
    }; c.prototype = a(Error.prototype, { constructor: u(5, c), message: u(5, ''), name: u(5, 'AggregateError') }), o({ global: !0 }, { AggregateError: c })
  }, function(e, t, n) {
    const o = n(8); const i = n(17); e.exports = function(t, n) {
      try {
        i(o, t, n)
      } catch (e) {
        o[t] = n
      } return n
    }
  }, function(e, t, n) {
    n = n(12); e.exports = !n(() => {
      function e() {} return e.prototype.constructor = null, Object.getPrototypeOf(new e()) !== e.prototype
    })
  }, function(e, t, n) {
    const o = n(13); e.exports = function(e) {
      if (!o(e) && e !== null) throw TypeError(`Can't set ${String(e)} as a prototype`); return e
    }
  }, function(e, t, n) {
    const o = n(15); const a = n(18); const l = n(20); const u = n(49); e.exports = o
      ? Object.defineProperties
      : function(e, t) {
        l(e); for (var n, o = u(t), i = o.length, r = 0; r < i;)a.f(e, n = o[r++], t[n]); return e
      }
  }, function(e, t, n) {
    'use strict'; function h(e) {
      let t; return !(!_(e) || typeof (t = e.then) !== 'function') && t
    } function i(f, d) {
      let p; f.notified || (f.notified = !0, p = f.reactions, k(() => {
        for (let e = f.value, t = f.state == 1, n = 0; p.length > n;) {
          var o; var i; var r; const a = p[n++]; const l = t ? a.ok : a.fail; const u = a.resolve; const s = a.reject; const c = a.domain; try {
            l ? (t || (f.rejection === 2 && re(f), f.rejection = 1), !0 === l ? o = e : (c && c.enter(), o = l(e), c && (c.exit(), r = !0)), o === a.promise ? s(J('Promise-chain cycle')) : (i = h(o)) ? i.call(o, u, s) : u(o)) : s(e)
          } catch (e) {
            c && !r && c.exit(), s(e)
          }
        }f.reactions = [], f.notified = !1, d && !f.rejection && oe(f)
      }))
    } function r(e, t, n) {
      let o; let i; Z ? ((o = K.createEvent('Event')).promise = t, o.reason = n, o.initEvent(e, !1, !0), p.dispatchEvent(o)) : o = { promise: t, reason: n }, !ee && (i = p[`on${e}`]) ? i(o) : e === te && B('Unhandled promise rejection', n)
    } function a(t, n, o) {
      return function(e) {
        t(n, e, o)
      }
    } function l(e, t, n) {
      e.done || (e.done = !0, (e = n || e).value = t, e.state = 2, i(e, !0))
    } let o; let u; let s; let c; const f = n(5); const d = n(39); var p = n(8); const A = n(29); const v = n(109); const m = n(51); const g = n(110); const y = n(80); const w = n(42); const x = n(111); var _ = n(13); const E = n(33); const b = n(86); const C = n(112); const S = n(40); var D = n(113); const M = n(114); const N = n(115).set; var k = n(171); const T = n(117); var B = n(173); const I = n(69); const R = n(88); var P = n(43); var H = n(102); const F = n(11); const L = n(175); const Q = n(87); const O = n(65); const U = F('species'); const j = 'Promise'; const Y = P.get; const z = P.set; const $ = P.getterFor(j); var P = v && v.prototype; let V = v; let G = P; var J = p.TypeError; var K = p.document; const W = p.process; let q = I.f; const X = q; var Z = !!(K && K.createEvent && p.dispatchEvent); var ee = typeof PromiseRejectionEvent === 'function'; var te = 'unhandledrejection'; let ne = !1; var H = H(j, () => {
      const e = C(V) !== String(V); if (!e && O === 66) return !0; if (d && !G.finally) return !0; if (O >= 51 && /native code/.test(V)) return !1; function t(e) {
        e(() => {}, () => {})
      } const n = new V((e) => {
        e(1)
      }); return (n.constructor = {})[U] = t, !(ne = n.then(() => {}) instanceof t) || !e && L && !ee
    }); var D = H || !D((e) => {
      V.all(e).catch(() => {})
    }); var oe = function(i) {
      N.call(p, () => {
        let e; const t = i.facade; const n = i.value; const o = ie(i); if (o && (e = R(() => {
          Q ? W.emit('unhandledRejection', n, t) : r(te, t, n)
        }), i.rejection = Q || ie(i) ? 2 : 1, e.error)) throw e.value
      })
    }; var ie = function(e) {
      return e.rejection !== 1 && !e.parent
    }; var re = function(t) {
      N.call(p, () => {
        const e = t.facade; Q ? W.emit('rejectionHandled', e) : r('rejectionhandled', e, t.value)
      })
    }; var ae = function(n, e, t) {
      if (!n.done) {
        n.done = !0, t && (n = t); try {
          if (n.facade === e) throw J("Promise can't be resolved itself"); const o = h(e); o
            ? k(() => {
              const t = { done: !1 }; try {
                o.call(e, a(ae, t, n), a(l, t, n))
              } catch (e) {
                l(t, e, n)
              }
            })
            : (n.value = e, n.state = 1, i(n, !1))
        } catch (e) {
          l({ done: !1 }, e, n)
        }
      }
    }; if (H && (G = (V = function(e) {
      b(this, V, j), E(e), o.call(this); const t = Y(this); try {
        e(a(ae, t), a(l, t))
      } catch (e) {
        l(t, e)
      }
    }).prototype, (o = function(e) {
      z(this, { type: j, done: !1, notified: !1, parent: !1, reactions: [], rejection: !1, state: 0, value: void 0 })
    }).prototype = g(G, {
      then: function(e, t) {
        const n = $(this); const o = q(M(this, V)); return o.ok = typeof e !== 'function' || e, o.fail = typeof t === 'function' && t, o.domain = Q ? W.domain : void 0, n.parent = !0, n.reactions.push(o), n.state != 0 && i(n, !1), o.promise
      },
      catch: function(e) {
        return this.then(void 0, e)
      }
    }), u = function() {
      const e = new o(); const t = Y(e); this.promise = e, this.resolve = a(ae, t), this.reject = a(l, t)
    }, I.f = q = function(e) {
      return e === V || e === s ? new u() : X(e)
    }, !d && typeof v === 'function' && P !== Object.prototype)) {
      c = P.then, ne || (m(P, 'then', function(e, t) {
        const n = this; return new V((e, t) => {
          c.call(n, e, t)
        }).then(e, t)
      }, { unsafe: !0 }), m(P, 'catch', G.catch, { unsafe: !0 })); try {
        delete P.constructor
      } catch (e) {}y && y(P, G)
    }f({ global: !0, wrap: !0, forced: H }, { Promise: V }), w(V, j, !1, !0), x(j), s = A(j), f({ target: j, stat: !0, forced: H }, {
      reject: function(e) {
        const t = q(this); return t.reject.call(void 0, e), t.promise
      }
    }), f({ target: j, stat: !0, forced: d || H }, {
      resolve: function(e) {
        return T(d && this === s ? V : this, e)
      }
    }), f({ target: j, stat: !0, forced: D }, {
      all: function(e) {
        const l = this; const t = q(l); const u = t.resolve; const s = t.reject; const n = R(() => {
          const o = E(l.resolve); const i = []; let r = 0; let a = 1; S(e, (e) => {
            const t = r++; let n = !1; i.push(void 0), a++, o.call(l, e).then((e) => {
              n || (n = !0, i[t] = e, --a || u(i))
            }, s)
          }), --a || u(i)
        }); return n.error && s(n.value), t.promise
      },
      race: function(e) {
        const n = this; const o = q(n); const i = o.reject; const t = R(() => {
          const t = E(n.resolve); S(e, (e) => {
            t.call(n, e).then(o.resolve, i)
          })
        }); return t.error && i(t.value), o.promise
      }
    })
  }, function(e, t, n) {
    'use strict'; const o = n(85); const i = n(67); e.exports = o
      ? {}.toString
      : function() {
        return `[object ${i(this)}]`
      }
  }, function(e, t, n) {
    let o; let i; let r; let a; let l; let u; let s; let c; const f = n(8); var d = n(74).f; const p = n(115).set; const h = n(116); const A = n(172); const v = n(87); const m = f.MutationObserver || f.WebKitMutationObserver; const g = f.document; const y = f.process; var n = f.Promise; var d = d(f, 'queueMicrotask'); var d = d && d.value; d || (o = function() {
      let e; let t; for (v && (e = y.domain) && e.exit(); i;) {
        t = i.fn, i = i.next; try {
          t()
        } catch (e) {
          throw i ? a() : r = void 0, e
        }
      }r = void 0, e && e.enter()
    }, a = h || v || A || !m || !g
      ? n && n.resolve
        ? ((s = n.resolve(void 0)).constructor = n, c = s.then, function() {
            c.call(s, o)
          })
        : v
          ? function() {
            y.nextTick(o)
          }
          : function() {
            p.call(f, o)
          }
      : (l = !0, u = g.createTextNode(''), new m(o).observe(u, { characterData: !0 }), function() {
          u.data = l = !l
        })), e.exports = d || function(e) {
      e = { fn: e, next: void 0 }; r && (r.next = e), i || (i = e, a()), r = e
    }
  }, function(e, t, n) {
    n = n(66); e.exports = /web0s(?!.*chrome)/i.test(n)
  }, function(e, t, n) {
    const o = n(8); e.exports = function(e, t) {
      const n = o.console; n && n.error && (arguments.length === 1 ? n.error(e) : n.error(e, t))
    }
  }, function(e, t, n) {
    var o = n(8); var n = n(112); var o = o.WeakMap; e.exports = typeof o === 'function' && /native code/.test(n(o))
  }, function(e, t) {
    e.exports = typeof window === 'object'
  }, function(e, t, n) {
    'use strict'; const o = n(5); const s = n(33); const i = n(69); const r = n(88); const c = n(40); o({ target: 'Promise', stat: !0 }, {
      allSettled: function(e) {
        const l = this; const t = i.f(l); const u = t.resolve; const n = t.reject; const o = r(() => {
          const o = s(l.resolve); const i = []; let r = 0; let a = 1; c(e, (e) => {
            const t = r++; let n = !1; i.push(void 0), a++, o.call(l, e).then((e) => {
              n || (n = !0, i[t] = { status: 'fulfilled', value: e }, --a || u(i))
            }, (e) => {
              n || (n = !0, i[t] = { status: 'rejected', reason: e }, --a || u(i))
            })
          }), --a || u(i)
        }); return o.error && n(o.value), t.promise
      }
    })
  }, function(e, t, n) {
    'use strict'; const o = n(5); const f = n(33); const d = n(29); const i = n(69); const r = n(88); const p = n(40); const h = 'No one promise resolved'; o({ target: 'Promise', stat: !0 }, {
      any: function(e) {
        const u = this; const t = i.f(u); const s = t.resolve; const c = t.reject; const n = r(() => {
          const o = f(u.resolve); const i = []; let r = 0; let a = 1; let l = !1; p(e, (e) => {
            const t = r++; let n = !1; i.push(void 0), a++, o.call(u, e).then((e) => {
              n || l || (l = !0, s(e))
            }, (e) => {
              n || l || (n = !0, i[t] = e, --a || c(new (d('AggregateError'))(i, h)))
            })
          }), --a || c(new (d('AggregateError'))(i, h))
        }); return n.error && c(n.value), t.promise
      }
    })
  }, function(e, t, n) {
    'use strict'; const o = n(5); let i = n(39); const r = n(109); const a = n(12); const l = n(29); const u = n(114); const s = n(117); var n = n(51); o({
      target: 'Promise',
      proto: !0,
      real: !0,
      forced: !!r && a(() => {
        r.prototype.finally.call({ then: function() {} }, () => {})
      })
    }, {
      finally: function(t) {
        const n = u(this, l('Promise')); const e = typeof t === 'function'; return this.then(e
          ? (e) => {
              return s(n, t()).then(() => {
                return e
              })
            }
          : t, e
          ? (e) => {
              return s(n, t()).then(() => {
                throw e
              })
            }
          : t)
      }
    }), i || typeof r !== 'function' || (i = l('Promise').prototype.finally, r.prototype.finally !== i && n(r.prototype, 'finally', i, { unsafe: !0 }))
  }, function(e, t, n) {
    const a = n(64); const l = n(48); var n = function(r) {
      return function(e, t) {
        let n; const o = String(l(e)); const i = a(t); var e = o.length; return i < 0 || e <= i ? r ? '' : void 0 : (t = o.charCodeAt(i)) < 55296 || t > 56319 || i + 1 === e || (n = o.charCodeAt(i + 1)) < 56320 || n > 57343 ? r ? o.charAt(i) : t : r ? o.slice(i, i + 2) : n - 56320 + (t - 55296 << 10) + 65536
      }
    }; e.exports = { codeAt: n(!1), charAt: n(!0) }
  }, function(e, t, n) {
    'use strict'; function o() {
      return this
    } const i = n(118).IteratorPrototype; const r = n(63); const a = n(37); const l = n(42); const u = n(41); e.exports = function(e, t, n) {
      t += ' Iterator'; return e.prototype = r(i, { next: a(1, n) }), l(e, t, !1, !0), u[t] = o, e
    }
  }, function(e, t, n) {
    'use strict'; const o = n(28); const i = n(90); const r = n(41); const a = n(43); var n = n(89); const l = 'Array Iterator'; const u = a.set; const s = a.getterFor(l); e.exports = n(Array, 'Array', function(e, t) {
      u(this, { type: l, target: o(e), index: 0, kind: t })
    }, function() {
      const e = s(this); const t = e.target; const n = e.kind; const o = e.index++; return !t || o >= t.length ? { value: e.target = void 0, done: !0 } : n == 'keys' ? { value: o, done: !1 } : n == 'values' ? { value: t[o], done: !1 } : { value: [o, t[o]], done: !1 }
    }, 'values'), r.Arguments = r.Array, i('keys'), i('values'), i('entries')
  }, function(e, t) {
    e.exports = { CSSRuleList: 0, CSSStyleDeclaration: 0, CSSValueList: 0, ClientRectList: 0, DOMRectList: 0, DOMStringList: 0, DOMTokenList: 1, DataTransferItemList: 0, FileList: 0, HTMLAllCollection: 0, HTMLCollection: 0, HTMLFormElement: 0, HTMLSelectElement: 0, MediaList: 0, MimeTypeArray: 0, NamedNodeMap: 0, NodeList: 1, PaintRequestList: 0, Plugin: 0, PluginArray: 0, SVGLengthList: 0, SVGNumberList: 0, SVGPathSegList: 0, SVGPointList: 0, SVGStringList: 0, SVGTransformList: 0, SourceBufferList: 0, StyleSheetList: 0, TextTrackCueList: 0, TextTrackList: 0, TouchList: 0 }
  }, function(e, t, n) {
    n(53); const o = n(184); const i = n(67); const r = Array.prototype; const a = { DOMTokenList: !0, NodeList: !0 }; e.exports = function(e) {
      const t = e.forEach; return e === r || e instanceof Array && t === r.forEach || a.hasOwnProperty(i(e)) ? o : t
    }
  }, function(e, t, n) {
    n = n(185); e.exports = n
  }, function(e, t, n) {
    n(186); n = n(14); e.exports = n('Array').forEach
  }, function(e, t, n) {
    'use strict'; const o = n(5); var n = n(187); o({ target: 'Array', proto: !0, forced: [].forEach != n }, { forEach: n })
  }, function(e, t, n) {
    'use strict'; const o = n(30).forEach; var n = n(70)('forEach'); e.exports = n
      ? [].forEach
      : function(e) {
        return o(this, e, arguments.length > 1 ? arguments[1] : void 0)
      }
  }, function(e, t, n) {
    n = n(189); e.exports = n
  }, function(e, t, n) {
    n(190); n = n(10); e.exports = n.Array.isArray
  }, function(e, t, n) {
    n(5)({ target: 'Array', stat: !0 }, { isArray: n(54) })
  }, function(e, t, n) {
    n = n(192); e.exports = n
  }, function(e, t, n) {
    const o = n(193); const i = Array.prototype; e.exports = function(e) {
      const t = e.map; return e === i || e instanceof Array && t === i.map ? o : t
    }
  }, function(e, t, n) {
    n(194); n = n(14); e.exports = n('Array').map
  }, function(e, t, n) {
    'use strict'; const o = n(5); const i = n(30).map; o({ target: 'Array', proto: !0, forced: !n(55)('map') }, {
      map: function(e) {
        return i(this, e, arguments.length > 1 ? arguments[1] : void 0)
      }
    })
  }, function(e, t, n) {
    n = n(196); e.exports = n
  }, function(e, t, n) {
    const o = n(197); const i = String.prototype; e.exports = function(e) {
      const t = e.trim; return typeof e === 'string' || e === i || e instanceof String && t === i.trim ? o : t
    }
  }, function(e, t, n) {
    n(198); n = n(14); e.exports = n('String').trim
  }, function(e, t, n) {
    'use strict'; const o = n(5); const i = n(93).trim; o({ target: 'String', proto: !0, forced: n(199)('trim') }, {
      trim: function() {
        return i(this)
      }
    })
  }, function(e, t, n) {
    const o = n(12); const i = n(71); e.exports = function(e) {
      return o(() => {
        return !!i[e]() || '​᠎'[e]() != '​᠎' || i[e].name !== e
      })
    }
  }, function(e, t, n) {
    n = n(201); e.exports = n
  }, function(e, t, n) {
    n(202), n(68), n(52), n(53); n = n(10); e.exports = n.Map
  }, function(e, t, n) {
    'use strict'; const o = n(121); var n = n(123); e.exports = o('Map', (e) => {
      return function() {
        return e(this, arguments.length ? arguments[0] : void 0)
      }
    }, n)
  }, function(e, t, n) {
    n = n(12); e.exports = !n(() => {
      return Object.isExtensible(Object.preventExtensions({}))
    })
  }, function(e, t, n) {
    n = n(205); e.exports = n
  }, function(e, t, n) {
    const o = n(206); const i = Array.prototype; e.exports = function(e) {
      const t = e.indexOf; return e === i || e instanceof Array && t === i.indexOf ? o : t
    }
  }, function(e, t, n) {
    n(207); n = n(14); e.exports = n('Array').indexOf
  }, function(e, t, n) {
    'use strict'; const o = n(5); const i = n(81).indexOf; var n = n(70); const r = [].indexOf; const a = !!r && 1 / [1].indexOf(1, -0) < 0; var n = n('indexOf'); o({ target: 'Array', proto: !0, forced: a || !n }, {
      indexOf: function(e) {
        return a ? r.apply(this, arguments) || 0 : i(this, e, arguments.length > 1 ? arguments[1] : void 0)
      }
    })
  }, function(e, t, n) {
    n = n(209); e.exports = n
  }, function(e, t, n) {
    const o = n(210); const i = Array.prototype; e.exports = function(e) {
      const t = e.splice; return e === i || e instanceof Array && t === i.splice ? o : t
    }
  }, function(e, t, n) {
    n(211); n = n(14); e.exports = n('Array').splice
  }, function(e, t, n) {
    'use strict'; const o = n(5); const f = n(82); const d = n(64); const p = n(34); const h = n(25); const A = n(91); const v = n(72); var n = n(55)('splice'); const m = Math.max; const g = Math.min; o({ target: 'Array', proto: !0, forced: !n }, {
      splice: function(e, t) {
        let n; let o; let i; let r; let a; let l; const u = h(this); const s = p(u.length); const c = f(e, s); var e = arguments.length; if (e === 0 ? n = o = 0 : o = e === 1 ? (n = 0, s - c) : (n = e - 2, g(m(d(t), 0), s - c)), s + n - o > 9007199254740991) throw TypeError('Maximum allowed length exceeded'); for (i = A(u, o), r = 0; r < o; r++)(a = c + r) in u && v(i, r, u[a]); if (n < (i.length = o)) {
          for (r = c; r < s - o; r++)l = r + n, (a = r + o) in u ? u[l] = u[a] : delete u[l]; for (r = s; s - o + n < r; r--) delete u[r - 1]
        } else if (o < n) for (r = s - o; c < r; r--)l = r + n - 1, (a = r + o - 1) in u ? u[l] = u[a] : delete u[l]; for (r = 0; r < n; r++)u[r + c] = arguments[r + 2]; return u.length = s - o + n, i
      }
    })
  }, function(e, t, n) {
    n = n(213); e.exports = n
  }, function(e, t, n) {
    const o = n(214); const i = Array.prototype; e.exports = function(e) {
      const t = e.filter; return e === i || e instanceof Array && t === i.filter ? o : t
    }
  }, function(e, t, n) {
    n(215); n = n(14); e.exports = n('Array').filter
  }, function(e, t, n) {
    'use strict'; const o = n(5); const i = n(30).filter; o({ target: 'Array', proto: !0, forced: !n(55)('filter') }, {
      filter: function(e) {
        return i(this, e, arguments.length > 1 ? arguments[1] : void 0)
      }
    })
  }, function(e, t, n) {
    n = n(217); e.exports = n
  }, function(e, t, n) {
    const o = n(218); const i = n(220); const r = Array.prototype; const a = String.prototype; e.exports = function(e) {
      const t = e.includes; return e === r || e instanceof Array && t === r.includes ? o : typeof e === 'string' || e === a || e instanceof String && t === a.includes ? i : t
    }
  }, function(e, t, n) {
    n(219); n = n(14); e.exports = n('Array').includes
  }, function(e, t, n) {
    'use strict'; const o = n(5); const i = n(81).includes; var n = n(90); o({ target: 'Array', proto: !0 }, {
      includes: function(e) {
        return i(this, e, arguments.length > 1 ? arguments[1] : void 0)
      }
    }), n('includes')
  }, function(e, t, n) {
    n(221); n = n(14); e.exports = n('String').includes
  }, function(e, t, n) {
    'use strict'; const o = n(5); const i = n(222); const r = n(48); o({ target: 'String', proto: !0, forced: !n(224)('includes') }, {
      includes: function(e) {
        return !!~String(r(this)).indexOf(i(e), arguments.length > 1 ? arguments[1] : void 0)
      }
    })
  }, function(e, t, n) {
    const o = n(223); e.exports = function(e) {
      if (o(e)) throw TypeError("The method doesn't accept regular expressions"); return e
    }
  }, function(e, t, n) {
    const o = n(13); const i = n(47); const r = n(11)('match'); e.exports = function(e) {
      let t; return o(e) && (void 0 !== (t = e[r]) ? !!t : i(e) == 'RegExp')
    }
  }, function(e, t, n) {
    const o = n(11)('match'); e.exports = function(t) {
      const n = /./; try {
        '/./'[t](n)
      } catch (e) {
        try {
          return n[o] = !1, '/./'[t](n)
        } catch (e) {}
      } return !1
    }
  }, function(e, t, n) {
    n = n(226); e.exports = n
  }, function(e, t, n) {
    const o = n(227); const i = Function.prototype; e.exports = function(e) {
      const t = e.bind; return e === i || e instanceof Function && t === i.bind ? o : t
    }
  }, function(e, t, n) {
    n(228); n = n(14); e.exports = n('Function').bind
  }, function(e, t, n) {
    n(5)({ target: 'Function', proto: !0 }, { bind: n(229) })
  }, function(e, t, n) {
    'use strict'; const r = n(33); const a = n(13); const l = [].slice; const u = {}; e.exports = Function.bind || function(t) {
      const n = r(this); const o = l.call(arguments, 1); var i = function() {
        const e = o.concat(l.call(arguments)); return this instanceof i
          ? (function(e, t, n) {
              if (!(t in u)) {
                for (var o = [], i = 0; i < t; i++)o[i] = `a[${i}]`; u[t] = Function('C,a', `return new C(${o.join(',')})`)
              } return u[t](e, n)
            }(n, e.length, e))
          : n.apply(t, e)
      }; return a(n.prototype) && (i.prototype = n.prototype), i
    }
  }, function(e, t, n) {
    e.exports = n(231)
  }, function(e, t, n) {
    const o = n(232); n(252), n(253), n(254), n(255), n(256), n(257), n(258), e.exports = o
  }, function(e, t, n) {
    n(233), n(68), n(234), n(236), n(237), n(238), n(239), n(126), n(240), n(241), n(242), n(243), n(244), n(245), n(246), n(247), n(248), n(249), n(250), n(251); n = n(10); e.exports = n.Symbol
  }, function(e, t, n) {
    'use strict'; const o = n(5); var i = n(12); const s = n(54); const c = n(13); const f = n(25); const d = n(34); const p = n(72); const h = n(91); var r = n(55); const a = n(11); var n = n(65); const A = a('isConcatSpreadable'); const v = 9007199254740991; const m = 'Maximum allowed index exceeded'; var i = n >= 51 || !i(() => {
      const e = []; return e[A] = !1, e.concat()[0] !== e
    }); var r = r('concat'); o({ target: 'Array', proto: !0, forced: !i || !r }, {
      concat: function(e) {
        for (var t, n, o, i = f(this), r = h(i, 0), a = 0, l = -1, u = arguments.length; l < u; l++) {
          if (function(e) {
            if (!c(e)) return !1; const t = e[A]; return void 0 !== t ? !!t : s(e)
          }(o = l === -1 ? i : arguments[l])) {
            if (n = d(o.length), v < a + n) throw TypeError(m); for (t = 0; t < n; t++, a++)t in o && p(r, a, o[t])
          } else {
            if (v <= a) throw TypeError(m); p(r, a++, o)
          }
        } return r.length = a, r
      }
    })
  }, function(e, t, n) {
    'use strict'; function o(e, t) {
      const n = Z[e] = x(G[Y]); return z(n, { type: j, tag: e, description: t }), s || (n.description = t), n
    } function i(t, e) {
      v(t); const n = g(e); var e = _(n).concat(ue(n)); return O(e, (e) => {
        s && !le.call(n, e) || ae(t, e, n[e])
      }), t
    } const r = n(5); var a = n(8); const l = n(29); const u = n(39); var s = n(15); const c = n(84); var f = n(106); const d = n(12); const p = n(16); const h = n(54); const A = n(13); var v = n(20); const m = n(25); var g = n(28); const y = n(60); const w = n(37); var x = n(63); var _ = n(49); const E = n(124); const b = n(235); const C = n(125); const S = n(74); const D = n(18); const M = n(59); const N = n(17); const k = n(51); var T = n(78); var B = n(61); const I = n(50); const R = n(62); const P = n(11); const H = n(96); const F = n(9); const L = n(42); const Q = n(43); var O = n(30).forEach; const U = B('hidden'); var j = 'Symbol'; var Y = 'prototype'; var B = P('toPrimitive'); var z = Q.set; const $ = Q.getterFor(j); const V = Object[Y]; var G = a.Symbol; const J = l('JSON', 'stringify'); const K = S.f; const W = D.f; const q = b.f; const X = M.f; var Z = T('symbols'); const ee = T('op-symbols'); const te = T('string-to-symbol-registry'); const ne = T('symbol-to-string-registry'); var T = T('wks'); var a = a.QObject; let oe = !a || !a[Y] || !a[Y].findChild; const ie = s && d(() => {
      return x(W({}, 'a', {
        get: function() {
          return W(this, 'a', { value: 7 }).a
        }
      })).a != 7
    })
      ? function(e, t, n) {
        const o = K(V, t); o && delete V[t], W(e, t, n), o && e !== V && W(V, t, o)
      }
      : W; const re = f
      ? function(e) {
        return typeof e === 'symbol'
      }
      : function(e) {
        return Object(e) instanceof G
      }; var ae = function(e, t, n) {
      e === V && ae(ee, t, n), v(e); t = y(t, !0); return v(n), p(Z, t) ? (n.enumerable ? (p(e, U) && e[U][t] && (e[U][t] = !1), n = x(n, { enumerable: w(0, !1) })) : (p(e, U) || W(e, U, w(1, {})), e[U][t] = !0), ie(e, t, n)) : W(e, t, n)
    }; var le = function(e) {
      const t = y(e, !0); var e = X.call(this, t); return !(this === V && p(Z, t) && !p(ee, t)) && (!(e || !p(this, t) || !p(Z, t) || p(this, U) && this[U][t]) || e)
    }; var a = function(e, t) {
      const n = g(e); var e = y(t, !0); if (n !== V || !p(Z, e) || p(ee, e)) {
        t = K(n, e); return !t || !p(Z, e) || p(n, U) && n[U][e] || (t.enumerable = !0), t
      }
    }; var f = function(e) {
      var e = q(g(e)); const t = []; return O(e, (e) => {
        p(Z, e) || p(I, e) || t.push(e)
      }), t
    }; var ue = function(e) {
      const t = e === V; var e = q(t ? ee : g(e)); const n = []; return O(e, (e) => {
        !p(Z, e) || t && !p(V, e) || n.push(Z[e])
      }), n
    }; c || (k((G = function() {
      if (this instanceof G) throw TypeError('Symbol is not a constructor'); const e = arguments.length && void 0 !== arguments[0] ? String(arguments[0]) : void 0; const t = R(e); var n = function(e) {
        this === V && n.call(ee, e), p(this, U) && p(this[U], t) && (this[U][t] = !1), ie(this, t, w(1, e))
      }; return s && oe && ie(V, t, { configurable: !0, set: n }), o(t, e)
    })[Y], 'toString', function() {
      return $(this).tag
    }), k(G, 'withoutSetter', (e) => {
      return o(R(e), e)
    }), M.f = le, D.f = ae, S.f = a, E.f = b.f = f, C.f = ue, H.f = function(e) {
      return o(P(e), e)
    }, s && (W(G[Y], 'description', {
      configurable: !0,
      get: function() {
        return $(this).description
      }
    }), u || k(V, 'propertyIsEnumerable', le, { unsafe: !0 }))), r({ global: !0, wrap: !0, forced: !c, sham: !c }, { Symbol: G }), O(_(T), (e) => {
      F(e)
    }), r({ target: j, stat: !0, forced: !c }, {
      for: function(e) {
        const t = String(e); if (p(te, t)) return te[t]; e = G(t); return te[t] = e, ne[e] = t, e
      },
      keyFor: function(e) {
        if (!re(e)) throw TypeError(`${e} is not a symbol`); if (p(ne, e)) return ne[e]
      },
      useSetter: function() {
        oe = !0
      },
      useSimple: function() {
        oe = !1
      }
    }), r({ target: 'Object', stat: !0, forced: !c, sham: !s }, {
      create: function(e, t) {
        return void 0 === t ? x(e) : i(x(e), t)
      },
      defineProperty: ae,
      defineProperties: i,
      getOwnPropertyDescriptor: a
    }), r({ target: 'Object', stat: !0, forced: !c }, { getOwnPropertyNames: f, getOwnPropertySymbols: ue }), r({
      target: 'Object',
      stat: !0,
      forced: d(() => {
        C.f(1)
      })
    }, {
      getOwnPropertySymbols: function(e) {
        return C.f(m(e))
      }
    }), J && r({
      target: 'JSON',
      stat: !0,
      forced: !c || d(() => {
        const e = G(); return J([e]) != '[null]' || J({ a: e }) != '{}' || J(Object(e)) != '{}'
      })
    }, {
      stringify: function(e, t, n) {
        for (var o, i = [e], r = 1; r < arguments.length;)i.push(arguments[r++]); if ((A(o = t) || void 0 !== e) && !re(e)) {
          return h(t) || (t = function(e, t) {
            if (typeof o === 'function' && (t = o.call(this, e, t)), !re(t)) return t
          }), i[1] = t, J.apply(null, i)
        }
      }
    }), G[Y][B] || N(G[Y], B, G[Y].valueOf), L(G, j), I[U] = !0
  }, function(e, t, n) {
    const o = n(28); const i = n(124).f; const r = {}.toString; const a = typeof window === 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : []; e.exports.f = function(e) {
      return a && r.call(e) == '[object Window]'
        ? (function(e) {
            try {
              return i(e)
            } catch (e) {
              return a.slice()
            }
          }(e))
        : i(o(e))
    }
  }, function(e, t, n) {
    n(9)('asyncIterator')
  }, function(e, t) {}, function(e, t, n) {
    n(9)('hasInstance')
  }, function(e, t, n) {
    n(9)('isConcatSpreadable')
  }, function(e, t, n) {
    n(9)('match')
  }, function(e, t, n) {
    n(9)('matchAll')
  }, function(e, t, n) {
    n(9)('replace')
  }, function(e, t, n) {
    n(9)('search')
  }, function(e, t, n) {
    n(9)('species')
  }, function(e, t, n) {
    n(9)('split')
  }, function(e, t, n) {
    n(9)('toPrimitive')
  }, function(e, t, n) {
    n(9)('toStringTag')
  }, function(e, t, n) {
    n(9)('unscopables')
  }, function(e, t, n) {
    const o = n(8); n(42)(o.JSON, 'JSON', !0)
  }, function(e, t) {}, function(e, t) {}, function(e, t, n) {
    n(9)('asyncDispose')
  }, function(e, t, n) {
    n(9)('dispose')
  }, function(e, t, n) {
    n(9)('matcher')
  }, function(e, t, n) {
    n(9)('metadata')
  }, function(e, t, n) {
    n(9)('observable')
  }, function(e, t, n) {
    n(9)('patternMatch')
  }, function(e, t, n) {
    n(9)('replaceAll')
  }, function(e, t, n) {
    e.exports = n(260)
  }, function(e, t, n) {
    n = n(261); e.exports = n
  }, function(e, t, n) {
    n(126), n(52), n(53); n = n(96); e.exports = n.f('iterator')
  }, function(e, t, n) {
    e.exports = n(263)
  }, function(e, t, n) {
    n = n(264); e.exports = n
  }, function(e, t, n) {
    n(265); n = n(10); e.exports = n.parseInt
  }, function(e, t, n) {
    const o = n(5); var n = n(266); o({ global: !0, forced: parseInt != n }, { parseInt: n })
  }, function(e, t, n) {
    const o = n(8); const i = n(93).trim; var n = n(71); const r = o.parseInt; const a = /^[+-]?0[Xx]/; var n = r(`${n}08`) !== 8 || r(`${n}0x16`) !== 22; e.exports = n
      ? function(e, t) {
        e = i(String(e)); return r(e, t >>> 0 || (a.test(e) ? 16 : 10))
      }
      : r
  }, function(e, t, n) {
    n = n(268); e.exports = n
  }, function(e, t, n) {
    const o = n(269); const i = Array.prototype; e.exports = function(e) {
      const t = e.slice; return e === i || e instanceof Array && t === i.slice ? o : t
    }
  }, function(e, t, n) {
    n(270); n = n(14); e.exports = n('Array').slice
  }, function(e, t, n) {
    'use strict'; const o = n(5); const s = n(13); const c = n(54); const f = n(82); const d = n(34); const p = n(28); const h = n(72); const i = n(11); var n = n(55)('slice'); const A = i('species'); const v = [].slice; const m = Math.max; o({ target: 'Array', proto: !0, forced: !n }, {
      slice: function(e, t) {
        let n; let o; let i; const r = p(this); const a = d(r.length); let l = f(e, a); const u = f(void 0 === t ? a : t, a); if (c(r) && ((n = typeof (n = r.constructor) === 'function' && (n === Array || c(n.prototype)) || s(n) && (n = n[A]) === null ? void 0 : n) === Array || void 0 === n)) return v.call(r, l, u); for (o = new (void 0 === n ? Array : n)(m(u - l, 0)), i = 0; l < u; l++, i++)l in r && h(o, i, r[l]); return o.length = i, o
      }
    })
  }, function(e, t, n) {
    n(272); n = n(10); e.exports = n.setTimeout
  }, function(e, t, n) {
    const o = n(5); const i = n(8); const r = n(66); const a = [].slice; var n = function(i) {
      return function(e, t) {
        const n = arguments.length > 2; const o = n ? a.call(arguments, 2) : void 0; return i(n
          ? function() {
            (typeof e === 'function' ? e : Function(e)).apply(this, o)
          }
          : e, t)
      }
    }; o({ global: !0, bind: !0, forced: /MSIE .\./.test(r) }, { setTimeout: n(i.setTimeout), setInterval: n(i.setInterval) })
  }, function(e, t, n) {
    'use strict'; var o = n(0); var i = o(n(1)); const r = o(n(274)); (0, i.default)(t, '__esModule', { value: !0 }); const a = n(2); const l = a.__importDefault(n(279)); const u = a.__importDefault(n(280)); const s = a.__importDefault(n(127)); const c = a.__importDefault(n(281)); const f = a.__importDefault(n(282)); const d = a.__importDefault(n(283)); const p = a.__importDefault(n(128)); var o = a.__importDefault(n(284)); var i = a.__importDefault(n(285)); var n = a.__importDefault(n(286)); var n = (0, r.default)({}, l.default, u.default, s.default, f.default, c.default, d.default, p.default, o.default, i.default, n.default, {
      linkCheck: function(e, t) {
        return !0
      }
    }); t.default = n
  }, function(e, t, n) {
    e.exports = n(275)
  }, function(e, t, n) {
    n = n(276); e.exports = n
  }, function(e, t, n) {
    n(277); n = n(10); e.exports = n.Object.assign
  }, function(e, t, n) {
    const o = n(5); var n = n(278); o({ target: 'Object', stat: !0, forced: Object.assign !== n }, { assign: n })
  }, function(e, t, n) {
    'use strict'; const d = n(15); const o = n(12); const p = n(49); const h = n(125); const A = n(59); const v = n(25); const m = n(75); const i = Object.assign; const r = Object.defineProperty; e.exports = !i || o(() => {
      if (d && i({ b: 1 }, i(r({}, 'a', {
        enumerable: !0,
        get: function() {
          r(this, 'b', { value: 3, enumerable: !1 })
        }
      }), { b: 2 })).b !== 1) return !0; const e = {}; const t = {}; const n = Symbol(); const o = 'abcdefghijklmnopqrst'; return e[n] = 7, o.split('').forEach((e) => {
        t[e] = e
      }), i({}, e)[n] != 7 || p(i({}, t)).join('') != o
    })
      ? function(e, t) {
        for (var n = v(e), o = arguments.length, i = 1, r = h.f, a = A.f; i < o;) for (var l, u = m(arguments[i++]), s = r ? p(u).concat(r(u)) : p(u), c = s.length, f = 0; f < c;)l = s[f++], d && !a.call(u, l) || (n[l] = u[l]); return n
      }
      : i
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }), t.default = { menus: ['head', 'bold', 'fontSize', 'fontName', 'italic', 'underline', 'strikeThrough', 'indent', 'lineHeight', 'foreColor', 'backColor', 'link', 'list', 'todo', 'justify', 'quote', 'emoticon', 'image', 'video', 'table', 'code', 'splitLine', 'undo', 'redo'], fontNames: ['黑体', '仿宋', '楷体', '标楷体', '华文仿宋', '华文楷体', '宋体', '微软雅黑', 'Arial', 'Tahoma', 'Verdana', 'Times New Roman', 'Courier New'], fontSizes: { 'x-small': { name: '10px', value: '1' }, small: { name: '13px', value: '2' }, normal: { name: '16px', value: '3' }, large: { name: '18px', value: '4' }, 'x-large': { name: '24px', value: '5' }, 'xx-large': { name: '32px', value: '6' }, 'xxx-large': { name: '48px', value: '7' } }, colors: ['#000000', '#ffffff', '#eeece0', '#1c487f', '#4d80bf', '#c24f4a', '#8baa4a', '#7b5ba1', '#46acc8', '#f9963b'], languageType: ['Bash', 'C', 'C#', 'C++', 'CSS', 'Java', 'JavaScript', 'JSON', 'TypeScript', 'Plain text', 'Html', 'XML', 'SQL', 'Go', 'Kotlin', 'Lua', 'Markdown', 'PHP', 'Python', 'Shell Session', 'Ruby'], languageTab: '　　　　', emotions: [{ title: '表情', type: 'emoji', content: '😀 😃 😄 😁 😆 😅 😂 🤣 😊 😇 🙂 🙃 😉 😌 😍 😘 😗 😙 😚 😋 😛 😝 😜 🤓 😎 😏 😒 😞 😔 😟 😕 🙁 😣 😖 😫 😩 😢 😭 😤 😠 😡 😳 😱 😨 🤗 🤔 😶 😑 😬 🙄 😯 😴 😷 🤑 😈 🤡 💩 👻 💀 👀 👣'.split(/\s/) }, { title: '手势', type: 'emoji', content: '👐 🙌 👏 🤝 👍 👎 👊 ✊ 🤛 🤜 🤞 ✌️ 🤘 👌 👈 👉 👆 👇 ☝️ ✋ 🤚 🖐 🖖 👋 🤙 💪 🖕 ✍️ 🙏'.split(/\s/) }], lineHeights: ['1', '1.15', '1.6', '2', '2.5', '3'], undoLimit: 20, indentation: '2em', showMenuTooltips: !0, menuTooltipPosition: 'up' }
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); n = n(7); t.default = {
      onchangeTimeout: 200,
      onchange: null,
      onfocus: n.EMPTY_FN,
      onblur: n.EMPTY_FN,
      onCatalogChange: null,
      customAlert: function(e, t, n) {
        window.alert(e), n && console.error(`wangEditor: ${n}`)
      }
    }
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }), t.default = {
      pasteFilterStyle: !0,
      pasteIgnoreImg: !1,
      pasteTextHandle: function(e) {
        return e
      }
    }
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }), t.default = { styleWithCSS: !1 }
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); n = n(7); t.default = {
      linkImgCheck: function(e, t, n) {
        return !0
      },
      showLinkImg: !0,
      showLinkImgAlt: !0,
      showLinkImgHref: !0,
      linkImgCallback: n.EMPTY_FN,
      uploadImgAccept: ['jpg', 'jpeg', 'png', 'gif', 'bmp'],
      uploadImgServer: '',
      uploadImgShowBase64: !1,
      uploadImgMaxSize: 5242880,
      uploadImgMaxLength: 100,
      uploadFileName: '',
      uploadImgParams: {},
      uploadImgParamsWithUrl: !1,
      uploadImgHeaders: {},
      uploadImgHooks: {},
      uploadImgTimeout: 1e4,
      withCredentials: !1,
      customUploadImg: null,
      uploadImgFromMedia: null
    }
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }), t.default = { lang: 'zh-CN', languages: { 'zh-CN': { wangEditor: { 重置: '重置', 插入: '插入', 默认: '默认', 创建: '创建', 修改: '修改', 如: '如', 请输入正文: '请输入正文', menus: { title: { 标题: '标题', 加粗: '加粗', 字号: '字号', 字体: '字体', 斜体: '斜体', 下划线: '下划线', 删除线: '删除线', 缩进: '缩进', 行高: '行高', 文字颜色: '文字颜色', 背景色: '背景色', 链接: '链接', 序列: '序列', 对齐: '对齐', 引用: '引用', 表情: '表情', 图片: '图片', 视频: '视频', 表格: '表格', 代码: '代码', 分割线: '分割线', 恢复: '恢复', 撤销: '撤销', 全屏: '全屏', 取消全屏: '取消全屏', 待办事项: '待办事项' }, dropListMenu: { 设置标题: '设置标题', 背景颜色: '背景颜色', 文字颜色: '文字颜色', 设置字号: '设置字号', 设置字体: '设置字体', 设置缩进: '设置缩进', 对齐方式: '对齐方式', 设置行高: '设置行高', 序列: '序列', head: { 正文: '正文' }, indent: { 增加缩进: '增加缩进', 减少缩进: '减少缩进' }, justify: { 靠左: '靠左', 居中: '居中', 靠右: '靠右', 两端: '两端' }, list: { 无序列表: '无序列表', 有序列表: '有序列表' } }, panelMenus: { emoticon: { 默认: '默认', 新浪: '新浪', emoji: 'emoji', 手势: '手势' }, image: { 上传图片: '上传图片', 网络图片: '网络图片', 图片地址: '图片地址', 图片文字说明: '图片文字说明', 跳转链接: '跳转链接' }, link: { 链接: '链接', 链接文字: '链接文字', 取消链接: '取消链接', 查看链接: '查看链接' }, video: { 插入视频: '插入视频', 上传视频: '上传视频' }, table: { 行: '行', 列: '列', 的: '的', 表格: '表格', 添加行: '添加行', 删除行: '删除行', 添加列: '添加列', 删除列: '删除列', 设置表头: '设置表头', 取消表头: '取消表头', 插入表格: '插入表格', 删除表格: '删除表格' }, code: { 删除代码: '删除代码', 修改代码: '修改代码', 插入代码: '插入代码' } } }, validate: { 张图片: '张图片', 大于: '大于', 图片链接: '图片链接', 不是图片: '不是图片', 返回结果: '返回结果', 上传图片超时: '上传图片超时', 上传图片错误: '上传图片错误', 上传图片失败: '上传图片失败', 插入图片错误: '插入图片错误', 一次最多上传: '一次最多上传', 下载链接失败: '下载链接失败', 图片验证未通过: '图片验证未通过', 服务器返回状态: '服务器返回状态', 上传图片返回结果错误: '上传图片返回结果错误', 请替换为支持的图片类型: '请替换为支持的图片类型', 您插入的网络图片无法识别: '您插入的网络图片无法识别', 您刚才插入的图片链接未通过编辑器校验: '您刚才插入的图片链接未通过编辑器校验', 插入视频错误: '插入视频错误', 视频链接: '视频链接', 不是视频: '不是视频', 视频验证未通过: '视频验证未通过', 个视频: '个视频', 上传视频超时: '上传视频超时', 上传视频错误: '上传视频错误', 上传视频失败: '上传视频失败', 上传视频返回结果错误: '上传视频返回结果错误' } } }, en: { wangEditor: { 重置: 'reset', 插入: 'insert', 默认: 'default', 创建: 'create', 修改: 'edit', 如: 'like', 请输入正文: 'please enter the text', menus: { title: { 标题: 'head', 加粗: 'bold', 字号: 'font size', 字体: 'font family', 斜体: 'italic', 下划线: 'underline', 删除线: 'strikethrough', 缩进: 'indent', 行高: 'line heihgt', 文字颜色: 'font color', 背景色: 'background', 链接: 'link', 序列: 'numbered list', 对齐: 'align', 引用: 'quote', 表情: 'emoticons', 图片: 'image', 视频: 'media', 表格: 'table', 代码: 'code', 分割线: 'split line', 恢复: 'undo', 撤销: 'redo', 全屏: 'fullscreen', 取消全屏: 'cancel fullscreen', 待办事项: 'todo' }, dropListMenu: { 设置标题: 'title', 背景颜色: 'background', 文字颜色: 'font color', 设置字号: 'font size', 设置字体: 'font family', 设置缩进: 'indent', 对齐方式: 'align', 设置行高: 'line heihgt', 序列: 'list', head: { 正文: 'text' }, indent: { 增加缩进: 'indent', 减少缩进: 'outdent' }, justify: { 靠左: 'left', 居中: 'center', 靠右: 'right', 两端: 'justify' }, list: { 无序列表: 'unordered', 有序列表: 'ordered' } }, panelMenus: { emoticon: { 表情: 'emoji', 手势: 'gesture' }, image: { 上传图片: 'upload image', 网络图片: 'network image', 图片地址: 'image link', 图片文字说明: 'image alt', 跳转链接: 'hyperlink' }, link: { 链接: 'link', 链接文字: 'link text', 取消链接: 'unlink', 查看链接: 'view links' }, video: { 插入视频: 'insert video', 上传视频: 'upload local video' }, table: { 行: 'rows', 列: 'columns', 的: ' ', 表格: 'table', 添加行: 'insert row', 删除行: 'delete row', 添加列: 'insert column', 删除列: 'delete column', 设置表头: 'set header', 取消表头: 'cancel header', 插入表格: 'insert table', 删除表格: 'delete table' }, code: { 删除代码: 'delete code', 修改代码: 'edit code', 插入代码: 'insert code' } } }, validate: { 张图片: 'images', 大于: 'greater than', 图片链接: 'image link', 不是图片: 'is not image', 返回结果: 'return results', 上传图片超时: 'upload image timeout', 上传图片错误: 'upload image error', 上传图片失败: 'upload image failed', 插入图片错误: 'insert image error', 一次最多上传: 'once most at upload', 下载链接失败: 'download link failed', 图片验证未通过: 'image validate failed', 服务器返回状态: 'server return status', 上传图片返回结果错误: 'upload image return results error', 请替换为支持的图片类型: 'please replace with a supported image type', 您插入的网络图片无法识别: 'the network picture you inserted is not recognized', 您刚才插入的图片链接未通过编辑器校验: 'the image link you just inserted did not pass the editor verification', 插入视频错误: 'insert video error', 视频链接: 'video link', 不是视频: 'is not video', 视频验证未通过: 'video validate failed', 个视频: 'videos', 上传视频超时: 'upload video timeout', 上传视频错误: 'upload video error', 上传视频失败: 'upload video failed', 上传视频返回结果错误: 'upload video return results error' } } } } }
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); const o = n(6); t.default = {
      compatibleMode: function() {
        return !(!o.UA.isIE() && !o.UA.isOldEdge)
      },
      historyMaxSize: 30
    }
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); n = n(7); t.default = {
      onlineVideoCheck: function(e) {
        return !0
      },
      onlineVideoCallback: n.EMPTY_FN,
      showLinkVideo: !0,
      uploadVideoAccept: ['mp4'],
      uploadVideoServer: '',
      uploadVideoMaxSize: 1073741824,
      uploadVideoName: '',
      uploadVideoParams: {},
      uploadVideoParamsWithUrl: !1,
      uploadVideoHeaders: {},
      uploadVideoHooks: {},
      uploadVideoTimeout: 72e5,
      withVideoCredentials: !1,
      customUploadVideo: null,
      customInsertVideo: null
    }
  }, function(e, t, n) {
    'use strict'; const o = n(0); const i = o(n(1)); const r = o(n(19)); (0, i.default)(t, '__esModule', { value: !0 }); const l = n(2).__importDefault(n(3)); const a = n(6); const u = n(7); var n = (s.prototype.getRange = function() {
      return this._currentRange
    }, s.prototype.saveRange = function(e) {
      let t; let n; let o; e ? this._currentRange = e : (o = window.getSelection()).rangeCount !== 0 && (t = o.getRangeAt(0), (n = this.getSelectionContainerElem(t)) != null && n.length && (n.attr('contenteditable') === 'false' || n.parentUntil('[contenteditable=false]') || (o = (e = this.editor).$textElem).isContain(n) && (o.elems[0] === n.elems[0] && (0, r.default)(n = o.html()).call(n) === u.EMPTY_P && (o = (o = o.children()) == null ? void 0 : o.last(), e.selection.createRangeByElem(o, !0, !0), e.selection.restoreSelection()), this._currentRange = t)))
    }, s.prototype.collapseRange = function(e) {
      void 0 === e && (e = !1); const t = this._currentRange; t && t.collapse(e)
    }, s.prototype.getSelectionText = function() {
      const e = this._currentRange; return e ? e.toString() : ''
    }, s.prototype.getSelectionContainerElem = function(e) {
      var e = e || this._currentRange; if (e) return e = e.commonAncestorContainer, l.default(e.nodeType === 1 ? e : e.parentNode)
    }, s.prototype.getSelectionStartElem = function(e) {
      var e = e || this._currentRange; if (e) return e = e.startContainer, l.default(e.nodeType === 1 ? e : e.parentNode)
    }, s.prototype.getSelectionEndElem = function(e) {
      var e = e || this._currentRange; if (e) return e = e.endContainer, l.default(e.nodeType === 1 ? e : e.parentNode)
    }, s.prototype.isSelectionEmpty = function() {
      const e = this._currentRange; return !(!e || !e.startContainer || e.startContainer !== e.endContainer || e.startOffset !== e.endOffset)
    }, s.prototype.restoreSelection = function() {
      const e = window.getSelection(); const t = this._currentRange; e && t && (e.removeAllRanges(), e.addRange(t))
    }, s.prototype.createEmptyRange = function() {
      let e; const t = this.editor; const n = this.getRange(); if (n && this.isSelectionEmpty()) {
        try {
          a.UA.isWebkit() ? (t.cmd.do('insertHTML', '&#8203;'), n.setEnd(n.endContainer, n.endOffset + 1), this.saveRange(n)) : (e = l.default('<strong>&#8203;</strong>'), t.cmd.do('insertElem', e), this.createRangeByElem(e, !0))
        } catch (e) {}
      }
    }, s.prototype.createRangeByElems = function(e, t) {
      let n = (window.getSelection ? window : document).getSelection(); n != null && n.removeAllRanges(); n = document.createRange(); n.setStart(e, 0), n.setEnd(t, t.childNodes.length || 1), this.saveRange(n), this.restoreSelection()
    }, s.prototype.createRangeByElem = function(e, t, n) {
      let o; e.length && (o = e.elems[0], e = document.createRange(), n ? e.selectNodeContents(o) : e.selectNode(o), t != null && (e.collapse(t), t || (this.saveRange(e), this.editor.selection.moveCursor(o))), this.saveRange(e))
    }, s.prototype.getSelectionRangeTopNodes = function() {
      const e = (t = this.getSelectionStartElem()) === null || void 0 === t ? void 0 : t.getNodeTop(this.editor); var t = (t = this.getSelectionEndElem()) === null || void 0 === t ? void 0 : t.getNodeTop(this.editor); return this.recordSelectionNodes(l.default(e), l.default(t))
    }, s.prototype.moveCursor = function(e, t) {
      const n = this.getRange(); var o = e.nodeType === 3 ? (o = e.nodeValue) === null || void 0 === o ? void 0 : o.length : e.childNodes.length; (a.UA.isFirefox || a.UA.isIE()) && o !== 0 && (e.nodeType !== 3 && e.childNodes[o - 1].nodeName !== 'BR' || (o -= 1)); o = t != null ? t : o; n && e && (n.setStart(e, o), n.setEnd(e, o), this.restoreSelection())
    }, s.prototype.getCursorPos = function() {
      const e = window.getSelection(); return e == null ? void 0 : e.anchorOffset
    }, s.prototype.clearWindowSelectionRange = function() {
      const e = window.getSelection(); e && e.removeAllRanges()
    }, s.prototype.recordSelectionNodes = function(e, t) {
      const n = []; let o = !0; try {
        for (let i = e, r = this.editor.$textElem; o;) {
          const a = i == null ? void 0 : i.getNodeTop(this.editor); a.getNodeName() === 'BODY' && (o = !1), a.length > 0 && (n.push(l.default(i)), t != null && t.equal(a) || r.equal(a) ? o = !1 : i = a.getNextSibling())
        }
      } catch (e) {
        o = !1
      } return n
    }, s.prototype.setRangeToElem = function(e) {
      const t = this.getRange(); t != null && t.setStart(e, 0), t != null && t.setEnd(e, 0)
    }, s); function s(e) {
      this._currentRange = null, this.editor = e
    }t.default = n
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); const i = n(2).__importDefault(n(3)); var n = (o.prototype.do = function(e, t) {
      const n = this.editor; n.config.styleWithCSS && document.execCommand('styleWithCSS', !1, 'true'); const o = n.selection; if (o.getRange()) {
        switch (o.restoreSelection(), e) {
          case 'insertHTML':this.insertHTML(t); break; case 'insertElem':this.insertElem(t); break; default:this.execCommand(e, t)
        }n.menus.changeActive(), o.saveRange(), o.restoreSelection()
      }
    }, o.prototype.insertHTML = function(e) {
      let t; const n = this.editor; const o = n.selection.getRange(); o != null && (this.queryCommandSupported('insertHTML') ? this.execCommand('insertHTML', e) : o.insertNode && (o.deleteContents(), i.default(e).elems.length > 0 ? o.insertNode(i.default(e).elems[0]) : ((t = document.createElement('p')).appendChild(document.createTextNode(e)), o.insertNode(t)), n.selection.collapseRange()))
    }, o.prototype.insertElem = function(e) {
      const t = this.editor.selection.getRange(); t != null && t.insertNode && (t.deleteContents(), t.insertNode(e.elems[0]))
    }, o.prototype.execCommand = function(e, t) {
      document.execCommand(e, !1, t)
    }, o.prototype.queryCommandValue = function(e) {
      return document.queryCommandValue(e)
    }, o.prototype.queryCommandState = function(e) {
      return document.queryCommandState(e)
    }, o.prototype.queryCommandSupported = function(e) {
      return document.queryCommandSupported(e)
    }, o); function o(e) {
      this.editor = e
    }t.default = n
  }, function(e, t, n) {
    'use strict'; const o = n(0); var i = o(n(1)); const r = o(n(31)); const a = o(n(4)); const l = o(n(19)); const u = o(n(27)); const s = o(n(45)); (0, i.default)(t, '__esModule', { value: !0 }); var i = n(2); const c = i.__importDefault(n(3)); const f = i.__importDefault(n(294)); const d = n(6); const p = i.__importDefault(n(306)); const h = i.__importDefault(n(307)); const A = n(7); var n = (v.prototype.init = function() {
      this._saveRange(), this._bindEventHooks(), f.default(this)
    }, v.prototype.togglePlaceholder = function() {
      const e = this.html(); var t = (0, r.default)(t = this.editor.$textContainerElem).call(t, '.placeholder'); t.hide(), this.editor.isComposing || e && e !== ' ' || t.show()
    }, v.prototype.clear = function() {
      this.html(A.EMPTY_P)
    }, v.prototype.html = function(e) {
      const t = this.editor; const n = t.$textElem; if (e == null) {
        let o = n.html(); const i = (o = (o = (o = (o = o.replace(/\u200b/gm, '')).replace(/<p><\/p>/gim, '')).replace(A.EMPTY_P_LAST_REGEX, '')).replace(A.EMPTY_P_REGEX, '<p>')).match(/<(img|br|hr|input)[^>]*>/gi); return i !== null && (0, a.default)(i).call(i, (e) => {
          e.match(/\/>/) || (o = o.replace(e, `${e.substring(0, e.length - 1)}/>`))
        }), o
      }(e = (0, l.default)(e).call(e)) === '' && (e = A.EMPTY_P), (0, u.default)(e).call(e, '<') !== 0 && (e = `<p>${e}</p>`), n.html(e), t.initSelection()
    }, v.prototype.setJSON = function(e) {
      const t = h.default(e).children(); var e = this.editor.$textElem; t && e.replaceChildAll(t)
    }, v.prototype.getJSON = function() {
      const e = this.editor.$textElem; return p.default(e)
    }, v.prototype.text = function(e) {
      const t = this.editor; const n = t.$textElem; if (e == null) return n.text().replace(/\u200b/gm, ''); n.text(`<p>${e}</p>`), t.initSelection()
    }, v.prototype.append = function(e) {
      const t = this.editor; (0, u.default)(e).call(e, '<') !== 0 && (e = `<p>${e}</p>`), this.html(this.html() + e), t.initSelection()
    }, v.prototype._saveRange = function() {
      const t = this.editor; const n = t.$textElem; const e = c.default(document); function o() {
        t.selection.saveRange(), t.menus.changeActive()
      } function i() {
        o(), e.off('mouseup', i)
      } function r() {
        e.on('mouseup', i), n.off('mouseleave', r)
      }n.on('keyup', o), n.on('click', function e() {
        o(), n.off('click', e)
      }), n.on('mousedown', () => {
        n.on('mouseleave', r)
      }), n.on('mouseup', (e) => {
        n.off('mouseleave', r), (0, s.default)(() => {
          t.selection.getRange() !== null && o()
        }, 0)
      })
    }, v.prototype._bindEventHooks = function() {
      const n = this.editor; const e = n.$textElem; const o = this.eventHooks; function t(e) {
        e.preventDefault()
      }e.on('click', (t) => {
        const e = o.clickEvents; (0, a.default)(e).call(e, (e) => {
          return e(t)
        })
      }), e.on('keyup', (t) => {
        let e; t.keyCode === 13 && (e = o.enterUpEvents, (0, a.default)(e).call(e, (e) => {
          return e(t)
        }))
      }), e.on('keyup', (t) => {
        const e = o.keyupEvents; (0, a.default)(e).call(e, (e) => {
          return e(t)
        })
      }), e.on('keydown', (t) => {
        const e = o.keydownEvents; (0, a.default)(e).call(e, (e) => {
          return e(t)
        })
      }), e.on('keyup', (t) => {
        let e; t.keyCode !== 8 && t.keyCode !== 46 || (e = o.deleteUpEvents, (0, a.default)(e).call(e, (e) => {
          return e(t)
        }))
      }), e.on('keydown', (t) => {
        let e; t.keyCode !== 8 && t.keyCode !== 46 || (e = o.deleteDownEvents, (0, a.default)(e).call(e, (e) => {
          return e(t)
        }))
      }), e.on('paste', (t) => {
        let e; d.UA.isIE() || (t.preventDefault(), e = o.pasteEvents, (0, a.default)(e).call(e, (e) => {
          return e(t)
        }))
      }), e.on('keydown', (e) => {
        (n.isFocus || n.isCompatibleMode) && (e.ctrlKey || e.metaKey) && e.keyCode === 90 && (e.preventDefault(), e.shiftKey ? n.history.restore() : n.history.revoke())
      }), e.on('keyup', (t) => {
        let e; t.keyCode === 9 && (t.preventDefault(), e = o.tabUpEvents, (0, a.default)(e).call(e, (e) => {
          return e(t)
        }))
      }), e.on('keydown', (t) => {
        let e; t.keyCode === 9 && (t.preventDefault(), e = o.tabDownEvents, (0, a.default)(e).call(e, (e) => {
          return e(t)
        }))
      }), e.on('scroll', d.throttle((t) => {
        const e = o.textScrollEvents; (0, a.default)(e).call(e, (e) => {
          return e(t)
        })
      }, 100)), c.default(document).on('dragleave', t)
        .on('drop', t)
        .on('dragenter', t)
        .on('dragover', t), n.beforeDestroy(() => {
        c.default(document).off('dragleave', t)
          .off('drop', t)
          .off('dragenter', t)
          .off('dragover', t)
      }), e.on('drop', (t) => {
        t.preventDefault(); const e = o.dropEvents; (0, a.default)(e).call(e, (e) => {
          return e(t)
        })
      }), e.on('click', (e) => {
        let t; let n = null; var e = e.target; var e = c.default(e); e.getNodeName() === 'A' ? n = e : (t = e.parentUntil('a')) != null && (n = t), n && (t = o.linkClickEvents, (0, a.default)(t).call(t, (e) => {
          return e(n)
        }))
      }), e.on('click', (e) => {
        let t = null; var n = e.target; var n = c.default(n); n.getNodeName() !== 'IMG' || n.elems[0].getAttribute('data-emoji') || (e.stopPropagation(), t = n), t && (n = o.imgClickEvents, (0, a.default)(n).call(n, (e) => {
          return e(t)
        }))
      }), e.on('click', (e) => {
        let t; let n = null; var e = e.target; var e = c.default(e); e.getNodeName() === 'PRE' ? n = e : (t = e.parentUntil('pre')) !== null && (n = t), n && (t = o.codeClickEvents, (0, a.default)(t).call(t, (e) => {
          return e(n)
        }))
      }), e.on('click', (e) => {
        let t = null; var e = e.target; var e = c.default(e); (t = e.getNodeName() === 'HR' ? e : t) && (n.selection.createRangeByElem(t), n.selection.restoreSelection(), e = o.splitLineEvents, (0, a.default)(e).call(e, (e) => {
          return e(t)
        }))
      }), n.$toolbarElem.on('click', (t) => {
        const e = o.toolbarClickEvents; (0, a.default)(e).call(e, (e) => {
          return e(t)
        })
      }), n.$textContainerElem.on('mousedown', (e) => {
        e = e.target; c.default(e).hasClass('w-e-img-drag-rb') && (e = o.imgDragBarMouseDownEvents, (0, a.default)(e).call(e, (e) => {
          return e()
        }))
      }), e.on('click', (e) => {
        let t = null; var e = e.target; (t = c.default(e).parentUntilEditor('TABLE', n, e)) && (e = o.tableClickEvents, (0, a.default)(e).call(e, (e) => {
          return e(t)
        }))
      }), e.on('keydown', (t) => {
        let e; t.keyCode === 13 && (e = o.enterDownEvents, (0, a.default)(e).call(e, (e) => {
          return e(t)
        }))
      }), e.on('click', (e) => {
        let t = null; var n = e.target; var n = c.default(n); n.getNodeName() === 'VIDEO' && (e.stopPropagation(), t = n), t && (n = o.videoClickEvents, (0, a.default)(n).call(n, (e) => {
          return e(t)
        }))
      })
    }, v); function v(e) {
      this.editor = e, this.eventHooks = { onBlurEvents: [], changeEvents: [], dropEvents: [], clickEvents: [], keydownEvents: [], keyupEvents: [], tabUpEvents: [], tabDownEvents: [], enterUpEvents: [], enterDownEvents: [], deleteUpEvents: [], deleteDownEvents: [], pasteEvents: [], linkClickEvents: [], codeClickEvents: [], textScrollEvents: [], toolbarClickEvents: [], imgClickEvents: [], imgDragBarMouseDownEvents: [], tableClickEvents: [], menuClickEvents: [], dropListMenuHoverEvents: [], splitLineEvents: [], videoClickEvents: [] }
    }t.default = n
  }, function(e, t, n) {
    n = n(291); e.exports = n
  }, function(e, t, n) {
    const o = n(292); const i = Array.prototype; e.exports = function(e) {
      const t = e.find; return e === i || e instanceof Array && t === i.find ? o : t
    }
  }, function(e, t, n) {
    n(293); n = n(14); e.exports = n('Array').find
  }, function(e, t, n) {
    'use strict'; const o = n(5); const i = n(30).find; var n = n(90); let r = !0; 'find' in [] && Array(1).find(() => {
      r = !1
    }), o({ target: 'Array', proto: !0, forced: r }, {
      find: function(e) {
        return i(this, e, arguments.length > 1 ? arguments[1] : void 0)
      }
    }), n('find')
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); const o = n(2); const i = o.__importDefault(n(295)); const r = o.__importStar(n(296)); const a = o.__importDefault(n(297)); const l = o.__importDefault(n(298)); const u = o.__importDefault(n(305)); t.default = function(e) {
      const t = e.editor; var e = e.eventHooks; i.default(t, e.enterUpEvents, e.enterDownEvents), r.default(t, e.deleteUpEvents, e.deleteDownEvents), r.cutToKeepP(t, e.keyupEvents), a.default(t, e.tabDownEvents), l.default(t, e.pasteEvents), u.default(t, e.imgClickEvents)
    }
  }, function(e, t, n) {
    'use strict'; const o = n(0); const i = o(n(1)); const r = o(n(27)); (0, i.default)(t, '__esModule', { value: !0 }); const a = n(2).__importDefault(n(3)); t.default = function(o, e, t) {
      function i(e) {
        let t; const n = a.default('<p><br></p>'); n.insertBefore(e), (0, r.default)(t = e.html()).call(t, '<img') >= 0 ? n.remove() : (o.selection.createRangeByElem(n, !0, !0), o.selection.restoreSelection(), e.remove())
      }e.push(() => {
        const e = o.$textElem; const t = o.selection.getSelectionContainerElem(); const n = t.parent(); n.html() !== '<code><br></code>' ? n.equal(e) && (t.getNodeName() === 'P' && t.attr('data-we-empty-p') === null || t.text() || i(t)) : i(t)
      }), t.push((e) => {
        let t; o.selection.saveRange((t = getSelection()) === null || void 0 === t ? void 0 : t.getRangeAt(0)), o.selection.getSelectionContainerElem().id === o.textElemId && (e.preventDefault(), o.cmd.do('insertHTML', '<p><br></p>'))
      })
    }
  }, function(e, t, n) {
    'use strict'; const o = n(0); var i = o(n(1)); const r = o(n(19)); (0, i.default)(t, '__esModule', { value: !0 }), t.cutToKeepP = void 0; var i = n(2); const a = n(7); const l = i.__importDefault(n(3)); t.cutToKeepP = function(n, e) {
      e.push((e) => {
        let t; e.keyCode === 88 && (t = n.$textElem, (e = (0, r.default)(e = t.html().toLowerCase()).call(e)) && e !== '<br>' || (e = l.default(a.EMPTY_P), t.html(' '), t.append(e), n.selection.createRangeByElem(e, !1, !0), n.selection.restoreSelection(), n.selection.moveCursor(e.getNode(), 0)))
      })
    }, t.default = function(n, e, t) {
      e.push(() => {
        let e; const t = n.$textElem; /^<p>(( ?)|(<br *\/?>))<\/p>$/.test(t.html()) && (e = l.default(a.EMPTY_P), t.html(' '), t.append(e), n.selection.createRangeByElem(e, !1, !0), n.selection.restoreSelection(), n.selection.moveCursor(e.getNode(), 0))
      }), t.push((e) => {
        let t = n.$textElem; (0, r.default)(t = t.html().toLowerCase()).call(t) === a.EMPTY_P && e.preventDefault()
      })
    }
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }), t.default = function(n, e) {
      e.push(() => {
        let e; let t; !n.cmd.queryCommandSupported('insertHTML') || (e = n.selection.getSelectionContainerElem()) && (t = e.parent(), e = e.getNodeName(), t = t.getNodeName(), e == 'CODE' || t === 'CODE' || t === 'PRE' || /hljs/.test(t) ? n.cmd.do('insertHTML', n.config.languageTab) : n.cmd.do('insertHTML', '&nbsp;&nbsp;&nbsp;&nbsp;'))
      })
    }
  }, function(e, t, n) {
    'use strict'; const o = n(0); const i = o(n(1)); const r = o(n(19)); (0, i.default)(t, '__esModule', { value: !0 }); const f = n(129); const d = n(6); const p = n(7); function h(e) {
      return e = (e = e.replace(/<div>/gim, '<p>').replace(/<\/div>/gim, '</p>')).replace(/<p><\/p>/gim, '<p><br></p>'), (0, r.default)(e).call(e)
    }t.default = function(c, e) {
      e.push((e) => {
        let t = c.config; const n = t.pasteFilterStyle; let o = t.pasteIgnoreImg; const i = t.pasteTextHandle; let r = f.getPasteHtml(e, n, o); var a = (a = f.getPasteText(e)).replace(/\n/gm, '<br>'); const l = c.selection.getSelectionContainerElem(); if (l) {
          t = l == null ? void 0 : l.getNodeName(), o = l == null ? void 0 : l.getNodeTop(c), e = ''; if (o.elems[0] && (e = o == null ? void 0 : o.getNodeName()), t === 'CODE' || e === 'PRE') return i && d.isFunction(i) && (a = `${i(a) || ''}`), void c.cmd.do('insertHTML', a.replace(/<br>|<br\/>/gm, '\n').replace(/<[^>]+>/gm, '')); if (p.urlRegex.test(a) && n) {
            i && d.isFunction(i) && (a = `${i(a) || ''}`); t = p.urlRegex.exec(a)[0], e = a.replace(p.urlRegex, ''); return c.cmd.do('insertHTML', `<a href="${t}" target="_blank">${t}</a>${e}`)
          } if (r) {
            try {
              if (i && d.isFunction(i) && (r = `${i(r) || ''}`), /[\.\#\@]?\w+[ ]+\{[^}]*\}/.test(r) && n)c.cmd.do('insertHTML', `${h(a)}`); else {
                const u = h(r); if (function(e) {
                  if (e !== '') {
                    let t = document.createElement('div'); return t.innerHTML = e, ((t = t.firstChild) === null || void 0 === t ? void 0 : t.nodeName) === 'P'
                  }
                }(u)) {
                  const s = c.$textElem; if (c.cmd.do('insertHTML', u), s.equal(l)) return void c.selection.createEmptyRange(); !(function(e) {
                    if (e != null && e.length) {
                      e = e.elems[0]; return e.nodeName === 'P' && e.innerHTML === '<br>'
                    }
                  }(o)) || o.remove()
                } else /^<img [^>]*src=['"]([^'"]+)[^>]*>$/g.test(u) || c.cmd.do('insertHTML', u)
              }
            } catch (e) {
              i && d.isFunction(i) && (a = `${i(a) || ''}`), c.cmd.do('insertHTML', `${h(a)}`)
            }
          }
        }
      })
    }
  }, function(e, t, n) {
    'use strict'; const o = n(0); var i = o(n(1)); const c = o(n(19)); const f = o(n(4)); const d = o(n(56)); (0, i.default)(t, '__esModule', { value: !0 }); var i = n(2); const p = n(300); const r = i.__importDefault(n(304)); function h(e, t) {
      let n; return e = (0, c.default)(n = e.toLowerCase()).call(n), p.IGNORE_TAGS.has(e) || !(!t || e !== 'img')
    }t.default = function(e, a, l) {
      void 0 === a && (a = !0), void 0 === l && (l = !1); const u = []; let s = ''; (new r.default()).parse(e, {
        startElement: function(e, t) {
          let n; let o; let i; let r; i = e, (i = (0, c.default)(i).call(i)) && (p.EMPTY_TAGS.has(i) || (s = i)), h(e, l) || (n = p.NECESSARY_ATTRS.get(e) || [], o = [], (0, f.default)(t).call(t, (e) => {
            const t = e.name; t !== 'style' ? !1 !== (0, d.default)(n).call(n, t) && o.push(e) : a || o.push(e)
          }), i = o, t = '', t = `<${e = e}`, r = [], (0, f.default)(i).call(i, (e) => {
            r.push(`${e.name}="${e.value}"`)
          }), t = t = `${(t = r.length > 0 ? `${t} ${r.join(' ')}` : t) + (p.EMPTY_TAGS.has(e) ? '/' : '')}>`, u.push(t))
        },
        characters: function(e) {
          e && (h(s, l) || u.push(e))
        },
        endElement: function(e) {
          h(e, l) || (u.push(`</${e}>`), s = '')
        },
        comment: function(e) {}
      }); let t; var e = u.join(''); return t = /<span>(.*?)<\/span>/, e = e.replace(/<span>.*?<\/span>/gi, (e) => {
        e = e.match(t); return e == null ? '' : e[1]
      })
    }
  }, function(e, t, n) {
    'use strict'; const o = n(0); const i = o(n(1)); const r = o(n(130)); var n = o(n(120)); (0, i.default)(t, '__esModule', { value: !0 }), t.TOP_LEVEL_TAGS = t.EMPTY_TAGS = t.NECESSARY_ATTRS = t.IGNORE_TAGS = void 0, t.IGNORE_TAGS = new r.default(['doctype', '!doctype', 'html', 'head', 'meta', 'body', 'script', 'style', 'link', 'frame', 'iframe', 'title', 'svg', 'center', 'o:p']), t.NECESSARY_ATTRS = new n.default([['img', ['src', 'alt']], ['a', ['href', 'target']], ['td', ['colspan', 'rowspan']], ['th', ['colspan', 'rowspan']]]), t.EMPTY_TAGS = new r.default(['area', 'base', 'basefont', 'br', 'col', 'hr', 'img', 'input', 'isindex', 'embed']), t.TOP_LEVEL_TAGS = new r.default(['h1', 'h2', 'h3', 'h4', 'h5', 'p', 'ul', 'ol', 'table', 'blockquote', 'pre', 'hr', 'form'])
  }, function(e, t, n) {
    n = n(302); e.exports = n
  }, function(e, t, n) {
    n(303), n(68), n(52), n(53); n = n(10); e.exports = n.Set
  }, function(e, t, n) {
    'use strict'; const o = n(121); var n = n(123); e.exports = o('Set', (e) => {
      return function() {
        return e(this, arguments.length ? arguments[0] : void 0)
      }
    }, n)
  }, function(e, t) {
    function n() {}n.prototype = {
      handler: null,
      startTagRe: /^<([^>\s\/]+)((\s+[^=>\s]+(\s*=\s*((\"[^"]*\")|(\'[^']*\')|[^>\s]+))?)*)\s*\/?\s*>/m,
      endTagRe: /^<\/([^>\s]+)[^>]*>/m,
      attrRe: /([^=\s]+)(\s*=\s*((\"([^"]*)\")|(\'([^']*)\')|[^>\s]+))?/gm,
      parse: function(e, t) {
        t && (this.contentHandler = t); for (var n, o, i, r = !1, a = this; e.length > 0;) {
          e.substring(0, 4) == '\x3c!--'
            ? r = (i = e.indexOf('--\x3e')) == -1 || (this.contentHandler.comment(e.substring(4, i)), e = e.substring(i + 3), !1)
            : e.substring(0, 2) == '</'
              ? r = !this.endTagRe.test(e) || (RegExp.leftContext, n = RegExp.lastMatch, o = RegExp.rightContext, n.replace(this.endTagRe, function() {
                return a.parseEndTag.apply(a, arguments)
              }), e = o, !1)
              : e.charAt(0) == '<' && (r = !this.startTagRe.test(e) || (RegExp.leftContext, n = RegExp.lastMatch, o = RegExp.rightContext, n.replace(this.startTagRe, function() {
                return a.parseStartTag.apply(a, arguments)
              }), e = o, !1)), r && (e = (i = e.indexOf('<')) == -1 ? (this.contentHandler.characters(e), '') : (this.contentHandler.characters(e.substring(0, i)), e.substring(i))), r = !0
        }
      },
      parseStartTag: function(e, t, n) {
        n = this.parseAttributes(t, n); this.contentHandler.startElement(t, n)
      },
      parseEndTag: function(e, t) {
        this.contentHandler.endElement(t)
      },
      parseAttributes: function(u, e) {
        const s = this; const c = []; return e.replace(this.attrRe, (e, t, n, o, i, r, a, l) => {
          c.push(s.parseAttribute(u, e, t, n, o, i, r, a, l))
        }), c
      },
      parseAttribute: function(e, t, n) {
        let o = ''; return arguments[7] ? o = arguments[8] : arguments[5] ? o = arguments[6] : arguments[3] && (o = arguments[4]), { name: n, value: !o && !arguments[3] ? null : o }
      }
    }, e.exports = n
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }), t.default = function(t, e) {
      e.push((e) => {
        t.selection.createRangeByElem(e), t.selection.restoreSelection()
      })
    }
  }, function(e, t, n) {
    'use strict'; const o = n(0); var i = o(n(1)); const r = o(n(4)); (0, i.default)(t, '__esModule', { value: !0 }); var i = n(2); const c = n(6); const f = i.__importDefault(n(3)); t.default = function u(e) {
      const s = []; var e = e.childNodes() || []; return (0, r.default)(e).call(e, (e) => {
        let t; const n = e.nodeType; if (n === 3 && (t = e.textContent || '', t = c.replaceHtmlSymbol(t)), n === 1) {
          (t = {}).tag = e.nodeName.toLowerCase(); for (var o = [], i = e.attributes, r = i.length || 0, a = 0; a < r; a++) {
            const l = i[a]; o.push({ name: l.name, value: l.value })
          }t.attrs = o, t.children = u(f.default(e))
        }t && s.push(t)
      }), s
    }
  }, function(e, t, n) {
    'use strict'; const o = n(0); const r = o(n(95)); const i = o(n(1)); const a = o(n(4)); (0, i.default)(t, '__esModule', { value: !0 }); const l = n(2).__importDefault(n(3)); t.default = function o(e, t) {
      const i = t = void 0 === t ? document.createElement('div') : t; return (0, a.default)(e).call(e, (e) => {
        let t; let n; typeof e === 'string' && (n = document.createTextNode(e)), (0, r.default)(e) === 'object' && (n = document.createElement(e.tag), (0, a.default)(t = e.attrs).call(t, (e) => {
          l.default(n).attr(e.name, e.value)
        }), e.children && e.children.length > 0 && o(e.children, n.getRootNode())), n && i.appendChild(n)
      }), l.default(i)
    }
  }, function(e, t, n) {
    'use strict'; const o = n(0); var i = o(n(1)); const u = o(n(92)); const s = o(n(73)); const c = o(n(56)); const f = o(n(309)); const d = o(n(4)); const p = o(n(131)); const r = o(n(132)); const h = o(n(45)); const a = o(n(57)); (0, i.default)(t, '__esModule', { value: !0 }); var i = n(2); const A = i.__importDefault(n(119)); const l = i.__importDefault(n(321)); const v = i.__importDefault(n(3)); var n = (m.prototype.extend = function(e, t) {
      t && typeof t === 'function' && (this.constructorList[e] = t)
    }, m.prototype.init = function() {
      const n = this; const e = this.editor.config; let t = e.excludeMenus; !1 === (0, u.default)(t) && (t = []), e.menus = (0, s.default)(o = e.menus).call(o, (e) => {
        return !1 === (0, c.default)(t).call(t, e)
      }); var o = (0, f.default)(A.default.globalCustomMenuConstructorList); var o = (0, s.default)(o).call(o, (e) => {
        return (0, c.default)(t).call(t, e)
      }); (0, d.default)(o).call(o, (e) => {
        delete A.default.globalCustomMenuConstructorList[e]
      }), (0, d.default)(o = e.menus).call(o, (e) => {
        const t = n.constructorList[e]; n._initMenuList(e, t)
      }); for (let i = 0, r = (0, p.default)(A.default.globalCustomMenuConstructorList); i < r.length; i++) {
        var a = r[i]; const l = a[0]; var a = a[1]; this._initMenuList(l, a)
      } this._addToToolbar(), e.showMenuTooltips && this._bindMenuTooltips()
    }, m.prototype._initMenuList = function(t, e) {
      let n; e != null && typeof e === 'function' && ((0, r.default)(n = this.menuList).call(n, (e) => {
        return e.key === t
      })
        ? console.warn(`菜单名称重复:${t}`)
        : ((e = new e(this.editor)).key = t, this.menuList.push(e)))
    }, m.prototype._bindMenuTooltips = function() {
      const i = this.editor; const r = i.$toolbarElem; const a = i.config.menuTooltipPosition; const l = v.default(`<div class="w-e-menu-tooltip w-e-menu-tooltip-${a}">\n            <div class="w-e-menu-tooltip-item-wrapper">\n              <div></div>\n            </div>\n          </div>`); l.css('visibility', 'hidden'), r.append(l), l.css('z-index', i.zIndex.get('tooltip')); let u = 0; function s() {
        u && clearTimeout(u)
      } function c() {
        s(), l.css('visibility', 'hidden')
      }r.on('mouseover', (e) => {
        let t; let n; let o; var e = e.target; var e = v.default(e); e.isContain(r)
          ? c()
          : (e.parentUntil('.w-e-droplist') != null ? c() : e.attr('data-title') ? (o = e.attr('data-title'), n = e) : (t = e.parentUntil('.w-e-menu')) != null && (o = t.attr('data-title'), n = t), o && n
              ? (s(), t = n.getOffsetData(), l.text(i.i18next.t(`menus.title.${o}`)), n = l.getOffsetData(), o = t.left + t.width / 2 - n.width / 2, l.css('left', `${o}px`), a === 'up' ? l.css('top', `${t.top - n.height - 8}px`) : a === 'down' && l.css('top', `${t.top + t.height + 8}px`), u = (0, h.default)(() => {
                  l.css('visibility', 'visible')
                }, 200))
              : c())
      }).on('mouseleave', () => {
        c()
      })
    }, m.prototype._addToToolbar = function() {
      let e; const t = this.editor.$toolbarElem; (0, d.default)(e = this.menuList).call(e, (e) => {
        e = e.$elem; e && t.append(e)
      })
    }, m.prototype.menuFind = function(e) {
      for (var t = this.menuList, n = 0, o = t.length; n < o; n++) if (t[n].key === e) return t[n]; return t[0]
    }, m.prototype.changeActive = function() {
      let e; (0, d.default)(e = this.menuList).call(e, (e) => {
        let t; (0, h.default)((0, a.default)(t = e.tryChangeActive).call(t, e), 100)
      })
    }, m); function m(e) {
      this.editor = e, this.menuList = [], this.constructorList = l.default
    }t.default = n
  }, function(e, t, n) {
    e.exports = n(310)
  }, function(e, t, n) {
    n = n(311); e.exports = n
  }, function(e, t, n) {
    n(312); n = n(10); e.exports = n.Object.keys
  }, function(e, t, n) {
    const o = n(5); const i = n(25); const r = n(49); o({
      target: 'Object',
      stat: !0,
      forced: n(12)(() => {
        r(1)
      })
    }, {
      keys: function(e) {
        return r(i(e))
      }
    })
  }, function(e, t, n) {
    n = n(314); e.exports = n
  }, function(e, t, n) {
    n(315); n = n(10); e.exports = n.Object.entries
  }, function(e, t, n) {
    const o = n(5); const i = n(316).entries; o({ target: 'Object', stat: !0 }, {
      entries: function(e) {
        return i(e)
      }
    })
  }, function(e, t, n) {
    const u = n(15); const s = n(49); const c = n(28); const f = n(59).f; var n = function(l) {
      return function(e) {
        for (var t, n = c(e), o = s(n), i = o.length, r = 0, a = []; r < i;)t = o[r++], u && !f.call(n, t) || a.push(l ? [t, n[t]] : n[t]); return a
      }
    }; e.exports = { entries: n(!0), values: n(!1) }
  }, function(e, t, n) {
    n = n(318); e.exports = n
  }, function(e, t, n) {
    const o = n(319); const i = Array.prototype; e.exports = function(e) {
      const t = e.some; return e === i || e instanceof Array && t === i.some ? o : t
    }
  }, function(e, t, n) {
    n(320); n = n(14); e.exports = n('Array').some
  }, function(e, t, n) {
    'use strict'; const o = n(5); const i = n(30).some; o({ target: 'Array', proto: !0, forced: !n(70)('some') }, {
      some: function(e) {
        return i(this, e, arguments.length > 1 ? arguments[1] : void 0)
      }
    })
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); const o = n(2); const i = o.__importDefault(n(322)); const r = o.__importDefault(n(323)); const a = o.__importDefault(n(328)); const l = o.__importDefault(n(333)); const u = o.__importDefault(n(334)); const s = o.__importDefault(n(335)); const c = o.__importDefault(n(336)); const f = o.__importDefault(n(338)); const d = o.__importDefault(n(340)); const p = o.__importDefault(n(341)); const h = o.__importDefault(n(344)); const A = o.__importDefault(n(345)); const v = o.__importDefault(n(346)); const m = o.__importDefault(n(357)); const g = o.__importDefault(n(371)); const y = o.__importDefault(n(375)); const w = o.__importDefault(n(137)); const x = o.__importDefault(n(384)); const _ = o.__importDefault(n(386)); const E = o.__importDefault(n(387)); const b = o.__importDefault(n(388)); const C = o.__importDefault(n(408)); const S = o.__importDefault(n(413)); var n = o.__importDefault(n(416)); t.default = { bold: i.default, head: r.default, italic: l.default, link: a.default, underline: u.default, strikeThrough: s.default, fontName: c.default, fontSize: f.default, justify: d.default, quote: p.default, backColor: h.default, foreColor: A.default, video: v.default, image: m.default, indent: g.default, emoticon: y.default, list: w.default, lineHeight: x.default, undo: _.default, redo: E.default, table: b.default, code: C.default, splitLine: S.default, todo: n.default }
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); let o; var i = n(2); const r = i.__importDefault(n(23)); const a = i.__importDefault(n(3)); var i = (o = r.default, i.__extends(l, o), l.prototype.clickHandler = function() {
      const e = this.editor; const t = e.selection.isSelectionEmpty(); t && e.selection.createEmptyRange(), e.cmd.do('bold'), t && (e.selection.collapseRange(), e.selection.restoreSelection())
    }, l.prototype.tryChangeActive = function() {
      this.editor.cmd.queryCommandState('bold') ? this.active() : this.unActive()
    }, l); function l(e) {
      const t = a.default('<div class="w-e-menu" data-title="加粗">\n                <i class="w-e-icon-bold"></i>\n            </div>'); return o.call(this, t, e) || this
    }t.default = i
  }, function(e, t, n) {
    'use strict'; var o = n(0); var i = o(n(1)); const r = o(n(27)); const a = o(n(31)); const d = o(n(4)); const l = o(n(324)); const u = o(n(56)); (0, i.default)(t, '__esModule', { value: !0 }); let s; var o = n(2); var i = o.__importDefault(n(24)); const p = o.__importDefault(n(3)); const c = n(6); const h = n(7); var o = (s = i.default, o.__extends(f, s), f.prototype.command = function(e) {
      let t; const n = this.editor; const o = n.selection.getSelectionContainerElem(); if (o && n.$textElem.equal(o)) this.setMultilineHead(e); else {
        if ((0, r.default)(t = ['OL', 'UL', 'LI', 'TABLE', 'TH', 'TR', 'CODE', 'HR']).call(t, p.default(o).getNodeName()) > -1) return; n.cmd.do('formatBlock', e)
      }e !== '<p>' && this.addUidForSelectionElem()
    }, f.prototype.addUidForSelectionElem = function() {
      const e = this.editor.selection.getSelectionContainerElem(); const t = c.getRandomCode(); p.default(e).attr('id', t)
    }, f.prototype.addListenerCatalog = function() {
      const e = this; this.editor.txt.eventHooks.changeEvents.push(() => {
        e.getCatalogs()
      })
    }, f.prototype.getCatalogs = function() {
      var e = this.editor; var t = this.editor.$textElem; var e = e.config.onCatalogChange; var t = (0, a.default)(t).call(t, 'h1,h2,h3,h4,h5'); const r = []; (0, d.default)(t).call(t, (e, t) => {
        const n = p.default(e); let o = n.attr('id'); const i = n.getNodeName(); var e = n.text(); o || (o = c.getRandomCode(), n.attr('id', o)), e && r.push({ tag: i, id: o, text: e })
      }), (0, l.default)(this.oldCatalogs) !== (0, l.default)(r) && (this.oldCatalogs = r, e && e(r))
    }, f.prototype.setMultilineHead = function(i) {
      const r = this; const n = this.editor; const e = n.selection; const t = (o = e.getSelectionContainerElem()) === null || void 0 === o ? void 0 : o.elems[0]; const a = ['IMG', 'VIDEO', 'TABLE', 'TH', 'TR', 'UL', 'OL', 'PRE', 'HR', 'BLOCKQUOTE']; var o = p.default(e.getSelectionStartElem()); let l = p.default(e.getSelectionEndElem()); l.elems[0].outerHTML !== p.default(h.EMPTY_P).elems[0].outerHTML || l.elems[0].nextSibling || (l = l.prev()); const u = []; u.push(o.getNodeTop(n)); const s = []; var o = (o = e.getRange()) === null || void 0 === o ? void 0 : o.commonAncestorContainer.childNodes; o != null && (0, d.default)(o).call(o, (e, t) => {
        e === u[0].getNode() && s.push(t), e === l.getNodeTop(n).getNode() && s.push(t)
      }); for (let c = 0; u[c].getNode() !== l.getNodeTop(n).getNode();) {
        if (!u[c].elems[0]) return; const f = p.default(u[c].next().getNode()); u.push(f), c++
      }u != null && (0, d.default)(u).call(u, (e, t) => {
        let n; let o; r.hasTag(e, a) || (n = p.default(i), o = e.parent().getNode(), n.html(`${e.html()}`), o.insertBefore(n.getNode(), e.getNode()), e.remove())
      }), e.createRangeByElems(t.children[s[0]], t.children[s[1]])
    }, f.prototype.hasTag = function(e, t) {
      const n = this; if (!e) return !1; if ((0, u.default)(t).call(t, e == null ? void 0 : e.getNodeName())) return !0; let o = !1; return (e = e.children()) !== null && void 0 !== e && (0, d.default)(e).call(e, (e) => {
        o = n.hasTag(p.default(e), t)
      }), o
    }, f.prototype.tryChangeActive = function() {
      const e = this.editor.cmd.queryCommandValue('formatBlock'); /^h/i.test(e) ? this.active() : this.unActive()
    }, f); function f(e) {
      var t = this; const n = p.default('<div class="w-e-menu" data-title="标题"><i class="w-e-icon-header"></i></div>'); const o = {
        width: 100,
        title: '设置标题',
        type: 'list',
        list: [{ $elem: p.default('<h1>H1</h1>'), value: '<h1>' }, { $elem: p.default('<h2>H2</h2>'), value: '<h2>' }, { $elem: p.default('<h3>H3</h3>'), value: '<h3>' }, { $elem: p.default('<h4>H4</h4>'), value: '<h4>' }, { $elem: p.default('<h5>H5</h5>'), value: '<h5>' }, { $elem: p.default(`<p>${e.i18next.t('menus.dropListMenu.head.正文')}</p>`), value: '<p>' }],
        clickHandler: function(e) {
          t.command(e)
        }
      }; var t = s.call(this, n, e, o) || this; return e.config.onCatalogChange && (t.oldCatalogs = [], t.addListenerCatalog(), t.getCatalogs()), t
    }t.default = o
  }, function(e, t, n) {
    e.exports = n(325)
  }, function(e, t, n) {
    n = n(326); e.exports = n
  }, function(e, t, n) {
    n(327); const o = n(10); o.JSON || (o.JSON = { stringify: JSON.stringify }), e.exports = function(e, t, n) {
      return o.JSON.stringify.apply(null, arguments)
    }
  }, function(e, t, n) {
    function i(e, t, n) {
      const o = n.charAt(t - 1); var t = n.charAt(t + 1); return u.test(e) && !s.test(t) || s.test(e) && !u.test(o) ? `\\u${e.charCodeAt(0).toString(16)}` : e
    } const o = n(5); const r = n(29); var n = n(12); const a = r('JSON', 'stringify'); const l = /[\uD800-\uDFFF]/g; var u = /^[\uD800-\uDBFF]$/; var s = /^[\uDC00-\uDFFF]$/; var n = n(() => {
      return a('\udf06\ud834') !== '"\\udf06\\ud834"' || a('\udead') !== '"\\udead"'
    }); a && o({ target: 'JSON', stat: !0, forced: n }, {
      stringify: function(e, t, n) {
        const o = a.apply(null, arguments); return typeof o === 'string' ? o.replace(l, i) : o
      }
    })
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); let o; var i = n(2); const r = i.__importDefault(n(35)); const a = i.__importDefault(n(3)); const l = i.__importDefault(n(329)); const u = i.__importDefault(n(134)); const s = i.__importDefault(n(32)); const c = i.__importDefault(n(331)); var i = (o = r.default, i.__extends(f, o), f.prototype.clickHandler = function() {
      let e; const t = this.editor; this.isActive ? (e = t.selection.getSelectionContainerElem()) && this.createPanel(e.text(), e.attr('href')) : t.selection.isSelectionEmpty() ? this.createPanel('', '') : this.createPanel(t.selection.getSelectionText(), '')
    }, f.prototype.createPanel = function(e, t) {
      t = l.default(this.editor, e, t); new s.default(this, t).create()
    }, f.prototype.tryChangeActive = function() {
      const e = this.editor; u.default(e) ? this.active() : this.unActive()
    }, f); function f(e) {
      const t = a.default('<div class="w-e-menu" data-title="链接"><i class="w-e-icon-link"></i></div>'); const n = o.call(this, t, e) || this; return c.default(e), n
    }t.default = i
  }, function(e, t, n) {
    'use strict'; const o = n(0); var i = o(n(1)); const c = o(n(19)); (0, i.default)(t, '__esModule', { value: !0 }); var i = n(2); const f = n(6); const d = i.__importDefault(n(3)); const p = i.__importDefault(n(134)); const h = n(330); t.default = function(a, e, t) {
      let n; const l = f.getRandom('input-link'); const u = f.getRandom('input-text'); const o = f.getRandom('btn-ok'); const i = f.getRandom('btn-del'); const r = p.default(a) ? 'inline-block' : 'none'; function s() {
        let e; !p.default(a) || (e = a.selection.getSelectionContainerElem()) && (a.selection.createRangeByElem(e), a.selection.restoreSelection(), n = e)
      } return {
        width: 300,
        height: 0,
        tabs: [{
          title: a.i18next.t('menus.panelMenus.link.链接'),
          tpl: `<div>\n                        <input\n                            id="${u}"\n                            type="text"\n                            class="block"\n                            value="${e}"\n                            placeholder="${a.i18next.t('menus.panelMenus.link.链接文字')}"/>\n                        </td>\n                        <input\n                            id="${l}"\n                            type="text"\n                            class="block"\n                            value="${t}"\n                            placeholder="${a.i18next.t('如')} https://..."/>\n                        </td>\n                        <div class="w-e-button-container">\n                            <button type="button" id="${o}" class="right">\n                                ${a.i18next.t('插入')}\n                            </button>\n                            <button type="button" id="${i}" class="gray right" style="display:${r}">\n                                ${a.i18next.t('menus.panelMenus.link.取消链接')}\n                            </button>\n                        </div>\n                    </div>`,
          events: [{
            selector: `#${o}`,
            type: 'click',
            fn: function() {
              a.selection.restoreSelection(); let e = a.selection.getSelectionRangeTopNodes()[0].getNode(); var t = window.getSelection(); var n = d.default(`#${l}`); var o = d.default(`#${u}`); var n = (0, c.default)(i = n.val()).call(i); var o = (0, c.default)(i = o.val()).call(i); var i = ''; var t = (i = t && (t == null || !t.isCollapsed) ? (r = h.insertHtml(t, e)) === null || void 0 === r ? void 0 : (0, c.default)(r).call(r) : i) == null ? void 0 : i.replace(/<.*?>/g, ''); var r = (e = t == null ? void 0 : t.length) !== null && void 0 !== e ? e : 0; if (r <= o.length && (e = o.substring(0, r), r = o.substring(r), t === e && (o = i + r)), n) {
                o = o || n; if (function(e, t) {
                  if (void 0 !== (t = a.config.linkCheck(e, t))) {
                    if (!0 === t) return 1; a.config.customAlert(t, 'warning')
                  }
                }(o, n)) return o = o, n = n, p.default(a) && s(), a.cmd.do('insertHTML', `<a href="${n}" target="_blank">${o}</a>`), !0
              }
            }
          }, {
            selector: `#${i}`,
            type: 'click',
            fn: function() {
              let e; return p.default(a) && (s(), e = n.text(), a.cmd.do('insertHTML', `<span>${e}</span>`)), !0
            }
          }]
        }]
      }
    }
  }, function(e, t, n) {
    'use strict'; const o = n(0); const i = o(n(1)); const r = o(n(4)); function p(e, t) {
      for (var n = e, o = e; n.textContent !== t && ((n = (o = n).parentNode ? n == null ? void 0 : n.parentNode : n) == null ? void 0 : n.nodeName) !== 'P';);return o
    } function h(e, t) {
      let n; let o = e.nodeName; let i = ''; return e.nodeType === 3 ? t : (e.nodeType === 1 && ((n = e.getAttribute('style')) && (i = `${i} style="${n}"`), (n = e.getAttribute('face')) && (i = `${i} face="${n}"`), (e = e.getAttribute('color')) && (i = `${i} color="${e}"`)), `<${o = o.toLowerCase()}${i}>${t}</${o}>`)
    } function A(e, t, n, o) {
      for (var i, r = (i = t.textContent) === null || void 0 === i ? void 0 : i.substring(n, o), a = t, l = ''; r = l = h(a, r != null ? r : ''), (a = a == null ? void 0 : a.parentElement) && a.textContent !== e;);return l
    } function v(e, t) {
      return (0, r.default)(e).call(e, (e) => {
        t = h(e, t)
      }), t
    }(0, i.default)(t, '__esModule', { value: !0 }), t.insertHtml = t.createPartHtml = t.makeHtmlString = t.getTopNode = void 0, t.getTopNode = p, t.makeHtmlString = h, t.createPartHtml = A, t.insertHtml = function(e, t) {
      let n; const o = e.anchorNode; const i = e.focusNode; const r = e.anchorOffset; const a = e.focusOffset; const l = (c = t.textContent) !== null && void 0 !== c ? c : ''; const u = (function(e) {
        let t; const n = (t = e.textContent) !== null && void 0 !== t ? t : ''; const o = []; for (;(e == null ? void 0 : e.textContent) === n;)e.nodeName !== 'P' && o.push(e), e = e.childNodes[0]; return o
      }(t)); var e = ''; let s = ''; var c = ''; var t = o; let f = i; let d = o; if (o != null && o.isEqualNode(i != null ? i : null)) return v(u, A(l, o, r, a)); for (o && (e = A(l, o, r != null ? r : 0)), i && (c = A(l, i, 0, a)), o && (t = p(o, l)), i && (f = p(i, l)), d = (t = t == null ? void 0 : t.nextSibling) !== null && void 0 !== t ? t : o; d == null || !d.isEqualNode(f != null ? f : null);)(d == null ? void 0 : d.nodeName) === '#text' ? s += d == null ? void 0 : d.textContent : (n = (n = (n = d == null ? void 0 : d.firstChild) === null || void 0 === n ? void 0 : n.parentElement) === null || void 0 === n ? void 0 : n.innerHTML, d && (s += h(d, n != null ? n : ''))), d = (n = d == null ? void 0 : d.nextSibling) !== null && void 0 !== n ? n : d; return v(u, `${e}${s}${c}`)
    }
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); const o = n(2).__importDefault(n(332)); t.default = function(e) {
      o.default(e)
    }
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); const o = n(2); const i = o.__importDefault(n(3)); const r = o.__importDefault(n(36)); function a(n) {
      let o; return {
        showLinkTooltip: function(e) {
          const t = [{
            $elem: i.default(`<span>${n.i18next.t('menus.panelMenus.link.查看链接')}</span>`),
            onClick: function(e, t) {
              t = t.attr('href'); return window.open(t, '_target'), !0
            }
          }, {
            $elem: i.default(`<span>${n.i18next.t('menus.panelMenus.link.取消链接')}</span>`),
            onClick: function(e, t) {
              e.selection.createRangeByElem(t), e.selection.restoreSelection(); t = t.text(); return e.cmd.do('insertHTML', `<span>${t}</span>`), !0
            }
          }]; (o = new r.default(n, e, t)).create()
        },
        hideLinkTooltip: function() {
          o && (o.remove(), o = null)
        }
      }
    }t.default = function(e) {
      const t = (n = a(e)).showLinkTooltip; var n = n.hideLinkTooltip; e.txt.eventHooks.linkClickEvents.push(t), e.txt.eventHooks.clickEvents.push(n), e.txt.eventHooks.keyupEvents.push(n), e.txt.eventHooks.toolbarClickEvents.push(n), e.txt.eventHooks.menuClickEvents.push(n), e.txt.eventHooks.textScrollEvents.push(n)
    }
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); let o; var i = n(2); const r = i.__importDefault(n(23)); const a = i.__importDefault(n(3)); var i = (o = r.default, i.__extends(l, o), l.prototype.clickHandler = function() {
      const e = this.editor; const t = e.selection.isSelectionEmpty(); t && e.selection.createEmptyRange(), e.cmd.do('italic'), t && (e.selection.collapseRange(), e.selection.restoreSelection())
    }, l.prototype.tryChangeActive = function() {
      this.editor.cmd.queryCommandState('italic') ? this.active() : this.unActive()
    }, l); function l(e) {
      const t = a.default('<div class="w-e-menu" data-title="斜体">\n                <i class="w-e-icon-italic"></i>\n            </div>'); return o.call(this, t, e) || this
    }t.default = i
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); let o; var i = n(2); const r = i.__importDefault(n(23)); const a = i.__importDefault(n(3)); var i = (o = r.default, i.__extends(l, o), l.prototype.clickHandler = function() {
      const e = this.editor; const t = e.selection.isSelectionEmpty(); t && e.selection.createEmptyRange(), e.cmd.do('underline'), t && (e.selection.collapseRange(), e.selection.restoreSelection())
    }, l.prototype.tryChangeActive = function() {
      this.editor.cmd.queryCommandState('underline') ? this.active() : this.unActive()
    }, l); function l(e) {
      const t = a.default('<div class="w-e-menu" data-title="下划线">\n                <i class="w-e-icon-underline"></i>\n            </div>'); return o.call(this, t, e) || this
    }t.default = i
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); let o; var i = n(2); const r = i.__importDefault(n(23)); const a = i.__importDefault(n(3)); var i = (o = r.default, i.__extends(l, o), l.prototype.clickHandler = function() {
      const e = this.editor; const t = e.selection.isSelectionEmpty(); t && e.selection.createEmptyRange(), e.cmd.do('strikeThrough'), t && (e.selection.collapseRange(), e.selection.restoreSelection())
    }, l.prototype.tryChangeActive = function() {
      this.editor.cmd.queryCommandState('strikeThrough') ? this.active() : this.unActive()
    }, l); function l(e) {
      const t = a.default('<div class="w-e-menu" data-title="删除线">\n                <i class="w-e-icon-strikethrough"></i>\n            </div>'); return o.call(this, t, e) || this
    }t.default = i
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); let i; var o = n(2); const r = o.__importDefault(n(24)); const a = o.__importDefault(n(3)); const l = o.__importDefault(n(337)); var o = (i = r.default, o.__extends(u, i), u.prototype.command = function(e) {
      let t; let n; const o = this.editor; const i = o.selection.isSelectionEmpty(); const r = (n = o.selection.getSelectionContainerElem()) === null || void 0 === n ? void 0 : n.elems[0]; r != null && (t = (r == null ? void 0 : r.nodeName.toLowerCase()) !== 'p', n = (r == null ? void 0 : r.getAttribute('face')) === e, i && (t && !n && (n = o.selection.getSelectionRangeTopNodes(), o.selection.createRangeByElem(n[0]), o.selection.moveCursor(n[0].elems[0])), o.selection.setRangeToElem(r), o.selection.createEmptyRange()), o.cmd.do('fontName', e), i && (o.selection.collapseRange(), o.selection.restoreSelection()))
    }, u.prototype.tryChangeActive = function() {}, u); function u(e) {
      let t = this; const n = a.default('<div class="w-e-menu" data-title="字体">\n                <i class="w-e-icon-font"></i>\n            </div>'); const o = {
        width: 100,
        title: '设置字体',
        type: 'list',
        list: new l.default(e.config.fontNames).getItemList(),
        clickHandler: function(e) {
          t.command(e)
        }
      }; return t = i.call(this, n, e, o) || this
    }t.default = o
  }, function(e, t, n) {
    'use strict'; const o = n(0); const i = o(n(1)); const r = o(n(4)); (0, i.default)(t, '__esModule', { value: !0 }); const a = n(2).__importDefault(n(3)); var n = (l.prototype.getItemList = function() {
      return this.itemList
    }, l); function l(e) {
      const n = this; this.itemList = [], (0, r.default)(e).call(e, (e) => {
        const t = typeof e === 'string' ? e : e.value; var e = typeof e === 'string' ? e : e.name; n.itemList.push({ $elem: a.default(`<p style="font-family:'${t}'">${e}</p>`), value: e })
      })
    }t.default = n
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); let i; var o = n(2); const r = o.__importDefault(n(24)); const a = o.__importDefault(n(3)); const l = o.__importDefault(n(339)); var o = (i = r.default, o.__extends(u, i), u.prototype.command = function(e) {
      let t; let n; const o = this.editor; const i = o.selection.isSelectionEmpty(); let r = (n = o.selection.getSelectionContainerElem()) === null || void 0 === n ? void 0 : n.elems[0]; r != null && (t = (r == null ? void 0 : r.nodeName.toLowerCase()) !== 'p', n = (r == null ? void 0 : r.getAttribute('size')) === e, i && (t && !n && (n = (t = o.selection.getSelectionRangeTopNodes())[0].elems[0], o.selection.createRangeByElem(t[0]), o.selection.moveCursor(n), r = n), o.selection.setRangeToElem(r), o.selection.createEmptyRange()), o.cmd.do('fontSize', e), i && (o.selection.collapseRange(), o.selection.restoreSelection()))
    }, u.prototype.tryChangeActive = function() {}, u); function u(e) {
      let t = this; const n = a.default('<div class="w-e-menu" data-title="字号">\n                <i class="w-e-icon-text-heigh"></i>\n            </div>'); const o = {
        width: 160,
        title: '设置字号',
        type: 'list',
        list: new l.default(e.config.fontSizes).getItemList(),
        clickHandler: function(e) {
          t.command(e)
        }
      }; return t = i.call(this, n, e, o) || this
    }t.default = o
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); const o = n(2).__importDefault(n(3)); var n = (i.prototype.getItemList = function() {
      return this.itemList
    }, i); function i(e) {
      for (const t in this.itemList = [], e) {
        const n = e[t]; this.itemList.push({ $elem: o.default(`<p style="font-size:${t}">${n.name}</p>`), value: n.value })
      }
    }t.default = n
  }, function(e, t, n) {
    'use strict'; var o = n(0); var i = o(n(1)); const r = o(n(4)); const a = o(n(27)); (0, i.default)(t, '__esModule', { value: !0 }); let l; var o = n(2); var i = o.__importDefault(n(24)); const u = o.__importDefault(n(3)); const s = ['LI']; const c = ['UL', 'BLOCKQUOTE']; var o = (l = i.default, o.__extends(f, l), f.prototype.command = function(t) {
      let e = this.editor; const n = e.selection; let o = n.getSelectionContainerElem(); n.saveRange(); e = e.selection.getSelectionRangeTopNodes(); if (o != null && o.length) {
        if (this.isSpecialNode(o, e[0]) || this.isSpecialTopNode(e[0])) {
          o = this.getSpecialNodeUntilTop(o, e[0]); if (o == null) return; u.default(o).css('text-align', t)
        } else {
          (0, r.default)(e).call(e, (e) => {
            e.css('text-align', t)
          })
        }
      } n.restoreSelection()
    }, f.prototype.getSpecialNodeUntilTop = function(e, t) {
      for (var n = e.elems[0], o = t.elems[0]; n != null;) {
        if ((0, a.default)(s).call(s, n == null ? void 0 : n.nodeName) !== -1) return n; if (n.parentNode === o) return n; n = n.parentNode
      } return n
    }, f.prototype.isSpecialNode = function(e, t) {
      t = this.getSpecialNodeUntilTop(e, t); return t != null && (0, a.default)(s).call(s, t.nodeName) !== -1
    }, f.prototype.isSpecialTopNode = function(e) {
      return e != null && (0, a.default)(c).call(c, (e = e.elems[0]) === null || void 0 === e ? void 0 : e.nodeName) !== -1
    }, f.prototype.tryChangeActive = function() {}, f); function f(e) {
      let t = this; const n = u.default('<div class="w-e-menu" data-title="对齐"><i class="w-e-icon-paragraph-left"></i></div>'); const o = {
        width: 100,
        title: '对齐方式',
        type: 'list',
        list: [{ $elem: u.default(`<p>\n                            <i class="w-e-icon-paragraph-left w-e-drop-list-item"></i>\n                            ${e.i18next.t('menus.dropListMenu.justify.靠左')}\n                        </p>`), value: 'left' }, { $elem: u.default(`<p>\n                            <i class="w-e-icon-paragraph-center w-e-drop-list-item"></i>\n                            ${e.i18next.t('menus.dropListMenu.justify.居中')}\n                        </p>`), value: 'center' }, { $elem: u.default(`<p>\n                            <i class="w-e-icon-paragraph-right w-e-drop-list-item"></i>\n                            ${e.i18next.t('menus.dropListMenu.justify.靠右')}\n                        </p>`), value: 'right' }, { $elem: u.default(`<p>\n                            <i class="w-e-icon-paragraph-justify w-e-drop-list-item"></i>\n                            ${e.i18next.t('menus.dropListMenu.justify.两端')}\n                        </p>`), value: 'justify' }],
        clickHandler: function(e) {
          t.command(e)
        }
      }; return t = l.call(this, n, e, o) || this
    }t.default = o
  }, function(e, t, n) {
    'use strict'; var o = n(0); var i = o(n(1)); const l = o(n(4)); (0, i.default)(t, '__esModule', { value: !0 }); let r; var o = n(2); const u = o.__importDefault(n(3)); var i = o.__importDefault(n(23)); const a = o.__importDefault(n(342)); const s = o.__importDefault(n(343)); const c = n(7); var o = (r = i.default, o.__extends(f, r), f.prototype.clickHandler = function() {
      const e = this.editor; const t = e.selection.isSelectionEmpty(); const n = e.selection.getSelectionRangeTopNodes(); const o = n[n.length - 1]; if (this.getTopNodeName() !== 'BLOCKQUOTE') {
        var i = s.default(n); i.insertAfter(o), this.delSelectNode(n); var r = (r = i.childNodes()) === null || void 0 === r ? void 0 : r.last().getNode(); return r == null ? void 0 : (r.textContent ? e.selection.moveCursor(r) : e.selection.moveCursor(r, 0), this.tryChangeActive(), void u.default(c.EMPTY_P).insertAfter(i))
      } var r = u.default(o.childNodes()); var i = r.length; let a = o; (0, l.default)(r).call(r, (e) => {
        e = u.default(e); e.insertAfter(a), a = e
      }), o.remove(), e.selection.moveCursor(r.elems[i - 1]), this.tryChangeActive(), t && (e.selection.collapseRange(), e.selection.restoreSelection())
    }, f.prototype.tryChangeActive = function() {
      let e; ((e = this.editor.selection.getSelectionRangeTopNodes()[0]) === null || void 0 === e ? void 0 : e.getNodeName()) === 'BLOCKQUOTE' ? this.active() : this.unActive()
    }, f.prototype.getTopNodeName = function() {
      const e = this.editor.selection.getSelectionRangeTopNodes()[0]; return e == null ? void 0 : e.getNodeName()
    }, f.prototype.delSelectNode = function(e) {
      (0, l.default)(e).call(e, (e) => {
        e.remove()
      })
    }, f); function f(e) {
      const t = u.default('<div class="w-e-menu" data-title="引用">\n                <i class="w-e-icon-quotes-left"></i>\n            </div>'); const n = r.call(this, t, e) || this; return a.default(e), n
    }t.default = o
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); const o = n(2); const r = n(7); const a = o.__importDefault(n(3)); t.default = function(i) {
      i.txt.eventHooks.enterDownEvents.push((e) => {
        let t; let n = i.selection.getSelectionContainerElem(); const o = i.selection.getSelectionRangeTopNodes()[0]; (o == null ? void 0 : o.getNodeName()) === 'BLOCKQUOTE' && (n.getNodeName() === 'BLOCKQUOTE' && (t = (t = n.childNodes()) === null || void 0 === t ? void 0 : t.getNode(), i.selection.moveCursor(t)), n.text() === '' && (e.preventDefault(), n.remove(), (n = a.default(r.EMPTY_P)).insertAfter(o), i.selection.moveCursor(n.getNode(), 0)), o.text() === '' && o.remove())
      })
    }
  }, function(e, t, n) {
    'use strict'; const o = n(0); const i = o(n(1)); const r = o(n(4)); (0, i.default)(t, '__esModule', { value: !0 }); const a = n(2).__importDefault(n(3)); t.default = function(e) {
      const t = a.default('<blockquote></blockquote>'); return (0, r.default)(e).call(e, (e) => {
        t.append(e.clone(!0))
      }), t
    }
  }, function(e, t, n) {
    'use strict'; var o = n(0); var i = o(n(1)); const r = o(n(26)); (0, i.default)(t, '__esModule', { value: !0 }); let a; var o = n(2); var i = o.__importDefault(n(24)); const l = o.__importDefault(n(3)); const u = n(6); var o = (a = i.default, o.__extends(s, a), s.prototype.command = function(e) {
      let t; const n = this.editor; const o = n.selection.isSelectionEmpty(); let i = (t = n.selection.getSelectionContainerElem()) === null || void 0 === t ? void 0 : t.elems[0]; i != null && (t = (i == null ? void 0 : i.nodeName.toLowerCase()) !== 'p', i = i == null ? void 0 : i.style.backgroundColor, i = u.hexToRgb(e) === i, o && (t && !i && (i = n.selection.getSelectionRangeTopNodes(), n.selection.createRangeByElem(i[0]), n.selection.moveCursor(i[0].elems[0])), n.selection.createEmptyRange()), n.cmd.do('backColor', e), o && (n.selection.collapseRange(), n.selection.restoreSelection()))
    }, s.prototype.tryChangeActive = function() {}, s); function s(e) {
      let t = this; const n = l.default('<div class="w-e-menu" data-title="背景色">\n                <i class="w-e-icon-paint-brush"></i>\n            </div>'); var o = {
        width: 120,
        title: '背景颜色',
        type: 'inline-block',
        list: (0, r.default)(o = e.config.colors).call(o, (e) => {
          return { $elem: l.default(`<i style="color:${e};" class="w-e-icon-paint-brush"></i>`), value: e }
        }),
        clickHandler: function(e) {
          t.command(e)
        }
      }; return t = a.call(this, n, e, o) || this
    }t.default = o
  }, function(e, t, n) {
    'use strict'; var o = n(0); var i = o(n(1)); const r = o(n(26)); (0, i.default)(t, '__esModule', { value: !0 }); let a; var o = n(2); var i = o.__importDefault(n(24)); const l = o.__importDefault(n(3)); var o = (a = i.default, o.__extends(u, a), u.prototype.command = function(e) {
      let t; let n; let o; const i = this.editor; const r = i.selection.isSelectionEmpty(); const a = (n = i.selection.getSelectionContainerElem()) === null || void 0 === n ? void 0 : n.elems[0]; a != null && (t = (a == null ? void 0 : a.nodeName.toLowerCase()) !== 'p', n = (a == null ? void 0 : a.getAttribute('color')) === e, r && (t && !n && (o = i.selection.getSelectionRangeTopNodes(), i.selection.createRangeByElem(o[0]), i.selection.moveCursor(o[0].elems[0])), i.selection.setRangeToElem(a), i.selection.createEmptyRange()), o = i.selection.getSelectionText(), a.nodeName === 'A' && a.textContent === o && (o = l.default('<span>&#8203;</span>').getNode(), a.appendChild(o)), i.cmd.do('foreColor', e), r && (i.selection.collapseRange(), i.selection.restoreSelection()))
    }, u.prototype.tryChangeActive = function() {}, u); function u(e) {
      let t = this; const n = l.default('<div class="w-e-menu" data-title="文字颜色">\n                <i class="w-e-icon-pencil2"></i>\n            </div>'); var o = {
        width: 120,
        title: '文字颜色',
        type: 'inline-block',
        list: (0, r.default)(o = e.config.colors).call(o, (e) => {
          return { $elem: l.default(`<i style="color:${e};" class="w-e-icon-pencil2"></i>`), value: e }
        }),
        clickHandler: function(e) {
          t.command(e)
        }
      }; return t = a.call(this, n, e, o) || this
    }t.default = o
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); let o; var i = n(2); const r = i.__importDefault(n(3)); const a = i.__importDefault(n(32)); const l = i.__importDefault(n(35)); const u = i.__importDefault(n(347)); const s = i.__importDefault(n(353)); var i = (o = l.default, i.__extends(c, o), c.prototype.clickHandler = function() {
      this.createPanel('')
    }, c.prototype.createPanel = function(e) {
      e = u.default(this.editor, e); new a.default(this, e).create()
    }, c.prototype.tryChangeActive = function() {}, c); function c(e) {
      const t = r.default('<div class="w-e-menu" data-title="视频">\n                <i class="w-e-icon-play"></i>\n            </div>'); const n = o.call(this, t, e) || this; return s.default(e), n
    }t.default = i
  }, function(e, t, n) {
    'use strict'; const o = n(0); var i = o(n(1)); const u = o(n(19)); (0, i.default)(t, '__esModule', { value: !0 }); var i = n(2); const s = n(6); const c = i.__importDefault(n(3)); const f = i.__importDefault(n(348)); const d = n(7); t.default = function(t, e) {
      const n = t.config; const o = new f.default(t); const i = s.getRandom('input-iframe'); let r = s.getRandom('btn-ok'); const a = s.getRandom('input-upload'); let l = s.getRandom('btn-local-ok'); return l = [{
        title: t.i18next.t('menus.panelMenus.video.上传视频'),
        tpl: `<div class="w-e-up-video-container">\n                    <div id="${l}" class="w-e-up-btn">\n                        <i class="w-e-icon-upload2"></i>\n                    </div>\n                    <div style="display:none;">\n                        <input id="${a}" type="file" accept="video/*"/>\n                    </div>\n                 </div>`,
        events: [{
          selector: `#${l}`,
          type: 'click',
          fn: function() {
            const e = c.default(`#${a}`).elems[0]; if (!e) return !0; e.click()
          }
        }, {
          selector: `#${a}`,
          type: 'change',
          fn: function() {
            let e = c.default(`#${a}`).elems[0]; if (!e) return !0; e = e.files; return e.length && o.uploadVideo(e), !0
          }
        }]
      }, {
        title: t.i18next.t('menus.panelMenus.video.插入视频'),
        tpl: `<div>\n                    <input \n                        id="${i}" \n                        type="text" \n                        class="block" \n                        placeholder="${t.i18next.t('如')}：<iframe src=... ></iframe>"/>\n                    </td>\n                    <div class="w-e-button-container">\n                        <button type="button" id="${r}" class="right">\n                            ${t.i18next.t('插入')}\n                        </button>\n                    </div>\n                </div>`,
        events: [{
          selector: `#${r}`,
          type: 'click',
          fn: function() {
            var e = c.default(`#${i}`); var e = (0, u.default)(e = e.val()).call(e); if (e && (function(e) {
              if (!0 === (e = t.config.onlineVideoCheck(e))) return 1; typeof e === 'string' && t.config.customAlert(e, 'error')
            }(e))) return e = e, t.cmd.do('insertHTML', e + d.EMPTY_P), t.config.onlineVideoCallback(e), !0
          }
        }]
      }], r = { width: 300, height: 0, tabs: [] }, window.FileReader && (n.uploadVideoServer || n.customUploadVideo) && r.tabs.push(l[0]), n.showLinkVideo && r.tabs.push(l[1]), r
    }
  }, function(e, t, n) {
    'use strict'; const o = n(0); var i = o(n(1)); const w = o(n(132)); const x = o(n(57)); const _ = o(n(4)); const E = o(n(27)); (0, i.default)(t, '__esModule', { value: !0 }); var i = n(2); const b = n(6); const C = i.__importDefault(n(135)); const S = i.__importDefault(n(136)); const r = n(7); const a = n(6); var n = (l.prototype.uploadVideo = function(e) {
      let o; let i; let r; let a; let l; let t; let n; let u; let s; let c; let f; let d; let p; let h; let A; let v; let m; let g; const y = this; e.length && (o = this.editor, i = o.config, r = function(e) {
        return o.i18next.t(`validate.${e}`)
      }, v = i.uploadVideoServer, a = i.uploadVideoMaxSize / 1024, l = i.uploadVideoName, t = i.uploadVideoParams, n = i.uploadVideoParamsWithUrl, u = i.uploadVideoHeaders, s = i.uploadVideoHooks, c = i.uploadVideoTimeout, g = i.withVideoCredentials, f = i.customUploadVideo, d = i.uploadVideoAccept, p = [], h = [], b.arrForEach(e, (e) => {
        const t = e.name; const n = e.size / 1024 / 1024; t && n && (d instanceof Array
          ? (0, w.default)(d).call(d, (e) => {
              return e === t.split('.')[t.split('.').length - 1]
            })
              ? a < n ? h.push(`【${t}】${r('大于')} ${a}M`) : p.push(e)
              : h.push(`【${t}】${r('不是视频')}`)
          : h.push(`【${d}】${r('uploadVideoAccept 不是Array')}`))
      }), h.length
        ? i.customAlert(`${r('视频验证未通过')}: \n${h.join('\n')}`, 'warning')
        : p.length !== 0
          ? f && typeof f === 'function'
            ? f(p, (0, x.default)(m = this.insertVideo).call(m, this))
            : (A = new FormData(), (0, _.default)(p).call(p, (e, t) => {
                let n = l || e.name; p.length > 1 && (n += t + 1), A.append(n, e)
              }), v && (v = (m = v.split('#'))[0], m = m[1] || '', (0, _.default)(b).call(b, t, (e, t) => {
                n && ((0, E.default)(v).call(v, '?') > 0 ? v += '&' : v += '?', v = `${v + e}=${t}`), A.append(e, t)
              }), m && (v += `#${m}`), typeof (g = C.default(v, {
                timeout: c,
                formData: A,
                headers: u,
                withCredentials: !!g,
                beforeSend: function(e) {
                  if (s.before) return s.before(e, o, p)
                },
                onTimeout: function(e) {
                  i.customAlert(r('上传视频超时'), 'error'), s.timeout && s.timeout(e, o)
                },
                onProgress: function(e, t) {
                  const n = new S.default(o); t.lengthComputable && (e = t.loaded / t.total, n.show(e))
                },
                onError: function(e) {
                  i.customAlert(r('上传视频错误'), 'error', `${r('上传视频错误')}，${r('服务器返回状态')}: ${e.status}`), s.error && s.error(e, o)
                },
                onFail: function(e, t) {
                  i.customAlert(r('上传视频失败'), 'error', `${r('上传视频返回结果错误')}，${r('返回结果')}` + `: ${t}`), s.fail && s.fail(e, o, t)
                },
                onSuccess: function(e, t) {
                  if (s.customInsert)s.customInsert((0, x.default)(n = y.insertVideo).call(n, y), t, o); else {
                    if (t.errno != '0') return i.customAlert(r('上传视频失败'), 'error', `${r('上传视频返回结果错误')}，${r('返回结果')} errno=${t.errno}`), void (s.fail && s.fail(e, o, t)); var n = t.data; y.insertVideo(n.url), s.success && s.success(e, o, t)
                  }
                }
              })) === 'string' && i.customAlert(g, 'error')))
          : i.customAlert(r('传入的文件不合法'), 'warning'))
    }, l.prototype.insertVideo = function(e) {
      function t(e, t) {
        return o.i18next.t((t = void 0 === t ? 'validate.' : t) + e)
      } let n; var o = this.editor; const i = o.config; i.customInsertVideo
        ? i.customInsertVideo(e)
        : (a.UA.isFirefox ? o.cmd.do('insertHTML', `<p data-we-video-p="true"><video src="${e}" controls="controls" style="max-width:100%"></video></p><p>&#8203</p>`) : o.cmd.do('insertHTML', `<video src="${e}" controls="controls" style="max-width:100%"></video>${r.EMPTY_P}`), (n = document.createElement('video')).onload = function() {
            n = null
          }, n.onerror = function() {
            i.customAlert(t('插入视频错误'), 'error', `wangEditor: ${t('插入视频错误')}，${t('视频链接')} "${e}"，${t('下载链接失败')}`), n = null
          }, n.onabort = function() {
            return n = null
          }, n.src = e)
    }, l); function l(e) {
      this.editor = e
    }t.default = n
  }, function(e, t, n) {
    e.exports = n(350)
  }, function(e, t, n) {
    n = n(351); e.exports = n
  }, function(e, t, n) {
    n(352); n = n(10); e.exports = n.Date.now
  }, function(e, t, n) {
    n(5)({ target: 'Date', stat: !0 }, {
      now: function() {
        return (new Date()).getTime()
      }
    })
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); const o = n(2); const i = o.__importDefault(n(354)); const r = o.__importDefault(n(356)); t.default = function(e) {
      i.default(e), r.default(e)
    }
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }), t.createShowHideFn = void 0; const o = n(2); const r = o.__importDefault(n(3)); const a = o.__importDefault(n(36)); const l = o.__importDefault(n(355)); function i(n) {
      function o(e, t) {
        return n.i18next.t((t = void 0 === t ? '' : t) + e)
      } let i; return {
        showVideoTooltip: function(e) {
          const t = [{
            $elem: r.default("<span class='w-e-icon-trash-o'></span>"),
            onClick: function(e, t) {
              return t.remove(), !0
            }
          }, {
            $elem: r.default('<span>100%</span>'),
            onClick: function(e, t) {
              return t.attr('width', '100%'), t.removeAttr('height'), !0
            }
          }, {
            $elem: r.default('<span>50%</span>'),
            onClick: function(e, t) {
              return t.attr('width', '50%'), t.removeAttr('height'), !0
            }
          }, {
            $elem: r.default('<span>30%</span>'),
            onClick: function(e, t) {
              return t.attr('width', '30%'), t.removeAttr('height'), !0
            }
          }, {
            $elem: r.default(`<span>${o('重置')}</span>`),
            onClick: function(e, t) {
              return t.removeAttr('width'), t.removeAttr('height'), !0
            }
          }, {
            $elem: r.default(`<span>${o('menus.justify.靠左')}</span>`),
            onClick: function(e, t) {
              return l.default(t, 'left'), !0
            }
          }, {
            $elem: r.default(`<span>${o('menus.justify.居中')}</span>`),
            onClick: function(e, t) {
              return l.default(t, 'center'), !0
            }
          }, {
            $elem: r.default(`<span>${o('menus.justify.靠右')}</span>`),
            onClick: function(e, t) {
              return l.default(t, 'right'), !0
            }
          }]; (i = new a.default(n, e, t)).create()
        },
        hideVideoTooltip: function() {
          i && (i.remove(), i = null)
        }
      }
    }t.createShowHideFn = i, t.default = function(e) {
      const t = (n = i(e)).showVideoTooltip; var n = n.hideVideoTooltip; e.txt.eventHooks.videoClickEvents.push(t), e.txt.eventHooks.clickEvents.push(n), e.txt.eventHooks.keyupEvents.push(n), e.txt.eventHooks.toolbarClickEvents.push(n), e.txt.eventHooks.menuClickEvents.push(n), e.txt.eventHooks.textScrollEvents.push(n), e.txt.eventHooks.changeEvents.push(n)
    }
  }, function(e, t, n) {
    'use strict'; const o = n(0); const i = o(n(1)); const r = o(n(56)); (0, i.default)(t, '__esModule', { value: !0 }); const a = n(2).__importDefault(n(3)); t.default = function(e, t) {
      (e = (function(e, t) {
        let n; let o = e.elems[0]; for (;o != null;) {
          if ((0, r.default)(t).call(t, o == null ? void 0 : o.nodeName)) return o; if (((n = o == null ? void 0 : o.parentNode) === null || void 0 === n ? void 0 : n.nodeName) === 'BODY') return null; o = o.parentNode
        } return o
      }(e, ['P']))) && a.default(e).css('text-align', t)
    }
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); const i = n(6); t.default = function(n) {
      let e; let o; i.UA.isFirefox && (e = n.txt, o = n.selection, e.eventHooks.keydownEvents.push((e) => {
        let t = o.getSelectionContainerElem(); !t || (t = (t = t.getNodeTop(n)).length && t.prev().length ? t.prev() : null) && t.attr('data-we-video-p') && o.getCursorPos() === 0 && e.keyCode === 8 && t.remove()
      }))
    }
  }, function(e, t, n) {
    'use strict'; var o = n(0); var i = o(n(1)); const r = o(n(26)); (0, i.default)(t, '__esModule', { value: !0 }); let a; var o = n(2); const l = n(7); const u = o.__importDefault(n(3)); const s = o.__importDefault(n(32)); var i = o.__importDefault(n(35)); const c = o.__importDefault(n(358)); const f = o.__importDefault(n(370)); var o = (a = i.default, o.__extends(d, a), d.prototype.clickHandler = function() {
      this.imgPanelConfig.onlyUploadConf || this.createPanel()
    }, d.prototype.createPanel = function() {
      var e = this.imgPanelConfig; var e = new s.default(this, e); this.setPanel(e), e.create()
    }, d.prototype.tryChangeActive = function() {}, d); function d(e) {
      let t; let n = this; let o = u.default('<div class="w-e-menu" data-title="图片"><i class="w-e-icon-image"></i></div>'); const i = f.default(e); return i.onlyUploadConf && (o = i.onlyUploadConf.$elem, (0, r.default)(t = i.onlyUploadConf.events).call(t, (e) => {
        const t = e.type; const n = e.fn || l.EMPTY_FN; o.on(t, (e) => {
          e.stopPropagation(), n(e)
        })
      })), (n = a.call(this, o, e) || this).imgPanelConfig = i, c.default(e), n
    }t.default = o
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); const o = n(2); const i = o.__importDefault(n(359)); const r = o.__importDefault(n(360)); const a = o.__importDefault(n(361)); const l = o.__importDefault(n(369)); t.default = function(e) {
      i.default(e), r.default(e), a.default(e), l.default(e)
    }
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); const o = n(2); const r = n(129); const a = o.__importDefault(n(98)); function i(e, t) {
      let n; let o; let i; !(function(e) {
        for (let t = ((e = e.clipboardData) === null || void 0 === e ? void 0 : e.types) || [], n = 0; n < t.length; n++) if (t[n] === 'Files') return 1
      }(e)) && (o = e, n = (i = (n = t).config).pasteFilterStyle, i = i.pasteIgnoreImg, r.getPasteHtml(o, n, i) || r.getPasteText(o)) || (e = r.getPasteImgs(e)).length && new a.default(t).uploadImg(e)
    }t.default = function(t) {
      t.txt.eventHooks.pasteEvents.unshift((e) => {
        i(e, t)
      })
    }
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); const o = n(2).__importDefault(n(98)); t.default = function(t) {
      t.txt.eventHooks.dropEvents.push((e) => {
        (e = e.dataTransfer && e.dataTransfer.files) && e.length && new o.default(t).uploadImg(e)
      })
    }
  }, function(e, t, n) {
    'use strict'; const o = n(0); const i = o(n(1)); const g = o(n(31)); const y = o(n(362)); (0, i.default)(t, '__esModule', { value: !0 }), t.createShowHideFn = void 0; const w = n(2).__importDefault(n(3)); n(367); const l = n(6); function x(e, t, n, o, i) {
      e.attr('style', `width:${t}px; height:${n}px; left:${o}px; top:${i}px;`)
    } function r(e) {
      let A; let t; let n; let v; let m; const r = e.$textContainerElem; const a = (t = r, (n = w.default('<div class="w-e-img-drag-mask">\n            <div class="w-e-img-drag-show-size"></div>\n            <div class="w-e-img-drag-rb"></div>\n         </div>')).hide(), t.append(n), n); function o() {
        (0, g.default)(r).call(r, '.w-e-img-drag-mask')
          .hide()
      } return m = r, (v = a).on('click', (e) => {
        e.stopPropagation()
      }), v.on('mousedown', '.w-e-img-drag-rb', (e) => {
        let t; let n; let o; let i; let r; let a; let l; let u; let s; let c; let f; function d() {
          f.off('mousemove', p), f.off('mouseup', h)
        } function p(e) {
          e.stopPropagation(), e.preventDefault(), s = i + (e.clientX - t), c = r + (e.clientY - n), s / c != u && (c = s / u), s = (0, y.default)(s.toFixed(2)), c = (0, y.default)(c.toFixed(2)), (0, g.default)(v).call(v, '.w-e-img-drag-show-size')
            .text(`${s.toFixed(2).replace('.00', '')}px * ${c.toFixed(2).replace('.00', '')}px`), x(v, s, c, a, l)
        } function h() {
          A.attr('width', `${s}`), A.attr('height', `${c}`); const e = A.getBoundingClientRect(); x(v, s, c, e.left - o.left, e.top - o.top), d()
        }e.preventDefault(), A && (t = e.clientX, n = e.clientY, o = m.getBoundingClientRect(), e = A.getBoundingClientRect(), i = e.width, r = e.height, a = e.left - o.left, l = e.top - o.top, u = i / r, s = i, c = r, (f = w.default(document)).on('mousemove', p), f.on('mouseup', h), f.on('mouseleave', d))
      }), w.default(document).on('click', o), e.beforeDestroy(() => {
        w.default(document).off('click', o)
      }), {
        showDrag: function(e) {
          if (l.UA.isIE()) return !1; let t; let n; let o; let i; e && (n = a, o = A = e, i = (t = r).getBoundingClientRect(), e = o.getBoundingClientRect(), t = e.width.toFixed(2), o = e.height.toFixed(2), (0, g.default)(n).call(n, '.w-e-img-drag-show-size')
            .text(`${t}px * ${o}px`), x(n, (0, y.default)(t), (0, y.default)(o), e.left - i.left, e.top - i.top), n.show())
        },
        hideDrag: o
      }
    }t.createShowHideFn = r, t.default = function(e) {
      const t = (n = r(e)).showDrag; var n = n.hideDrag; e.txt.eventHooks.imgClickEvents.push(t), e.txt.eventHooks.textScrollEvents.push(n), e.txt.eventHooks.keyupEvents.push(n), e.txt.eventHooks.toolbarClickEvents.push(n), e.txt.eventHooks.menuClickEvents.push(n), e.txt.eventHooks.changeEvents.push(n)
    }
  }, function(e, t, n) {
    e.exports = n(363)
  }, function(e, t, n) {
    n = n(364); e.exports = n
  }, function(e, t, n) {
    n(365); n = n(10); e.exports = n.parseFloat
  }, function(e, t, n) {
    const o = n(5); var n = n(366); o({ global: !0, forced: parseFloat != n }, { parseFloat: n })
  }, function(e, t, n) {
    const o = n(8); const i = n(93).trim; var n = n(71); const r = o.parseFloat; var n = 1 / r(`${n}-0`) != -1 / 0; e.exports = n
      ? function(e) {
        const t = i(String(e)); var e = r(t); return e === 0 && t.charAt(0) == '-' ? -0 : e
      }
      : r
  }, function(e, t, n) {
    const o = n(21); let i = n(368); var n = { insert: 'head', singleton: !1 }; o(i = typeof (i = i.__esModule ? i.default : i) === 'string' ? [[e.i, i, '']] : i, n); e.exports = i.locals || {}
  }, function(e, t, n) {
    (t = n(22)(!1)).push([e.i, '.w-e-text-container {\n  overflow: hidden;\n}\n.w-e-img-drag-mask {\n  position: absolute;\n  z-index: 1;\n  border: 1px dashed #ccc;\n  box-sizing: border-box;\n}\n.w-e-img-drag-mask .w-e-img-drag-rb {\n  position: absolute;\n  right: -5px;\n  bottom: -5px;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  background: #ccc;\n  cursor: se-resize;\n}\n.w-e-img-drag-mask .w-e-img-drag-show-size {\n  min-width: 110px;\n  height: 22px;\n  line-height: 22px;\n  font-size: 14px;\n  color: #999;\n  position: absolute;\n  left: 0;\n  top: 0;\n  background-color: #999;\n  color: #fff;\n  border-radius: 2px;\n  padding: 0 5px;\n}\n', '']), e.exports = t
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }), t.createShowHideFn = void 0; const o = n(2); const r = o.__importDefault(n(3)); const a = o.__importDefault(n(36)); function i(n) {
      function o(e, t) {
        return n.i18next.t((t = void 0 === t ? '' : t) + e)
      } let i; return {
        showImgTooltip: function(e) {
          const t = [{
            $elem: r.default("<span class='w-e-icon-trash-o'></span>"),
            onClick: function(e, t) {
              return e.selection.createRangeByElem(t), e.selection.restoreSelection(), e.cmd.do('delete'), !0
            }
          }, {
            $elem: r.default('<span>30%</span>'),
            onClick: function(e, t) {
              return t.attr('width', '30%'), t.removeAttr('height'), !0
            }
          }, {
            $elem: r.default('<span>50%</span>'),
            onClick: function(e, t) {
              return t.attr('width', '50%'), t.removeAttr('height'), !0
            }
          }, {
            $elem: r.default('<span>100%</span>'),
            onClick: function(e, t) {
              return t.attr('width', '100%'), t.removeAttr('height'), !0
            }
          }]; t.push({
            $elem: r.default(`<span>${o('重置')}</span>`),
            onClick: function(e, t) {
              return t.removeAttr('width'), t.removeAttr('height'), !0
            }
          }), e.attr('data-href') && t.push({
            $elem: r.default(`<span>${o('查看链接')}</span>`),
            onClick: function(e, t) {
              t = t.attr('data-href'); return t && (t = decodeURIComponent(t), window.open(t, '_target')), !0
            }
          }), (i = new a.default(n, e, t)).create()
        },
        hideImgTooltip: function() {
          i && (i.remove(), i = null)
        }
      }
    }t.createShowHideFn = i, t.default = function(e) {
      const t = (n = i(e)).showImgTooltip; var n = n.hideImgTooltip; e.txt.eventHooks.imgClickEvents.push(t), e.txt.eventHooks.clickEvents.push(n), e.txt.eventHooks.keyupEvents.push(n), e.txt.eventHooks.toolbarClickEvents.push(n), e.txt.eventHooks.menuClickEvents.push(n), e.txt.eventHooks.textScrollEvents.push(n), e.txt.eventHooks.imgDragBarMouseDownEvents.push(n), e.txt.eventHooks.changeEvents.push(n)
    }
  }, function(e, t, n) {
    'use strict'; const o = n(0); var i = o(n(1)); const A = o(n(26)); const v = o(n(19)); (0, i.default)(t, '__esModule', { value: !0 }); var i = n(2); const m = i.__importDefault(n(3)); const g = n(6); const y = i.__importDefault(n(98)); t.default = function(n) {
      function e(e, t) {
        return n.i18next.t((t = void 0 === t ? 'menus.panelMenus.image.' : t) + e)
      } const o = n.config; const i = new y.default(n); const r = g.getRandom('up-trigger-id'); const a = g.getRandom('up-file-id'); const l = g.getRandom('input-link-url'); const u = g.getRandom('input-link-url-alt'); const s = g.getRandom('input-link-url-href'); let t = g.getRandom('btn-link'); function c(e, t, n) {
        return `<div class="${e}" data-title="${n}">\n            <div id="${r}" class="w-e-up-btn">\n                <i class="${t}"></i>\n            </div>\n            <div style="display:none;">\n                <input id="${a}" type="file" ${f} accept="${d}"/>\n            </div>\n        </div>`
      } var f = o.uploadImgMaxLength === 1 ? '' : 'multiple="multiple"'; var d = (0, A.default)(h = o.uploadImgAccept).call(h, (e) => {
        return `image/${e}`
      })
        .join(','); let p = [{
        selector: `#${r}`,
        type: 'click',
        fn: function() {
          let e = o.uploadImgFromMedia; if (e && typeof e === 'function') return e(), !0; e = m.default(`#${a}`).elems[0]; if (!e) return !0; e.click()
        }
      }, {
        selector: `#${a}`,
        type: 'change',
        fn: function() {
          const e = m.default(`#${a}`).elems[0]; if (!e) return !0; const t = e.files; return t != null && t.length && i.uploadImg(t), e && (e.value = ''), !0
        }
      }]; var h = [`<input\n            id="${l}"\n            type="text"\n            class="block"\n            placeholder="${e('图片地址')}"/>`]; return o.showLinkImgAlt && h.push(`\n        <input\n            id="${u}"\n            type="text"\n            class="block"\n            placeholder="${e('图片文字说明')}"/>`), o.showLinkImgHref && h.push(`\n        <input\n            id="${s}"\n            type="text"\n            class="block"\n            placeholder="${e('跳转链接')}"/>`), t = [{ title: e('上传图片'), tpl: c('w-e-up-img-container', 'w-e-icon-upload2', ''), events: p }, {
        title: e('网络图片'),
        tpl: `<div>\n                    ${h.join('')}\n                    <div class="w-e-button-container">\n                        <button type="button" id="${t}" class="right">${e('插入', '')}</button>\n                    </div>\n                </div>`,
        events: [{
          selector: `#${t}`,
          type: 'click',
          fn: function() {
            let e; let t; var n = m.default(`#${l}`); var n = (0, v.default)(n = n.val()).call(n); if (n && (o.showLinkImgAlt && (e = (0, v.default)(e = m.default(`#${u}`).val()).call(e)), o.showLinkImgHref && (t = (0, v.default)(t = m.default(`#${s}`).val()).call(t)), (function(e) {
              if (!0 === (e = o.linkImgCheck(e))) return 1; typeof e === 'string' && o.customAlert(e, 'error')
            }(n)))) return i.insertImg(n, e, t), !0
          }
        }]
      }], p = { width: 300, height: 0, tabs: [], onlyUploadConf: { $elem: m.default(c('w-e-menu', 'w-e-icon-image', '图片')), events: p } }, window.FileReader && (o.uploadImgShowBase64 || o.uploadImgServer || o.customUploadImg || o.uploadImgFromMedia) && p.tabs.push(t[0]), o.showLinkImg && (p.tabs.push(t[1]), p.onlyUploadConf = void 0), p
    }
  }, function(e, t, n) {
    'use strict'; var o = n(0); var i = o(n(1)); const r = o(n(4)); (0, i.default)(t, '__esModule', { value: !0 }); let a; var o = n(2); const l = o.__importDefault(n(3)); var i = o.__importDefault(n(24)); const u = o.__importDefault(n(372)); var o = (a = i.default, o.__extends(s, a), s.prototype.command = function(t) {
      let e; const n = this.editor; const o = n.selection.getSelectionContainerElem(); o && n.$textElem.equal(o)
        ? (e = n.selection.getSelectionRangeTopNodes()).length > 0 && (0, r.default)(e).call(e, (e) => {
            u.default(l.default(e), t, n)
          })
        : o && o.length > 0 && (0, r.default)(o).call(o, (e) => {
          u.default(l.default(e), t, n)
        }), n.selection.restoreSelection(), this.tryChangeActive()
    }, s.prototype.tryChangeActive = function() {
      var e = this.editor; const t = e.selection.getSelectionStartElem(); var e = l.default(t).getNodeTop(e); e.length <= 0 || (e.elems[0].style.paddingLeft != '' ? this.active() : this.unActive())
    }, s); function s(e) {
      let t = this; const n = l.default('<div class="w-e-menu" data-title="缩进">\n                <i class="w-e-icon-indent-increase"></i>\n            </div>'); const o = {
        width: 130,
        title: '设置缩进',
        type: 'list',
        list: [{ $elem: l.default(`<p>\n                            <i class="w-e-icon-indent-increase w-e-drop-list-item"></i>\n                            ${e.i18next.t('menus.dropListMenu.indent.增加缩进')}\n                        <p>`), value: 'increase' }, { $elem: l.default(`<p>\n                            <i class="w-e-icon-indent-decrease w-e-drop-list-item"></i>\n                            ${e.i18next.t('menus.dropListMenu.indent.减少缩进')}\n                        <p>`), value: 'decrease' }],
        clickHandler: function(e) {
          t.command(e)
        }
      }; return t = a.call(this, n, e, o) || this
    }t.default = o
  }, function(e, t, n) {
    'use strict'; const o = n(0); var i = o(n(1)); const r = o(n(44)); const a = o(n(19)); (0, i.default)(t, '__esModule', { value: !0 }); var i = n(2); const l = i.__importDefault(n(373)); const u = i.__importDefault(n(374)); const s = /^(\d+)(\w+)$/; const c = /^(\d+)%$/; function f(e) {
      const t = e.config.indentation; if (typeof t === 'string') {
        if (s.test(t)) {
          var e = (0, r.default)(n = (0, a.default)(t).call(t)
            .match(s)).call(n, 1, 3); var n = e[0]; var e = e[1]; return { value: Number(n), unit: e }
        } if (c.test(t)) {
          return {
            value: Number((0, a.default)(t).call(t)
              .match(c)[1]),
            unit: '%'
          }
        }
      } else if (void 0 !== t.value && t.unit) return t; return { value: 2, unit: 'em' }
    }t.default = function(e, t, n) {
      e = e.getNodeTop(n), /^P$/i.test(e.getNodeName()) && (t === 'increase' ? l.default(e, f(n)) : t === 'decrease' && u.default(e, f(n)))
    }
  }, function(e, t, n) {
    'use strict'; const o = n(0); const i = o(n(1)); const r = o(n(44)); (0, i.default)(t, '__esModule', { value: !0 }), t.default = function(e, t) {
      let n = e.elems[0]; n.style.paddingLeft === '' ? e.css('padding-left', t.value + t.unit) : (n = n.style.paddingLeft, n = (0, r.default)(n).call(n, 0, n.length - t.unit.length), n = Number(n) + t.value, e.css('padding-left', `${n}${t.unit}`))
    }
  }, function(e, t, n) {
    'use strict'; const o = n(0); const i = o(n(1)); const r = o(n(44)); (0, i.default)(t, '__esModule', { value: !0 }), t.default = function(e, t) {
      let n = e.elems[0]; n.style.paddingLeft !== '' && (n = n.style.paddingLeft, n = (0, r.default)(n).call(n, 0, n.length - t.unit.length), (n = Number(n) - t.value) > 0 ? e.css('padding-left', `${n}${t.unit}`) : e.css('padding-left', ''))
    }
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); let o; var i = n(2); const r = i.__importDefault(n(3)); const a = i.__importDefault(n(35)); const l = i.__importDefault(n(32)); const u = i.__importDefault(n(376)); var i = (o = a.default, i.__extends(s, o), s.prototype.createPanel = function() {
      const e = u.default(this.editor); new l.default(this, e).create()
    }, s.prototype.clickHandler = function() {
      this.createPanel()
    }, s.prototype.tryChangeActive = function() {}, s); function s(e) {
      const t = r.default('<div class="w-e-menu" data-title="表情">\n                <i class="w-e-icon-happy"></i>\n            </div>'); return o.call(this, t, e) || this
    }t.default = i
  }, function(e, t, n) {
    'use strict'; const o = n(0); const i = o(n(1)); const r = o(n(26)); const a = o(n(73)); const l = o(n(19)); (0, i.default)(t, '__esModule', { value: !0 }); const u = n(2).__importDefault(n(3)); t.default = function(o) {
      const e = o.config.emotions; return {
        width: 300,
        height: 230,
        tabs: (0, r.default)(e).call(e, (e) => {
          return {
            title: o.i18next.t(`menus.panelMenus.emoticon.${e.title}`),
            tpl: `<div>${n = [], (n = (t = e).type == 'image'
? (n = (0, r.default)(e = t.content).call(e, (e) => {
          return typeof e === 'string' ? '' : `<span  title="${e.alt}">\n                    <img class="eleImg" data-emoji="${e.alt}" style src="${e.src}" alt="[${e.alt}]">\n                </span>`
        }), (0, a.default)(n).call(n, (e) => {
          return e !== ''
        }))
: (0, r.default)(t = t.content).call(t, (e) => {
          return `<span class="eleImg" title="${e}">${e}</span>`
        })).join('').replace(/&nbsp;/g, '')}</div>`,
            events: [{
              selector: '.eleImg',
              type: 'click',
              fn: function(e) {
                let t = u.default(e.target); return t = t.getNodeName() === 'IMG' ? (0, l.default)(e = t.parent().html()).call(e) : `<span>${t.html()}</span>`, o.cmd.do('insertHTML', t), !0
              }
            }]
          }; let t; let n
        })
      }
    }
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }), t.createListHandle = t.ClassType = void 0; let o; var i = n(2); const r = i.__importDefault(n(3)); const a = i.__importDefault(n(378)); const l = i.__importDefault(n(380)); const u = i.__importDefault(n(381)); const s = i.__importDefault(n(382)); var i = i.__importDefault(n(383)); (n = o = t.ClassType || (t.ClassType = {})).Wrap = 'WrapListHandle', n.Join = 'JoinListHandle', n.StartJoin = 'StartJoinListHandle', n.EndJoin = 'EndJoinListHandle', n.Other = 'OtherListHandle'; const c = { WrapListHandle: a.default, JoinListHandle: l.default, StartJoinListHandle: u.default, EndJoinListHandle: s.default, OtherListHandle: i.default }; t.createListHandle = function(e, t, n) {
      if (e === o.Other && void 0 === n) throw new Error('other 类需要传入 range'); return e !== o.Other ? new c[e](t) : new c[e](t, n)
    }; f.prototype.getSelectionRangeElem = function() {
      return r.default(this.handle.selectionRangeElem.get())
    }, i = f; function f(e) {
      this.handle = e, this.handle.exec()
    }t.default = i
  }, function(e, t, n) {
    'use strict'; var o = n(0); var i = o(n(1)); const A = o(n(4)); (0, i.default)(t, '__esModule', { value: !0 }); let r; var o = n(2); const v = o.__importDefault(n(3)); var i = n(58); const m = n(46); var o = (r = i.ListHandle, o.__extends(a, r), a.prototype.exec = function() {
      let t; var e = this.options; const n = e.listType; const o = e.listTarget; const i = e.$selectionElem; const r = e.$startElem; const a = e.$endElem; const l = []; const u = i == null ? void 0 : i.getNodeName(); var e = r.prior; const s = a.prior; if ((r.prior || a.prior) && (e != null && e.prev().length || s != null && s.next().length)) {
        for (let c = e; c.length;)l.push(c), c = s != null && s.equal(c) ? v.default(void 0) : c.next(); var e = e.prev(); let f = s.next(); if (u === n
          ? t = m.createElementFragment(l, m.createDocumentFragment(), 'p')
          : (t = m.createElement(o), (0, A.default)(l).call(l, (e) => {
              t.append(e.elems[0])
            })), e.length && f.length) {
          for (var d = []; f.length;)d.push(f), f = f.next(); var p; const h = m.createElement(u); (0, A.default)(d).call(d, (e) => {
            h.append(e.elems[0])
          }), v.default(h).insertAfter(i), this.selectionRangeElem.set(t), (p = i.next()).length ? m.insertBefore(i, t, p.elems[0]) : i.parent().elems[0].append(t)
        } else e.length ? (this.selectionRangeElem.set(t), (p = i.next()).length ? m.insertBefore(i, t, p.elems[0]) : i.parent().elems[0].append(t)) : (this.selectionRangeElem.set(t), m.insertBefore(i, t, i.elems[0]))
      } else {
        (0, A.default)(p = i == null ? void 0 : i.children()).call(p, (e) => {
          l.push(v.default(e))
        }), u === n
          ? t = m.createElementFragment(l, m.createDocumentFragment(), 'p')
          : (t = m.createElement(o), (0, A.default)(l).call(l, (e) => {
              t.append(e.elems[0])
            })), this.selectionRangeElem.set(t), m.insertBefore(i, t, i.elems[0]), i.remove()
      }
    }, a); function a(e) {
      return r.call(this, e) || this
    }t.default = o
  }, function(e, t, n) {
    'use strict'; const o = n(0); let i = o(n(1)); const r = o(n(4)); (0, i.default)(t, '__esModule', { value: !0 }); a.prototype.set = function(e) {
      let t; let n; e instanceof DocumentFragment && (n = [], (0, r.default)(t = e.childNodes).call(t, (e) => {
        n.push(e)
      }), e = n), this._element = e
    }, a.prototype.get = function() {
      return this._element
    }, a.prototype.clear = function() {
      this._element = null
    }, i = a; function a() {
      this._element = null
    }t.default = i
  }, function(e, t, n) {
    'use strict'; var o = n(0); var i = o(n(1)); const m = o(n(4)); (0, i.default)(t, '__esModule', { value: !0 }); let r; var o = n(2); const g = o.__importDefault(n(3)); var i = n(58); const y = n(46); var o = (r = i.ListHandle, o.__extends(a, r), a.prototype.exec = function() {
      let t; var e = this.options; var n = e.editor; const o = e.listType; let i = e.listTarget; const r = e.$startElem; var e = e.$endElem; const a = n.selection.getSelectionRangeTopNodes(); var n = r == null ? void 0 : r.getNodeName(); if (n === (e == null ? void 0 : e.getNodeName())) {
        if (a.length > 2) {
          if (a.shift(), a.pop(), t = y.createElementFragment(y.filterSelectionNodes(a), y.createDocumentFragment()), n === o) {
            (p = e.children()) !== null && void 0 !== p && (0, m.default)(p).call(p, (e) => {
              t.append(e)
            }), e.remove(), this.selectionRangeElem.set(t), r.elems[0].append(t)
          } else {
            for (var l = document.createDocumentFragment(), u = document.createDocumentFragment(), s = y.getStartPoint(r); s.length;) {
              const c = s.elems[0]; s = s.next(), l.append(c)
            } for (var f = y.getEndPoint(e), d = []; f.length;)d.unshift(f.elems[0]), f = f.prev(); (0, m.default)(d).call(d, (e) => {
              u.append(e)
            }); var p = y.createElement(i); p.append(l), p.append(t), p.append(u), this.selectionRangeElem.set(t = p), g.default(p).insertAfter(r), (p = r.children()) !== null && void 0 !== p && p.length || r.remove(), (p = e.children()) !== null && void 0 !== p && p.length || e.remove()
          }
        } else {
          a.length = 0; for (s = y.getStartPoint(r); s.length;)a.push(s), s = s.next(); for (f = y.getEndPoint(e), d = []; f.length;)d.unshift(f), f = f.prev(); a.push.apply(a, d), n === o
            ? (t = y.createElementFragment(a, y.createDocumentFragment(), 'p'), this.selectionRangeElem.set(t), y.insertBefore(r, t, e.elems[0]))
            : (t = y.createElement(i), (0, m.default)(a).call(a, (e) => {
                t.append(e.elems[0])
              }), this.selectionRangeElem.set(t), g.default(t).insertAfter(r)), (i = r.children()) !== null && void 0 !== i && i.length || e.remove(), (i = e.children()) !== null && void 0 !== i && i.length || e.remove()
        }
      } else {
        for (var h = [], f = y.getEndPoint(e); f.length;)h.unshift(f), f = f.prev(); for (var A, v = [], s = y.getStartPoint(r); s.length;)v.push(s), s = s.next(); t = y.createDocumentFragment(), a.shift(), a.pop(), (0, m.default)(v).call(v, (e) => {
          return t.append(e.elems[0])
        }), t = y.createElementFragment(y.filterSelectionNodes(a), t), (0, m.default)(h).call(h, (e) => {
          return t.append(e.elems[0])
        }), this.selectionRangeElem.set(t), n === o ? (r.elems[0].append(t), (A = e.children()) !== null && void 0 !== A && A.length || e.remove()) : (A = e.children()) !== null && void 0 !== A && A.length ? (A = e.children(), y.insertBefore(A, t, A.elems[0])) : e.elems[0].append(t)
      }
    }, a); function a(e) {
      return r.call(this, e) || this
    }t.default = o
  }, function(e, t, n) {
    'use strict'; var o = n(0); var i = o(n(1)); const u = o(n(4)); (0, i.default)(t, '__esModule', { value: !0 }); let r; var o = n(2); const s = o.__importDefault(n(3)); var i = n(58); const c = n(46); var o = (r = i.ListHandle, o.__extends(a, r), a.prototype.exec = function() {
      let t; var e = this.options; var n = e.editor; const o = e.listType; const i = e.listTarget; const r = e.$startElem; var e = n.selection.getSelectionRangeTopNodes(); var n = r == null ? void 0 : r.getNodeName(); e.shift(); for (var a = [], l = c.getStartPoint(r); l.length;)a.push(l), l = l.next(); n === o
        ? (t = c.createDocumentFragment(), (0, u.default)(a).call(a, (e) => {
            return t.append(e.elems[0])
          }), t = c.createElementFragment(c.filterSelectionNodes(e), t), this.selectionRangeElem.set(t), r.elems[0].append(t))
        : (t = c.createElement(i), (0, u.default)(a).call(a, (e) => {
            return t.append(e.elems[0])
          }), t = c.createElementFragment(c.filterSelectionNodes(e), t), this.selectionRangeElem.set(t), s.default(t).insertAfter(r), (e = r.children()) !== null && void 0 !== e && e.length || r.remove())
    }, a); function a(e) {
      return r.call(this, e) || this
    }t.default = o
  }, function(e, t, n) {
    'use strict'; var o = n(0); var i = o(n(1)); const u = o(n(4)); (0, i.default)(t, '__esModule', { value: !0 }); let r; var o = n(2); const s = o.__importDefault(n(3)); var i = n(58); const c = n(46); var o = (r = i.ListHandle, o.__extends(a, r), a.prototype.exec = function() {
      var e = this.options; var t = e.editor; let n = e.listType; let o = e.listTarget; const i = e.$endElem; var e = t.selection.getSelectionRangeTopNodes(); var t = i == null ? void 0 : i.getNodeName(); e.pop(); for (var r, a = [], l = c.getEndPoint(i); l.length;)a.unshift(l), l = l.prev(); t === n
        ? (r = c.createElementFragment(c.filterSelectionNodes(e), c.createDocumentFragment()), (0, u.default)(a).call(a, (e) => {
            return r.append(e.elems[0])
          }), this.selectionRangeElem.set(r), (n = i.children()) !== null && void 0 !== n && n.length ? (n = i.children(), c.insertBefore(n, r, n.elems[0])) : i.elems[0].append(r))
        : ((e = c.filterSelectionNodes(e)).push.apply(e, a), r = c.createElementFragment(e, c.createElement(o)), this.selectionRangeElem.set(r), s.default(r).insertBefore(i), (o = i.children()) !== null && void 0 !== o && o.length || i.remove())
    }, a); function a(e) {
      return r.call(this, e) || this
    }t.default = o
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); let o; var i = n(2); const r = n(58); const a = n(46); var i = (o = r.ListHandle, i.__extends(l, o), l.prototype.exec = function() {
      var e = this.options; var t = e.editor; var e = e.listTarget; var t = t.selection.getSelectionRangeTopNodes(); var e = a.createElementFragment(a.filterSelectionNodes(t), a.createElement(e)); this.selectionRangeElem.set(e), this.range.insertNode(e)
    }, l); function l(e, t) {
      e = o.call(this, e) || this; return e.range = t, e
    }t.default = i
  }, function(e, t, n) {
    'use strict'; var o = n(0); var i = o(n(1)); const x = o(n(4)); const _ = o(n(27)); (0, i.default)(t, '__esModule', { value: !0 }); let r; var o = n(2); var i = o.__importDefault(n(24)); const E = o.__importDefault(n(3)); const a = o.__importDefault(n(385)); const b = n(6); var o = (r = i.default, o.__extends(l, r), l.prototype.command = function(t) {
      const n = this; const e = (window.getSelection ? window : document).getSelection(); const o = ['P']; const i = this.editor; let r = ''; i.selection.restoreSelection(); var a = E.default(i.selection.getSelectionContainerElem()); if (a != null && a.length) {
        const l = E.default(i.selection.getSelectionContainerElem()); let u = E.default(i.selection.getSelectionStartElem()).elems[0]; let s = ''; let c = []; let f = ''; if (a && i.$textElem.equal(a)) {
          if (b.UA.isIE()) return; const d = []; const p = []; const h = []; const A = E.default(i.selection.getSelectionStartElem()); const v = E.default(i.selection.getSelectionEndElem()); var a = (a = i.selection.getRange()) === null || void 0 === a ? void 0 : a.commonAncestorContainer.childNodes; p.push(this.getDom(A.elems[0])), a != null && (0, x.default)(a).call(a, (e, t) => {
            e === n.getDom(A.elems[0]) && d.push(t), e === n.getDom(v.elems[0]) && d.push(t)
          }); let m; var g = 0; for (h.push(this.getDom(A.elems[0])); p[g] !== this.getDom(v.elems[0]);)m = E.default(p[g].nextElementSibling).elems[0], (0, _.default)(o).call(o, E.default(m).getNodeName()) !== -1 && h.push(m), p.push(m), g++; if (E.default(p[0]).getNodeName() !== 'P') {
            for (var g = 0, y = 0; y < p.length; y++) {
              if (E.default(p[y]).getNodeName() === 'P') {
                g = y; break
              }
            } if (g === 0) return; for (let w = 0; w !== g;)p.shift(), w++
          } return this.setRange(p[0], p[p.length - 1]), (0, x.default)(p).call(p, (e) => {
            s = e.getAttribute('style'), c = s ? s.split(';') : [], f = '', r = (f = E.default(e).getNodeName() === 'P' && t ? `${n.styleProcessing(c)}line-height:${t};` : n.styleProcessing(c), `${r}<${E.default(e).getNodeName()
.toLowerCase()} style="${f}">${e.innerHTML}</${E.default(e).getNodeName()
.toLowerCase()}` + '>')
          }), this.action(r, i), u = l.elems[0], void this.setRange(u.children[d[0]], u.children[d[1]])
        }u = this.getDom(u), (0, _.default)(o).call(o, E.default(u).getNodeName()) !== -1 && (s = u.getAttribute('style'), c = s ? s.split(';') : [], e != null && e.selectAllChildren(u), i.selection.saveRange(), t
          ? (f = s ? `${this.styleProcessing(c)}line-height:${t};` : `line-height:${t};`, r = `<${E.default(u).getNodeName()
          .toLowerCase()} style="${f}">${u.innerHTML}</${E.default(u).getNodeName()
          .toLowerCase()}>`, E.default(u).getNodeName() === 'BLOCKQUOTE' ? E.default(u).css('line-height', t) : this.action(r, i))
          : s && (f = this.styleProcessing(c), r = f === ''
            ? `<${E.default(u).getNodeName()
          .toLowerCase()}>${u.innerHTML}</${E.default(u).getNodeName()
          .toLowerCase()}>`
            : `<${E.default(u).getNodeName()
          .toLowerCase()} style="${f}">${u.innerHTML}</${E.default(u).getNodeName()
          .toLowerCase()}>`, this.action(r, i)))
      }
    }, l.prototype.getDom = function(e) {
      e = E.default(e).elems[0]; return e.parentNode
        ? e = (function e(t, n) {
          const o = E.default(t.parentNode); return n.$textElem.equal(o) ? t : e(o.elems[0], n)
        }(e, this.editor))
        : e
    }, l.prototype.action = function(e, t) {
      t.cmd.do('insertHTML', e)
    }, l.prototype.styleProcessing = function(e) {
      let t = ''; return (0, x.default)(e).call(e, (e) => {
        e !== '' && (0, _.default)(e).call(e, 'line-height') === -1 && (t = `${t + e};`)
      }), t
    }, l.prototype.setRange = function(e, t) {
      const n = this.editor; const o = (window.getSelection ? window : document).getSelection(); o != null && o.removeAllRanges(); const i = document.createRange(); var t = t; i.setStart(e, 0), i.setEnd(t, 1), o != null && o.addRange(i), n.selection.saveRange(), o != null && o.removeAllRanges(), n.selection.restoreSelection()
    }, l.prototype.tryChangeActive = function() {
      let e = this.editor; const t = e.selection.getSelectionContainerElem(); t && e.$textElem.equal(t) || (e = E.default(e.selection.getSelectionStartElem())).length !== 0 && ((e = (e = this.getDom(e.elems[0])).getAttribute('style') ? e.getAttribute('style') : '') && (0, _.default)(e).call(e, 'line-height') !== -1 ? this.active() : this.unActive())
    }, l); function l(t) {
      let n = this; const e = E.default('<div class="w-e-menu" data-title="行高">\n                    <i class="w-e-icon-row-height"></i>\n                </div>'); const o = {
        width: 100,
        title: '设置行高',
        type: 'list',
        list: new a.default(t, t.config.lineHeights).getItemList(),
        clickHandler: function(e) {
          t.selection.saveRange(), n.command(e)
        }
      }; return n = r.call(this, e, t, o) || this
    }t.default = o
  }, function(e, t, n) {
    'use strict'; const o = n(0); const i = o(n(1)); const r = o(n(4)); (0, i.default)(t, '__esModule', { value: !0 }); const a = n(2).__importDefault(n(3)); var n = (l.prototype.getItemList = function() {
      return this.itemList
    }, l); function l(e, t) {
      const n = this; this.itemList = [{ $elem: a.default(`<span>${e.i18next.t('默认')}</span>`), value: '' }], (0, r.default)(t).call(t, (e) => {
        n.itemList.push({ $elem: a.default(`<span>${e}</span>`), value: e })
      })
    }t.default = n
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); let o; var i = n(2); const r = i.__importDefault(n(3)); var n = i.__importDefault(n(23)); var i = (o = n.default, i.__extends(a, o), a.prototype.clickHandler = function() {
      const e = this.editor; e.history.revoke(); let t = e.$textElem.children(); t != null && t.length && (t = t.last(), e.selection.createRangeByElem(t, !1, !0), e.selection.restoreSelection())
    }, a.prototype.tryChangeActive = function() {
      this.editor.isCompatibleMode || (this.editor.history.size[0] ? this.active() : this.unActive())
    }, a); function a(e) {
      const t = r.default('<div class="w-e-menu" data-title="撤销">\n                <i class="w-e-icon-undo"></i>\n            </div>'); return o.call(this, t, e) || this
    }t.default = i
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); let o; var i = n(2); const r = i.__importDefault(n(3)); var n = i.__importDefault(n(23)); var i = (o = n.default, i.__extends(a, o), a.prototype.clickHandler = function() {
      const e = this.editor; e.history.restore(); let t = e.$textElem.children(); t != null && t.length && (t = t.last(), e.selection.createRangeByElem(t, !1, !0), e.selection.restoreSelection())
    }, a.prototype.tryChangeActive = function() {
      this.editor.isCompatibleMode || (this.editor.history.size[1] ? this.active() : this.unActive())
    }, a); function a(e) {
      const t = r.default('<div class="w-e-menu" data-title="恢复">\n                <i class="w-e-icon-redo"></i>\n            </div>'); return o.call(this, t, e) || this
    }t.default = i
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); let o; var i = n(2); const r = i.__importDefault(n(35)); const a = i.__importDefault(n(3)); const l = i.__importDefault(n(389)); const u = i.__importDefault(n(32)); const s = i.__importDefault(n(398)); var i = (o = r.default, i.__extends(c, o), c.prototype.clickHandler = function() {
      this.createPanel()
    }, c.prototype.createPanel = function() {
      const e = l.default(this.editor); new u.default(this, e).create()
    }, c.prototype.tryChangeActive = function() {}, c); function c(e) {
      const t = a.default('<div class="w-e-menu" data-title="表格"><i class="w-e-icon-table2"></i></div>'); const n = o.call(this, t, e) || this; return s.default(e), n
    }t.default = i
  }, function(e, t, n) {
    'use strict'; const o = n(0); var i = o(n(1)); const r = o(n(390)); (0, i.default)(t, '__esModule', { value: !0 }); var i = n(2); const l = n(6); const u = i.__importDefault(n(3)); n(395); const s = i.__importDefault(n(397)); function c(e) {
      return e > 0 && (0, r.default)(e)
    }t.default = function(n) {
      const o = new s.default(n); const i = l.getRandom('w-col-id'); const r = l.getRandom('w-row-id'); let e = l.getRandom('btn-link'); const t = 'menus.panelMenus.table.'; var a = [{
        title: (a = function(e) {
          return n.i18next.t(e)
        })(`${t}插入表格`),
        tpl: `<div>\n                    <div class="w-e-table">\n                        <span>${a('创建')}</span>\n                        <input id="${r}"  type="text" class="w-e-table-input" value="5"/></td>\n                        <span>${a(`${t}行`)}</span>\n                        <input id="${i}" type="text" class="w-e-table-input" value="5"/></td>\n                        <span>${a(`${t}列`) + a(`${t}的`) + a(`${t}表格`)}</span>\n                    </div>\n                    <div class="w-e-button-container">\n                        <button type="button" id="${e}" class="right">${a('插入')}</button>\n                    </div>\n                </div>`,
        events: [{
          selector: `#${e}`,
          type: 'click',
          fn: function() {
            const e = Number(u.default(`#${i}`).val()); const t = Number(u.default(`#${r}`).val()); return c(t) && c(e) ? (o.createAction(t, e), !0) : (n.config.customAlert('表格行列请输入正整数', 'warning'), !1)
          }
        }]
      }]; return (e = { width: 330, height: 0, tabs: [] }).tabs.push(a[0]), e
    }
  }, function(e, t, n) {
    e.exports = n(391)
  }, function(e, t, n) {
    n = n(392); e.exports = n
  }, function(e, t, n) {
    n(393); n = n(10); e.exports = n.Number.isInteger
  }, function(e, t, n) {
    n(5)({ target: 'Number', stat: !0 }, { isInteger: n(394) })
  }, function(e, t, n) {
    const o = n(13); const i = Math.floor; e.exports = function(e) {
      return !o(e) && isFinite(e) && i(e) === e
    }
  }, function(e, t, n) {
    const o = n(21); let i = n(396); var n = { insert: 'head', singleton: !1 }; o(i = typeof (i = i.__esModule ? i.default : i) === 'string' ? [[e.i, i, '']] : i, n); e.exports = i.locals || {}
  }, function(e, t, n) {
    (t = n(22)(!1)).push([e.i, '.w-e-table {\n  display: flex;\n}\n.w-e-table .w-e-table-input {\n  width: 40px;\n  text-align: center!important;\n  margin: 0 5px;\n}\n', '']), e.exports = t
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); const o = n(2); const a = n(7); const r = o.__importDefault(n(3)); var n = (i.prototype.createAction = function(e, t) {
      const n = this.editor; var o = r.default(n.selection.getSelectionContainerElem()); const i = r.default(o.elems[0]).parentUntilEditor('UL', n); var o = r.default(o.elems[0]).parentUntilEditor('OL', n); i || o || (t = this.createTableHtml(e, t), n.cmd.do('insertHTML', t))
    }, i.prototype.createTableHtml = function(e, t) {
      for (var n = '', o = '', i = 0; i < e; i++) {
        for (var o = '', r = 0; r < t; r++)o += i === 0 ? '<th></th>' : '<td></td>'; n = `${n}<tr>${o}</tr>`
      } return `<table border="0" width="100%" cellpadding="0" cellspacing="0"><tbody>${n}</tbody></table>${a.EMPTY_P}`
    }, i); function i(e) {
      this.editor = e
    }t.default = n
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); const o = n(2); const i = o.__importDefault(n(399)); const r = o.__importDefault(n(407)); t.default = function(e) {
      i.default(e), r.default(e)
    }
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); const o = n(2); const l = o.__importDefault(n(3)); const i = o.__importDefault(n(36)); const u = o.__importDefault(n(400)); const r = o.__importDefault(n(406)); const s = n(7); function a(n) {
      let o; return {
        showTableTooltip: function(e) {
          const a = new r.default(n); var t = function(e, t) {
            return n.i18next.t((t = void 0 === t ? 'menus.panelMenus.table.' : t) + e)
          }; var t = [{
            $elem: l.default(`<span>${t('删除表格')}</span>`),
            onClick: function(e, t) {
              return e.selection.createRangeByElem(t), e.selection.restoreSelection(), e.cmd.do('insertHTML', s.EMPTY_P), !0
            }
          }, {
            $elem: l.default(`<span>${t('添加行')}</span>`),
            onClick: function(e, t) {
              if (c(e)) return !0; let n = l.default(e.selection.getSelectionStartElem()); let o = a.getRowNode(n.elems[0]); if (!o) return !0; n = Number(a.getCurrentRowIndex(t.elems[0], o)), o = a.getTableHtml(t.elems[0]), n = f(t, n = a.getTableHtml(u.default.ProcessingRow(l.default(o), n).elems[0])); return e.selection.createRangeByElem(t), e.selection.restoreSelection(), e.cmd.do('insertHTML', n), !0
            }
          }, {
            $elem: l.default(`<span>${t('删除行')}</span>`),
            onClick: function(e, t) {
              if (c(e)) return !0; var n = l.default(e.selection.getSelectionStartElem()); var o = a.getRowNode(n.elems[0]); if (!o) return !0; const i = Number(a.getCurrentRowIndex(t.elems[0], o)); const r = a.getTableHtml(t.elems[0]); var n = u.default.DeleteRow(l.default(r), i).elems[0].children[0].children.length; var o = ''; return e.selection.createRangeByElem(t), e.selection.restoreSelection(), o = f(t, o = n === 0 ? s.EMPTY_P : a.getTableHtml(u.default.DeleteRow(l.default(r), i).elems[0])), e.cmd.do('insertHTML', o), !0
            }
          }, {
            $elem: l.default(`<span>${t('添加列')}</span>`),
            onClick: function(e, t) {
              if (c(e)) return !0; var n = l.default(e.selection.getSelectionStartElem()); var o = a.getCurrentColIndex(n.elems[0]); var n = a.getTableHtml(t.elems[0]); var o = f(t, o = a.getTableHtml(u.default.ProcessingCol(l.default(n), o).elems[0])); return e.selection.createRangeByElem(t), e.selection.restoreSelection(), e.cmd.do('insertHTML', o), !0
            }
          }, {
            $elem: l.default(`<span>${t('删除列')}</span>`),
            onClick: function(e, t) {
              if (c(e)) return !0; var n = l.default(e.selection.getSelectionStartElem()); var o = a.getCurrentColIndex(n.elems[0]); var i = a.getTableHtml(t.elems[0]); var n = u.default.DeleteCol(l.default(i), o); var i = n.elems[0].children[0].children[0].children.length; var o = ''; return e.selection.createRangeByElem(t), e.selection.restoreSelection(), o = f(t, o = i === 0 ? s.EMPTY_P : a.getTableHtml(n.elems[0])), e.cmd.do('insertHTML', o), !0
            }
          }, {
            $elem: l.default(`<span>${t('设置表头')}</span>`),
            onClick: function(e, t) {
              if (c(e)) return !0; let n = l.default(e.selection.getSelectionStartElem()); let o = a.getRowNode(n.elems[0]); if (!o) return !0; n = Number(a.getCurrentRowIndex(t.elems[0], o)); n !== 0 && (n = 0); o = a.getTableHtml(t.elems[0]), n = f(t, n = a.getTableHtml(u.default.setTheHeader(l.default(o), n, 'th').elems[0])); return e.selection.createRangeByElem(t), e.selection.restoreSelection(), e.cmd.do('insertHTML', n), !0
            }
          }, {
            $elem: l.default(`<span>${t('取消表头')}</span>`),
            onClick: function(e, t) {
              let n = l.default(e.selection.getSelectionStartElem()); let o = a.getRowNode(n.elems[0]); if (!o) return !0; n = Number(a.getCurrentRowIndex(t.elems[0], o)); n !== 0 && (n = 0); o = a.getTableHtml(t.elems[0]), n = f(t, n = a.getTableHtml(u.default.setTheHeader(l.default(o), n, 'td').elems[0])); return e.selection.createRangeByElem(t), e.selection.restoreSelection(), e.cmd.do('insertHTML', n), !0
            }
          }]; (o = new i.default(n, e, t)).create()
        },
        hideTableTooltip: function() {
          o && (o.remove(), o = null)
        }
      }
    } function c(e) {
      const t = e.selection.getSelectionStartElem(); var e = e.selection.getSelectionEndElem(); return (t == null ? void 0 : t.elems[0]) !== (e == null ? void 0 : e.elems[0])
    } function f(e, t) {
      e = e.elems[0].nextSibling; return e && e.innerHTML !== '<br>' || (t += `${s.EMPTY_P}`), t
    }t.default = function(e) {
      const t = (n = a(e)).showTableTooltip; var n = n.hideTableTooltip; e.txt.eventHooks.tableClickEvents.push(t), e.txt.eventHooks.clickEvents.push(n), e.txt.eventHooks.keyupEvents.push(n), e.txt.eventHooks.toolbarClickEvents.push(n), e.txt.eventHooks.menuClickEvents.push(n), e.txt.eventHooks.textScrollEvents.push(n)
    }
  }, function(e, t, n) {
    'use strict'; const o = n(0); const i = o(n(1)); const l = o(n(44)); const u = o(n(94)); const s = o(n(4)); const c = o(n(138)); (0, i.default)(t, '__esModule', { value: !0 }); const f = n(2).__importDefault(n(3)); function d(e, t) {
      for (;e.children.length !== 0;)e.removeChild(e.children[0]); for (let n = 0; n < t.length; n++)e.appendChild(t[n])
    } function p(e) {
      let t = e.elems[0].children[0]; return t = t.nodeName === 'COLGROUP' ? e.elems[0].children[e.elems[0].children.length - 1] : t
    }t.default = {
      ProcessingRow: function(e, t) {
        for (var n = p(e), o = (e = (0, l.default)(Array.prototype).apply(n.children))[0].children.length, i = document.createElement('tr'), r = 0; r < o; r++) {
          const a = document.createElement('td'); i.appendChild(a)
        } return (0, u.default)(e).call(e, t + 1, 0, i), d(n, e), f.default(n.parentNode)
      },
      ProcessingCol: function(e, i) {
        for (var e = p(e), r = (0, l.default)(Array.prototype).apply(e.children), t = 0; t < r.length; t++) {
          !(function(e) {
            const t = []; for ((0, s.default)(n = (0, c.default)(r[e].children)).call(n, (e) => {
              t.push(e)
            }); r[e].children.length !== 0;)r[e].removeChild(r[e].children[0]); var n = f.default(t[0]).getNodeName() !== 'TH' ? document.createElement('td') : document.createElement('th'); (0, u.default)(t).call(t, i + 1, 0, n); for (let o = 0; o < t.length; o++)r[e].appendChild(t[o])
          }(t))
        } return d(e, r), f.default(e.parentNode)
      },
      DeleteRow: function(e, t) {
        const n = p(e); var e = (0, l.default)(Array.prototype).apply(n.children); return (0, u.default)(e).call(e, t, 1), d(n, e), f.default(n.parentNode)
      },
      DeleteCol: function(e, i) {
        for (var e = p(e), r = (0, l.default)(Array.prototype).apply(e.children), t = 0; t < r.length; t++) {
          !(function(e) {
            let t; const n = []; for ((0, s.default)(t = (0, c.default)(r[e].children)).call(t, (e) => {
              n.push(e)
            }); r[e].children.length !== 0;)r[e].removeChild(r[e].children[0]); (0, u.default)(n).call(n, i, 1); for (let o = 0; o < n.length; o++)r[e].appendChild(n[o])
          }(t))
        } return d(e, r), f.default(e.parentNode)
      },
      setTheHeader: function(e, t, n) {
        for (var o = p(e), i = (e = (0, l.default)(Array.prototype).apply(o.children))[t].children, r = document.createElement('tr'), a = 0; a < i.length; a++) {
          !(function(e) {
            const t = document.createElement(n); (0, s.default)(e = (0, c.default)(i[e].children)).call(e, (e) => {
              t.appendChild(e)
            }), r.appendChild(t)
          }(a))
        } return (0, u.default)(e).call(e, t, 1, r), d(o, e), f.default(o.parentNode)
      }
    }
  }, function(e, t, n) {
    n = n(402); e.exports = n
  }, function(e, t, n) {
    n(52), n(403); n = n(10); e.exports = n.Array.from
  }, function(e, t, n) {
    const o = n(5); const i = n(404); o({
      target: 'Array',
      stat: !0,
      forced: !n(113)((e) => {
        Array.from(e)
      })
    }, { from: i })
  }, function(e, t, n) {
    'use strict'; const p = n(38); const h = n(25); const A = n(405); const v = n(105); const m = n(34); const g = n(72); const y = n(107); e.exports = function(e) {
      let t; let n; let o; let i; let r; let a; const l = h(e); const u = typeof this === 'function' ? this : Array; const s = arguments.length; let c = s > 1 ? arguments[1] : void 0; const f = void 0 !== c; var e = y(l); let d = 0; if (f && (c = p(c, s > 2 ? arguments[2] : void 0, 2)), e == null || u == Array && v(e)) for (n = new u(t = m(l.length)); d < t; d++)a = f ? c(l[d], d) : l[d], g(n, d, a); else for (r = (i = e.call(l)).next, n = new u(); !(o = r.call(i)).done; d++)a = f ? A(i, c, [o.value, d], !0) : o.value, g(n, d, a); return n.length = d, n
    }
  }, function(e, t, n) {
    const i = n(20); const r = n(108); e.exports = function(t, e, n, o) {
      try {
        return o ? e(i(n)[0], n[1]) : e(n)
      } catch (e) {
        throw r(t), e
      }
    }
  }, function(e, t, n) {
    'use strict'; const o = n(0); const i = o(n(1)); const r = o(n(4)); const a = o(n(138)); (0, i.default)(t, '__esModule', { value: !0 }); const l = n(2).__importDefault(n(3)); var n = (u.prototype.getRowNode = function(e) {
      let t = l.default(e).elems[0]; return t.parentNode ? t = (e = l.default(t).parentUntil('TR', t)) === null || void 0 === e ? void 0 : e.elems[0] : t
    }, u.prototype.getCurrentRowIndex = function(e, n) {
      let o = 0; let t = e.children[0]; return t.nodeName === 'COLGROUP' && (t = e.children[e.children.length - 1]), (0, r.default)(t = (0, a.default)(t.children)).call(t, (e, t) => {
        e === n && (o = t)
      }), o
    }, u.prototype.getCurrentColIndex = function(e) {
      let n = 0; const o = l.default(e).getNodeName() === 'TD' || l.default(e).getNodeName() === 'TH' ? e : (t = l.default(e).parentUntil('TD', e)) === null || void 0 === t ? void 0 : t.elems[0]; var t = l.default(o).parent(); return (0, r.default)(t = (0, a.default)(t.elems[0].children)).call(t, (e, t) => {
        e === o && (n = t)
      }), n
    }, u.prototype.getTableHtml = function(e) {
      return `<table border="0" width="100%" cellpadding="0" cellspacing="0">${l.default(e).html()}</table>`
    }, u); function u(e) {
      this.editor = e
    }t.default = n
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }), t.default = function(o) {
      const e = o.txt; const i = o.selection; e.eventHooks.keydownEvents.push((e) => {
        o.selection.saveRange(); let t; let n = i.getSelectionContainerElem(); !n || (n = (t = n.getNodeTop(o)).length && t.prev().length ? t.prev() : null) && n.getNodeName() === 'TABLE' && i.isSelectionEmpty() && i.getCursorPos() === 0 && e.keyCode === 8 && (!!(n = t.next()).length && (function(e) {
          if (e.length) {
            e = e.elems[0]; return e.nodeName === 'P' && e.innerHTML === '<br>'
          }
        }(t)) && (t.remove(), o.selection.setRangeToElem(n.elems[0])), e.preventDefault())
      })
    }
  }, function(e, t, n) {
    'use strict'; var o = n(0); var i = o(n(1)); const a = o(n(26)); (0, i.default)(t, '__esModule', { value: !0 }), t.formatCodeHtml = void 0; var o = n(2); var i = o.__importDefault(n(35)); const r = o.__importDefault(n(3)); const l = n(6); const u = o.__importDefault(n(409)); const s = o.__importDefault(n(139)); const c = o.__importDefault(n(32)); const f = o.__importDefault(n(410)); t.formatCodeHtml = function(e, t) {
      return t && (t = (function e(t) {
        let n; const o = t.match(/<span\sclass="hljs[\s|\S]+?\/span>/gm); if (!o || !o.length) return t; const i = (0, a.default)(n = l.deepClone(o)).call(n, (e) => {
          return (e = e.replace(/<span\sclass="hljs[^>]+>/, '')).replace(/<\/span>/, '')
        }); for (let r = 0; r < o.length; r++)t = t.replace(o[r], i[r]); return e(t)
      }(t)), (o = (n = t).match(/<pre[\s|\S]+?\/pre>/g)) === null || (0, a.default)(o).call(o, (e) => {
        n = n.replace(e, e.replace(/<\/code><code>/g, '\n').replace(/<br>/g, ''))
      }), t = l.replaceSpecialSymbol(t = n)); let n; let o
    }; let d; var o = (d = i.default, o.__extends(p, d), p.prototype.insertLineCode = function(e) {
      const t = this.editor; var e = r.default(`<code>${e}</code>`); t.cmd.do('insertElem', e), t.selection.createRangeByElem(e, !1), t.selection.restoreSelection()
    }, p.prototype.clickHandler = function() {
      const e = this.editor; const t = e.selection.getSelectionText(); this.isActive || (e.selection.isSelectionEmpty() ? this.createPanel('', '') : this.insertLineCode(t))
    }, p.prototype.createPanel = function(e, t) {
      t = u.default(this.editor, e, t); new c.default(this, t).create()
    }, p.prototype.tryChangeActive = function() {
      const e = this.editor; s.default(e) ? this.active() : this.unActive()
    }, p); function p(e) {
      const t = r.default('<div class="w-e-menu" data-title="代码"><i class="w-e-icon-terminal"></i></div>'); const n = d.call(this, t, e) || this; return f.default(e), n
    }t.default = o
  }, function(e, t, n) {
    'use strict'; const o = n(0); var i = o(n(1)); const s = o(n(26)); (0, i.default)(t, '__esModule', { value: !0 }); var i = n(2); const c = n(6); const f = i.__importDefault(n(3)); const d = i.__importDefault(n(139)); const p = n(7); t.default = function(o, e, t) {
      let n; const i = c.getRandom('input-iframe'); const r = c.getRandom('select'); const a = c.getRandom('btn-ok'); function l(e) {
        let t; d.default(o) && d.default(o) && ((t = (t = o.selection.getSelectionStartElem()) == null ? void 0 : t.getNodeTop(o)) && (o.selection.createRangeByElem(t), o.selection.restoreSelection())), ((t = o.selection.getSelectionStartElem()) === null || void 0 === t ? void 0 : t.elems[0].innerHTML) && o.cmd.do('insertHTML', p.EMPTY_P), o.cmd.do('insertHTML', e); e = o.selection.getSelectionStartElem(), e = e == null ? void 0 : e.getNodeTop(o); f.default(p.EMPTY_P).insertAfter(e)
      } function u(e) {
        return o.i18next.t(e)
      } return {
        width: 500,
        height: 0,
        tabs: [{
          title: u('menus.panelMenus.code.插入代码'),
          tpl: `<div>\n                        <select name="" id="${r}">\n                            ${(0, s.default)(n = o.config.languageType).call(n, (e) => {
return `<option ${t == e ? 'selected' : ''} value ="${e}">${e}</option>`
})}\n                        </select>\n                        <textarea id="${i}" type="text" class="wang-code-textarea" placeholder="" style="height: 160px">${e.replace(/&quot;/g, '"')}</textarea>\n                        <div class="w-e-button-container">\n                            <button type="button" id="${a}" class="right">${d.default(o) ? u('修改') : u('插入')}</button>\n                        </div>\n                    </div>`,
          events: [{
            selector: `#${a}`,
            type: 'click',
            fn: function() {
              var e = document.getElementById(i); const t = f.default(`#${r}`).val(); const n = e.value; var e = o.highlight ? o.highlight.highlightAuto(n).value : `<xmp>${n}</xmp>`; if (n) return !d.default(o) && (l(`<pre><code class="${t}">${e}</code></pre>`), !0)
            }
          }]
        }]
      }
    }
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); const o = n(2); const i = o.__importDefault(n(411)); const r = o.__importDefault(n(412)); t.default = function(e) {
      i.default(e), r.default(e)
    }
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }), t.createShowHideFn = void 0; const o = n(2); const r = o.__importDefault(n(3)); const a = o.__importDefault(n(36)); function i(o) {
      let i; return {
        showCodeTooltip: function(e) {
          let t; var n = [{
            $elem: r.default(`<span>${n = '删除代码', o.i18next.t((t = void 0 === t ? 'menus.panelMenus.code.' : t) + n)}</span>`),
            onClick: function(e, t) {
              return t.remove(), !0
            }
          }]; (i = new a.default(o, e, n)).create()
        },
        hideCodeTooltip: function() {
          i && (i.remove(), i = null)
        }
      }
    }t.createShowHideFn = i, t.default = function(e) {
      const t = (n = i(e)).showCodeTooltip; var n = n.hideCodeTooltip; e.txt.eventHooks.codeClickEvents.push(t), e.txt.eventHooks.clickEvents.push(n), e.txt.eventHooks.toolbarClickEvents.push(n), e.txt.eventHooks.menuClickEvents.push(n), e.txt.eventHooks.textScrollEvents.push(n)
    }
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); const o = n(2); const r = n(7); const a = o.__importDefault(n(3)); t.default = function(o) {
      const n = o.$textElem; const i = o.selection; const e = o.txt.eventHooks.keydownEvents; e.push((e) => {
        let t; e.keyCode === 40 && (t = i.getSelectionContainerElem(), e = (e = n.children()) === null || void 0 === e ? void 0 : e.last(), (t == null ? void 0 : t.elems[0].tagName) === 'XMP' && (e == null ? void 0 : e.elems[0].tagName) === 'PRE' && (e = a.default(r.EMPTY_P), n.append(e)))
      }), e.push((e) => {
        o.selection.saveRange(); let t; let n = i.getSelectionContainerElem(); n && (n = (t = n.getNodeTop(o)) == null ? void 0 : t.prev(), t = t == null ? void 0 : t.getNextSibling(), n.length && (n == null ? void 0 : n.getNodeName()) === 'PRE' && t.length === 0 && i.getCursorPos() === 0 && e.keyCode === 8 && e.preventDefault())
      })
    }
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); let o; var i = n(2); const r = i.__importDefault(n(23)); const a = i.__importDefault(n(3)); const l = i.__importDefault(n(414)); const u = n(6); const s = n(7); var i = (o = r.default, i.__extends(c, o), c.prototype.clickHandler = function() {
      let e; let t = this.editor; const n = t.selection.getRange(); let o = t.selection.getSelectionContainerElem(); o != null && o.length && (t = (e = a.default(o.elems[0])).parentUntil('TABLE', o.elems[0]), o = e.children(), e.getNodeName() !== 'CODE' && (t && a.default(t.elems[0]).getNodeName() === 'TABLE' || (!o || o.length === 0 || a.default(o.elems[0]).getNodeName() !== 'IMG' || n != null && n.collapsed) && this.createSplitLine()))
    }, c.prototype.createSplitLine = function() {
      let e = `<hr/>${s.EMPTY_P}`; u.UA.isFirefox && (e = '<hr/><p></p>'), this.editor.cmd.do('insertHTML', e)
    }, c.prototype.tryChangeActive = function() {}, c); function c(e) {
      const t = a.default('<div class="w-e-menu" data-title="分割线"><i class="w-e-icon-split-line"></i></div>'); const n = o.call(this, t, e) || this; return l.default(e), n
    }t.default = i
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); const o = n(2).__importDefault(n(415)); t.default = function(e) {
      o.default(e)
    }
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); const o = n(2); const i = o.__importDefault(n(3)); const r = o.__importDefault(n(36)); function a(n) {
      let o; return {
        showSplitLineTooltip: function(e) {
          const t = [{
            $elem: i.default(`<span>${n.i18next.t('menus.panelMenus.删除')}</span>`),
            onClick: function(e, t) {
              return e.selection.createRangeByElem(t), e.selection.restoreSelection(), e.cmd.do('delete'), !0
            }
          }]; (o = new r.default(n, e, t)).create()
        },
        hideSplitLineTooltip: function() {
          o && (o.remove(), o = null)
        }
      }
    }t.default = function(e) {
      const t = (n = a(e)).showSplitLineTooltip; var n = n.hideSplitLineTooltip; e.txt.eventHooks.splitLineEvents.push(t), e.txt.eventHooks.clickEvents.push(n), e.txt.eventHooks.keyupEvents.push(n), e.txt.eventHooks.toolbarClickEvents.push(n), e.txt.eventHooks.menuClickEvents.push(n), e.txt.eventHooks.textScrollEvents.push(n)
    }
  }, function(e, t, n) {
    'use strict'; var o = n(0); var i = o(n(1)); const r = o(n(4)); (0, i.default)(t, '__esModule', { value: !0 }); let a; var o = n(2); const l = o.__importDefault(n(3)); var i = o.__importDefault(n(23)); const u = n(99); const s = o.__importDefault(n(422)); const c = o.__importDefault(n(140)); var o = (a = i.default, o.__extends(f, a), f.prototype.clickHandler = function() {
      const e = this.editor; u.isAllTodo(e) ? (this.cancelTodo(), this.tryChangeActive()) : this.setTodo()
    }, f.prototype.tryChangeActive = function() {
      u.isAllTodo(this.editor) ? this.active() : this.unActive()
    }, f.prototype.setTodo = function() {
      const o = this.editor; const e = o.selection.getSelectionRangeTopNodes(); (0, r.default)(e).call(e, (e) => {
        let t; let n; (e == null ? void 0 : e.getNodeName()) === 'P' && (n = (n = (t = c.default(e).getTodo()).children()) === null || void 0 === n ? void 0 : n.getNode(), t.insertAfter(e), o.selection.moveCursor(n), e.remove())
      }), this.tryChangeActive()
    }, f.prototype.cancelTodo = function() {
      const o = this.editor; const e = o.selection.getSelectionRangeTopNodes(); (0, r.default)(e).call(e, (e) => {
        var t = (n = (t = e.childNodes()) === null || void 0 === t ? void 0 : t.childNodes()) === null || void 0 === n ? void 0 : n.clone(!0); var n = l.default('<p></p>'); n.append(t), n.insertAfter(e), (t = n.childNodes()) !== null && void 0 !== t && t.get(0).remove(), o.selection.moveCursor(n.getNode()), e.remove()
      })
    }, f); function f(e) {
      const t = l.default('<div class="w-e-menu" data-title="待办事项">\n                    <i class="w-e-icon-checkbox-checked"></i>\n                </div>'); const n = a.call(this, t, e) || this; return s.default(e), n
    }t.default = o
  }, function(e, t, n) {
    e.exports = n(418)
  }, function(e, t, n) {
    n = n(419); e.exports = n
  }, function(e, t, n) {
    const o = n(420); const i = Array.prototype; e.exports = function(e) {
      const t = e.every; return e === i || e instanceof Array && t === i.every ? o : t
    }
  }, function(e, t, n) {
    n(421); n = n(14); e.exports = n('Array').every
  }, function(e, t, n) {
    'use strict'; const o = n(5); const i = n(30).every; o({ target: 'Array', proto: !0, forced: !n(70)('every') }, {
      every: function(e) {
        return i(this, e, arguments.length > 1 ? arguments[1] : void 0)
      }
    })
  }, function(e, t, n) {
    'use strict'; const o = n(0); var i = o(n(1)); const A = o(n(4)); (0, i.default)(t, '__esModule', { value: !0 }); var i = n(2); const v = i.__importDefault(n(3)); const m = n(99); const g = i.__importDefault(n(140)); const y = n(99); const w = n(7); t.default = function(h) {
      h.txt.eventHooks.enterDownEvents.push((e) => {
        if (m.isAllTodo(h)) {
          e.preventDefault(); let t; let n; let o; let i; let r; let a; const l = h.selection; const u = l.getSelectionRangeTopNodes()[0]; const s = (c = u.childNodes()) === null || void 0 === c ? void 0 : c.get(0); var e = (t = window.getSelection()) === null || void 0 === t ? void 0 : t.anchorNode; var c = l.getRange(); if (c != null && c.collapsed || (t = c == null ? void 0 : c.commonAncestorContainer.childNodes, n = c == null ? void 0 : c.startContainer, o = c == null ? void 0 : c.endContainer, d = c == null ? void 0 : c.startOffset, p = c == null ? void 0 : c.endOffset, r = i = 0, a = [], t != null && (0, A.default)(t).call(t, (e, t) => {
            e.contains(n) && (i = t), e.contains(o) && (r = t)
          }), r - i > 1 && (t != null && (0, A.default)(t).call(t, (e, t) => {
            t <= i || r <= t || a.push(e)
          }), (0, A.default)(a).call(a, (e) => {
            e.remove()
          })), y.dealTextNode(n, d), y.dealTextNode(o, p, !1), h.selection.moveCursor(o, 0)), u.text() === '') {
            var f = v.default(w.EMPTY_P); return f.insertAfter(u), l.moveCursor(f.getNode()), void u.remove()
          } var d = l.getCursorPos(); var p = m.getCursorNextNode(s == null ? void 0 : s.getNode(), e, d); var f = g.default(v.default(p)); var e = f.getInputContainer(); var d = e.parent().getNode(); var p = f.getTodo(); var f = e.getNode().nextSibling; (s == null ? void 0 : s.text()) === '' && s != null && s.append(v.default('<br>')), p.insertAfter(u), f && (f == null ? void 0 : f.textContent) !== '' ? l.moveCursor(d) : ((f == null ? void 0 : f.nodeName) !== 'BR' && v.default('<br>').insertAfter(e), l.moveCursor(d, 1))
        }
      }), h.txt.eventHooks.deleteUpEvents.push(() => {
        const e = h.selection.getSelectionRangeTopNodes()[0]; e && y.isTodo(e) && e.text() === '' && (v.default(w.EMPTY_P).insertAfter(e), e.remove())
      }), h.txt.eventHooks.deleteDownEvents.push((e) => {
        if (m.isAllTodo(h)) {
          const t = h.selection; const n = t.getSelectionRangeTopNodes()[0]; let o = (l = n.childNodes()) === null || void 0 === l ? void 0 : l.getNode(); const i = v.default('<p></p>'); const r = i.getNode(); let a = (u = window.getSelection()) === null || void 0 === u ? void 0 : u.anchorNode; var l = t.getCursorPos(); var u = a.previousSibling; if (n.text() === '') {
            e.preventDefault(); a = v.default(w.EMPTY_P); return a.insertAfter(n), n.remove(), void t.moveCursor(a.getNode(), 0)
          }(u == null ? void 0 : u.nodeName) === 'SPAN' && u.childNodes[0].nodeName === 'INPUT' && l === 0 && (e.preventDefault(), o != null && (0, A.default)(o = o.childNodes).call(o, (e, t) => {
            t !== 0 && r.appendChild(e.cloneNode(!0))
          }), i.insertAfter(n), n.remove())
        }
      }), h.txt.eventHooks.clickEvents.push((e) => {
        e && e.target instanceof HTMLInputElement && e.target.type === 'checkbox' && (e.target.checked ? e.target.setAttribute('checked', 'true') : e.target.removeAttribute('checked'))
      })
    }
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }), t.selectorValidator = void 0; const o = n(2); const s = o.__importDefault(n(3)); const c = n(6); const f = n(7); const d = o.__importDefault(n(128)); const p = '1px solid #c9d8db'; const h = '#FFF'; const A = '1px solid #EEE'; t.default = function(e) {
      var t = e.toolbarSelector; let n = s.default(t); let o = e.textSelector; const i = e.config.height; const r = e.i18next; const a = s.default('<div></div>'); const l = s.default('<div></div>'); var t = null; o == null
        ? (u = n.children(), n.append(a).append(l), a.css('background-color', h).css('border', p)
            .css('border-bottom', A), l.css('border', p).css('border-top', 'none')
            .css('height', `${i}px`))
        : (n.append(a), t = s.default(o).children(), s.default(o).append(l), u = l.children()), (n = s.default('<div></div>')).attr('contenteditable', 'true').css('width', '100%')
        .css('height', '100%'), (o = (o = e.config.placeholder) !== d.default.placeholder ? s.default(`<div>${o}</div>`) : s.default(`<div>${r.t(o)}</div>`)).addClass('placeholder'), u && u.length ? (n.append(u), o.hide()) : n.append(s.default(f.EMPTY_P)), t && t.length && (n.append(t), o.hide()), l.append(n), l.append(o), a.addClass('w-e-toolbar').css('z-index', e.zIndex.get('toolbar')), l.addClass('w-e-text-container'), l.css('z-index', e.zIndex.get()), n.addClass('w-e-text'); var u = c.getRandom('toolbar-elem'); a.attr('id', u), t = c.getRandom('text-elem'), n.attr('id', t), (o = l.getBoundingClientRect().height) !== n.getBoundingClientRect().height && n.css('min-height', `${o}px`), e.$toolbarElem = a, e.$textContainerElem = l, e.$textElem = n, e.toolbarElemId = u, e.textElemId = t
    }, t.selectorValidator = function(e) {
      const t = 'data-we-id'; const n = /^wangEditor-\d+$/; const o = e.textSelector; const i = e.toolbarSelector; const r = { bar: s.default('<div></div>'), text: s.default('<div></div>') }; if (i == null) throw new Error('错误：初始化编辑器时候未传入任何参数，请查阅文档'); if (r.bar = s.default(i), !r.bar.elems.length) throw new Error(`无效的节点选择器：${i}`); if (n.test(r.bar.attr(t))) throw new Error('初始化节点已存在编辑器实例，无法重复创建编辑器'); if (o) {
        if (r.text = s.default(o), !r.text.elems.length) throw new Error(`无效的节点选择器：${o}`); if (n.test(r.text.attr(t))) throw new Error('初始化节点已存在编辑器实例，无法重复创建编辑器')
      }r.bar.attr(t, e.id), r.text.attr(t, e.id), e.beforeDestroy(() => {
        r.bar.removeAttr(t), r.text.removeAttr(t)
      })
    }
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); const a = n(2).__importDefault(n(3)); const l = n(7); t.default = function e(t, n) {
      const o = t.$textElem; let i = o.children(); if (!i || !i.length) return o.append(a.default(l.EMPTY_P)), void e(t); const r = i.last(); if (n && (i = r.html().toLowerCase(), n = r.getNodeName(), i !== '<br>' && i !== '<br/>' || n !== 'P')) return o.append(a.default(l.EMPTY_P)), void e(t); t.selection.createRangeByElem(r, !1, !0), t.config.focus ? t.selection.restoreSelection() : t.selection.clearWindowSelectionRange()
    }
  }, function(e, t, n) {
    'use strict'; const o = n(0); const i = o(n(1)); const r = o(n(4)); (0, i.default)(t, '__esModule', { value: !0 }); const a = n(2).__importDefault(n(3)); function l(e) {
      (0, e.config.onfocus)(e.txt.html() || '')
    }t.default = function(e) {
      let n; let t; (n = e).txt.eventHooks.changeEvents.push(() => {
        let e; const t = n.config.onchange; t && (e = n.txt.html() || '', n.isFocus = !0, t(e)), n.txt.togglePlaceholder()
      }), (function(i) {
        function e(e) {
          var t = e.target; var n = a.default(t); var o = i.$textElem; var t = i.$toolbarElem; var o = o.isContain(n); var n = t.isContain(n); var e = t.elems[0] == e.target; o
            ? (i.isFocus || l(i), i.isFocus = !0)
            : n && !e || !i.isFocus || (n = (o = i).config.onblur, e = o.txt.html() || '', (0, r.default)(o = o.txt.eventHooks.onBlurEvents).call(o, (e) => {
              return e()
            }), n(e), i.isFocus = !1)
        }i.isFocus = !1, document.activeElement === i.$textElem.elems[0] && i.config.focus && (l(i), i.isFocus = !0); a.default(document).on('click', e), i.beforeDestroy(() => {
          a.default(document).off('click', e)
        })
      }(e)), (t = e).$textElem.on('compositionstart', () => {
        t.isComposing = !0, t.txt.togglePlaceholder()
      }).on('compositionend', () => {
        t.isComposing = !1, t.txt.togglePlaceholder()
      })
    }
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }), t.default = function(e) {
      const t = (n = e.config).lang; var n = n.languages; if (e.i18next == null) {
        e.i18next = {
          t: function(e) {
            e = e.split('.'); return e[e.length - 1]
          }
        }
      } else {
        try {
          e.i18next.init({ ns: 'wangEditor', lng: t, defaultNS: 'wangEditor', resources: n })
        } catch (e) {
          throw new Error(`i18next:${e}`)
        }
      }
    }
  }, function(e, o, t) {
    'use strict'; const n = t(0); const i = n(t(1)); const r = n(t(31)); (0, i.default)(o, '__esModule', { value: !0 }), o.setUnFullScreen = o.setFullScreen = void 0; const a = t(2).__importDefault(t(3)); t(428); const l = 'w-e-icon-fullscreen'; const u = 'w-e-icon-fullscreen_exit'; const s = 'w-e-full-screen-editor'; o.setFullScreen = function(e) {
      const t = a.default(e.toolbarSelector); const n = e.$textContainerElem; let o = e.$toolbarElem; const i = (0, r.default)(o).call(o, `i.${l}`); var e = e.config; i.removeClass(l), i.addClass(u), t.addClass(s), t.css('z-index', e.zIndexFullScreen); o = o.getBoundingClientRect(); n.css('height', `calc(100% - ${o.height}px)`)
    }; o.setUnFullScreen = function(e) {
      const t = a.default(e.toolbarSelector); const n = e.$textContainerElem; var o = e.$toolbarElem; var o = (0, r.default)(o).call(o, `i.${u}`); var e = e.config; o.removeClass(u), o.addClass(l), t.removeClass(s), t.css('z-index', 'auto'), n.css('height', `${e.height}px`)
    }; o.default = function(t) {
      let e; let n; t.textSelector || t.config.showFullScreen && (e = t.$toolbarElem, (n = a.default(`<div class="w-e-menu" data-title="全屏">\n            <i class="${l}"></i>\n        </div>`)).on('click', (e) => {
        (0, r.default)(e = a.default(e.currentTarget)).call(e, 'i')
          .hasClass(l)
          ? (n.attr('data-title', '取消全屏'), o.setFullScreen(t))
          : (n.attr('data-title', '全屏'), o.setUnFullScreen(t))
      }), e.append(n))
    }
  }, function(e, t, n) {
    const o = n(21); let i = n(429); var n = { insert: 'head', singleton: !1 }; o(i = typeof (i = i.__esModule ? i.default : i) === 'string' ? [[e.i, i, '']] : i, n); e.exports = i.locals || {}
  }, function(e, t, n) {
    (t = n(22)(!1)).push([e.i, '.w-e-full-screen-editor {\n  position: fixed;\n  width: 100%!important;\n  height: 100%!important;\n  left: 0;\n  top: 0;\n}\n', '']), e.exports = t
  }, function(e, t, n) {
    'use strict'; const o = n(0); const i = o(n(1)); const r = o(n(31)); (0, i.default)(t, '__esModule', { value: !0 }); t.default = function(e, t) {
      e = e.$textElem, t = (0, r.default)(e).call(e, `[id='${t}']`)
        .getOffsetData().top; e.scrollTop(t)
    }
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); const o = n(2).__importDefault(n(127)); const i = { menu: 2, panel: 2, toolbar: 1, tooltip: 1, textContainer: 1 }; var n = (r.prototype.get = function(e) {
      return e && this.tier[e] ? this.baseZIndex + this.tier[e] : this.baseZIndex
    }, r.prototype.init = function(e) {
      this.baseZIndex == o.default.zIndex && (this.baseZIndex = e.config.zIndex)
    }, r); function r() {
      this.tier = i, this.baseZIndex = o.default.zIndex
    }t.default = n
  }, function(e, t, n) {
    'use strict'; var o = n(0); var i = o(n(1)); const a = o(n(73)); const r = o(n(4)); (0, i.default)(t, '__esModule', { value: !0 }); var o = n(2); var i = o.__importDefault(n(433)); const l = n(6); const u = n(7); let s; var o = (s = i.default, o.__extends(c, s), c.prototype.save = function() {
      this.data.length && (this.editor.history.save(this.data), this.data.length = 0, this.emit())
    }, c.prototype.emit = function() {
      let e; (0, r.default)(e = this.editor.txt.eventHooks.changeEvents).call(e, (e) => {
        return e()
      })
    }, c.prototype.observe = function() {
      const e = this; s.prototype.observe.call(this, this.editor.$textElem.elems[0]); const t = this.editor.config.onchangeTimeout; this.asyncSave = l.debounce(() => {
        e.save()
      }, t), this.editor.isCompatibleMode || this.editor.$textElem.on('compositionend', () => {
        e.asyncSave()
      })
    }, c); function c(i) {
      var r = s.call(this, (e, t) => {
        let n; let o; if (n = e, o = t.target, e = (0, a.default)(n).call(n, (e) => {
          const t = e.type; const n = e.target; var e = e.attributeName; return t != 'attributes' || t == 'attributes' && (e == 'contenteditable' || n != o)
        }), (n = r.data).push.apply(n, e), i.isCompatibleMode)r.asyncSave(); else if (!i.isComposing) return r.asyncSave()
      }) || this; return r.editor = i, r.data = [], r.asyncSave = u.EMPTY_FN, r
    }t.default = o
  }, function(e, t, n) {
    'use strict'; n = n(0)(n(1)); (0, n.default)(t, '__esModule', { value: !0 }); (0, n.default)(o.prototype, 'target', {
      get: function() {
        return this.node
      },
      enumerable: !1,
      configurable: !0
    }), o.prototype.observe = function(e) {
      this.node instanceof Node || (this.node = e, this.connect())
    }, o.prototype.connect = function() {
      if (this.node) return this.observer.observe(this.node, this.options), this; throw new Error('还未初始化绑定，请您先绑定有效的 Node 节点')
    }, o.prototype.disconnect = function() {
      const e = this.observer.takeRecords(); e.length && this.callback(e), this.observer.disconnect()
    }, n = o; function o(t, e) {
      const n = this; this.options = { subtree: !0, childList: !0, attributes: !0, attributeOldValue: !0, characterData: !0, characterDataOldValue: !0 }, this.callback = function(e) {
        t(e, n)
      }, this.observer = new MutationObserver(this.callback), e && (this.options = e)
    }t.default = n
  }, function(e, t, n) {
    'use strict'; var o = n(0)(n(1)); (0, o.default)(t, '__esModule', { value: !0 }); const i = n(2); const r = i.__importDefault(n(435)); const a = i.__importDefault(n(442)); const l = i.__importDefault(n(443)); var o = ((0, o.default)(u.prototype, 'size', {
      get: function() {
        return this.scroll.size
      },
      enumerable: !1,
      configurable: !0
    }), u.prototype.observe = function() {
      this.content.observe(), this.scroll.observe(), this.editor.isCompatibleMode || this.range.observe()
    }, u.prototype.save = function(e) {
      e.length && (this.content.save(e), this.scroll.save(), this.editor.isCompatibleMode || this.range.save())
    }, u.prototype.revoke = function() {
      this.editor.change.disconnect(); const e = this.content.revoke(); e && (this.scroll.revoke(), this.editor.isCompatibleMode || (this.range.revoke(), this.editor.$textElem.focus())), this.editor.change.connect(), e && this.editor.change.emit()
    }, u.prototype.restore = function() {
      this.editor.change.disconnect(); const e = this.content.restore(); e && (this.scroll.restore(), this.editor.isCompatibleMode || (this.range.restore(), this.editor.$textElem.focus())), this.editor.change.connect(), e && this.editor.change.emit()
    }, u); function u(e) {
      this.editor = e, this.content = new r.default(e), this.scroll = new a.default(e), this.range = new l.default(e)
    }t.default = o
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); const o = n(2); const i = o.__importDefault(n(436)); const r = o.__importDefault(n(440)); var n = (a.prototype.observe = function() {
      this.editor.isCompatibleMode ? this.cache = new r.default(this.editor) : this.cache = new i.default(this.editor), this.cache.observe()
    }, a.prototype.save = function(e) {
      this.editor.isCompatibleMode ? this.cache.save() : this.cache.compile(e)
    }, a.prototype.revoke = function() {
      let e; return (e = this.cache) === null || void 0 === e ? void 0 : e.revoke()
    }, a.prototype.restore = function() {
      let e; return (e = this.cache) === null || void 0 === e ? void 0 : e.restore()
    }, a); function a(e) {
      this.editor = e
    }t.default = n
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); let o; var i = n(2); const r = i.__importDefault(n(100)); const a = i.__importDefault(n(438)); const l = n(439); var i = (o = r.default, i.__extends(u, o), u.prototype.observe = function() {
      this.resetMaxSize(this.editor.config.historyMaxSize)
    }, u.prototype.compile = function(e) {
      return this.save(a.default(e)), this
    }, u.prototype.revoke = function() {
      return o.prototype.revoke.call(this, (e) => {
        l.revoke(e)
      })
    }, u.prototype.restore = function() {
      return o.prototype.restore.call(this, (e) => {
        l.restore(e)
      })
    }, u); function u(e) {
      const t = o.call(this, e.config.historyMaxSize) || this; return t.editor = e, t
    }t.default = i
  }, function(e, t, n) {
    'use strict'; n = n(0)(n(1)); (0, n.default)(t, '__esModule', { value: !0 }), t.CeilStack = void 0; o.prototype.resetMax = function(e) {
      e = Math.abs(e), this.reset || isNaN(e) || (this.max = e, this.reset = !0)
    }, (0, n.default)(o.prototype, 'size', {
      get: function() {
        return this.data.length
      },
      enumerable: !1,
      configurable: !0
    }), o.prototype.instack = function(e) {
      return this.data.unshift(e), this.max && this.size > this.max && (this.data.length = this.max), this
    }, o.prototype.outstack = function() {
      return this.data.shift()
    }, o.prototype.clear = function() {
      return this.data.length = 0, this
    }, n = o; function o(e) {
      void 0 === e && (e = 0), this.data = [], this.max = 0, this.reset = !1, (e = Math.abs(e)) && (this.max = e)
    }t.CeilStack = n
  }, function(e, t, n) {
    'use strict'; const o = n(0); const i = o(n(1)); const u = o(n(4)); const s = o(n(27)); (0, i.default)(t, '__esModule', { value: !0 }), t.compliePosition = t.complieNodes = t.compileValue = t.compileType = void 0; const c = n(6); function f(e) {
      switch (e) {
        case 'childList':return 'node'; case 'attributes':return 'attr'; default:return 'text'
      }
    } function d(e) {
      switch (e.type) {
        case 'attributes':return e.target.getAttribute(e.attributeName) || ''; case 'characterData':return e.target.textContent; default:return ''
      }
    } function p(e) {
      const t = {}; return e.addedNodes.length && (t.add = c.toArray(e.addedNodes)), e.removedNodes.length && (t.remove = c.toArray(e.removedNodes)), t
    } function h(e) {
      e = e.previousSibling ? { type: 'before', target: e.previousSibling } : e.nextSibling ? { type: 'after', target: e.nextSibling } : { type: 'parent', target: e.target }; return e
    }t.compileType = f, t.compileValue = d, t.complieNodes = p, t.compliePosition = h; const A = ['UL', 'OL', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6']; function v(e, t) {
      for (var n = 0, o = t.length - 1; o > 0 && e.contains(t[o]); o--)n++; return n
    }t.default = function(e) {
      const r = []; let a = !1; const l = []; return (0, u.default)(e).call(e, (e, t) => {
        let n; let o; const i = { type: f(e.type), target: e.target, attr: e.attributeName || '', value: d(e) || '', oldValue: e.oldValue || '', nodes: p(e), position: h(e) }; r.push(i), c.UA.isFirefox && (a && e.addedNodes.length && e.addedNodes[0].nodeType == 1 && (o = { type: 'node', target: n = e.addedNodes[0], attr: '', value: '', oldValue: '', nodes: { add: [a] }, position: { type: 'parent', target: n } }, (0, s.default)(A).call(A, n.nodeName) != -1 ? (o.nodes.add = c.toArray(n.childNodes), r.push(o)) : a.nodeType == 3 ? (v(n, l) && (o.nodes.add = c.toArray(n.childNodes)), r.push(o)) : (0, s.default)(A).call(A, e.target.nodeName) == -1 && v(n, l) && (o.nodes.add = c.toArray(n.childNodes), r.push(o))), i.type == 'node' && e.removedNodes.length == 1 ? (a = e.removedNodes[0], l.push(a)) : (a = !1, l.length = 0))
      }), r
    }
  }, function(e, t, n) {
    'use strict'; const o = n(0); const i = o(n(1)); const r = o(n(4)); const a = o(n(131)); function l(t, e) {
      let n = t.position.target; switch (t.position.type) {
        case 'before':n.nextSibling
          ? (n = n.nextSibling, (0, r.default)(e).call(e, (e) => {
              t.target.insertBefore(e, n)
            }))
          : (0, r.default)(e).call(e, (e) => {
              t.target.appendChild(e)
            }); break; case 'after':(0, r.default)(e).call(e, (e) => {
          t.target.insertBefore(e, n)
        }); break; default:(0, r.default)(e).call(e, (e) => {
          n.appendChild(e)
        })
      }
    }(0, i.default)(t, '__esModule', { value: !0 }), t.restore = t.revoke = void 0; const u = {
      node: function(t) {
        for (let e = 0, n = (0, a.default)(t.nodes); e < n.length; e++) {
          var o = n[e]; const i = o[0]; var o = o[1]; i === 'add'
            ? (0, r.default)(o).call(o, (e) => {
                t.target.removeChild(e)
              })
            : l(t, o)
        }
      },
      text: function(e) {
        e.target.textContent = e.oldValue
      },
      attr: function(e) {
        const t = e.target; e.oldValue == null ? t.removeAttribute(e.attr) : t.setAttribute(e.attr, e.oldValue)
      }
    }; t.revoke = function(e) {
      for (let t = e.length - 1; t > -1; t--) {
        const n = e[t]; u[n.type](n)
      }
    }; const s = {
      node: function(e) {
        for (let t = 0, n = (0, a.default)(e.nodes); t < n.length; t++) {
          var o = n[t]; const i = o[0]; var o = o[1]; i === 'add'
            ? l(e, o)
            : (0, r.default)(o).call(o, (e) => {
                e.parentNode.removeChild(e)
              })
        }
      },
      text: function(e) {
        e.target.textContent = e.value
      },
      attr: function(e) {
        e.target.setAttribute(e.attr, e.value)
      }
    }; t.restore = function(e) {
      for (let t = 0, n = e; t < n.length; t++) {
        const o = n[t]; s[o.type](o)
      }
    }
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); const o = n(441); var n = (i.prototype.observe = function() {
      this.data.resetMax(this.editor.config.historyMaxSize), this.data.insertLast(this.editor.$textElem.html())
    }, i.prototype.save = function() {
      return this.data.insertLast(this.editor.$textElem.html()), this
    }, i.prototype.revoke = function() {
      const e = this.data.prev(); return !!e && (this.editor.$textElem.html(e), !0)
    }, i.prototype.restore = function() {
      const e = this.data.next(); return !!e && (this.editor.$textElem.html(e), !0)
    }, i); function i(e) {
      this.editor = e, this.data = new o.TailChain()
    }t.default = n
  }, function(e, t, n) {
    'use strict'; const o = n(0); let i = o(n(1)); const r = o(n(94)); (0, i.default)(t, '__esModule', { value: !0 }), t.TailChain = void 0; a.prototype.resetMax = function(e) {
      (e = Math.abs(e)) && (this.max = e)
    }, (0, i.default)(a.prototype, 'size', {
      get: function() {
        return this.data.length
      },
      enumerable: !1,
      configurable: !0
    }), a.prototype.insertLast = function(e) {
      let t; for (this.isRe && ((0, r.default)(t = this.data).call(t, this.point + 1), this.isRe = !1), this.data.push(e); this.max && this.size > this.max;) this.data.shift(); return this.point = this.size - 1, this
    }, a.prototype.current = function() {
      return this.data[this.point]
    }, a.prototype.prev = function() {
      if (this.isRe || (this.isRe = !0), this.point--, !(this.point < 0)) return this.current(); this.point = 0
    }, a.prototype.next = function() {
      if (this.isRe || (this.isRe = !0), this.point++, !(this.point >= this.size)) return this.current(); this.point = this.size - 1
    }, i = a; function a() {
      this.data = [], this.max = 0, this.point = 0, this.isRe = !1
    }t.TailChain = i
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 }); let o; var i = n(2); var n = i.__importDefault(n(100)); var i = (o = n.default, i.__extends(r, o), r.prototype.observe = function() {
      const e = this; this.target = this.editor.$textElem.elems[0], this.editor.$textElem.on('scroll', () => {
        e.last = e.target.scrollTop
      }), this.resetMaxSize(this.editor.config.historyMaxSize)
    }, r.prototype.save = function() {
      return o.prototype.save.call(this, [this.last, this.target.scrollTop]), this
    }, r.prototype.revoke = function() {
      const t = this; return o.prototype.revoke.call(this, (e) => {
        t.target.scrollTop = e[0]
      })
    }, r.prototype.restore = function() {
      const t = this; return o.prototype.restore.call(this, (e) => {
        t.target.scrollTop = e[1]
      })
    }, r); function r(e) {
      const t = o.call(this, e.config.historyMaxSize) || this; return t.editor = e, t.last = 0, t.target = e.$textElem.elems[0], t
    }t.default = i
  }, function(e, t, n) {
    'use strict'; var o = n(0)(n(1)); (0, o.default)(t, '__esModule', { value: !0 }); const i = n(2); const r = i.__importDefault(n(100)); const a = i.__importDefault(n(3)); const l = n(6); function u(e) {
      return { start: [e.startContainer, e.startOffset], end: [e.endContainer, e.endOffset], root: e.commonAncestorContainer, collapsed: e.collapsed }
    } let s; var o = (s = r.default, i.__extends(c, s), (0, o.default)(c.prototype, 'rangeHandle', {
      get: function() {
        const e = document.getSelection(); return e && e.rangeCount ? e.getRangeAt(0) : document.createRange()
      },
      enumerable: !1,
      configurable: !0
    }), c.prototype.observe = function() {
      const t = this; function e() {
        const e = t.rangeHandle; t.root !== e.commonAncestorContainer && !t.root.contains(e.commonAncestorContainer) || t.editor.isComposing || t.updateLastRange()
      } this.root = this.editor.$textElem.elems[0], this.resetMaxSize(this.editor.config.historyMaxSize), a.default(document).on('selectionchange', e), this.editor.beforeDestroy(() => {
        a.default(document).off('selectionchange', e)
      }), t.editor.$textElem.on('keydown', (e) => {
        e.key != 'Backspace' && e.key != 'Delete' || t.updateLastRange()
      })
    }, c.prototype.save = function() {
      const e = u(this.rangeHandle); return s.prototype.save.call(this, [this.lastRange, e]), this.lastRange = e, this
    }, c.prototype.set = function(e) {
      try {
        if (e) {
          const t = this.rangeHandle; return t.setStart.apply(t, e.start), t.setEnd.apply(t, e.end), this.editor.menus.changeActive(), !0
        }
      } catch (e) {
        return !1
      } return !1
    }, c.prototype.revoke = function() {
      const t = this; return s.prototype.revoke.call(this, (e) => {
        t.set(e[0])
      })
    }, c.prototype.restore = function() {
      const t = this; return s.prototype.restore.call(this, (e) => {
        t.set(e[1])
      })
    }, c); function c(e) {
      const t = s.call(this, e.config.historyMaxSize) || this; return t.editor = e, t.lastRange = u(document.createRange()), t.root = e.$textElem.elems[0], t.updateLastRange = l.debounce(() => {
        t.lastRange = u(t.rangeHandle)
      }, e.config.onchangeTimeout), t
    }t.default = o
  }, function(e, t, n) {
    'use strict'; const o = n(0); const i = o(n(1)); const a = o(n(31)); (0, i.default)(t, '__esModule', { value: !0 }); const l = n(2).__importDefault(n(3)); n(445), t.default = function(n) {
      let o; let i; let r = !1; return n.txt.eventHooks.changeEvents.push(() => {
        r && (0, a.default)(o).call(o, '.w-e-content-preview')
          .html(n.$textElem.html())
      }), {
        disable: function() {
          let e; let t; r || (n.$textElem.hide(), e = n.zIndex.get('textContainer'), t = n.txt.html(), o = l.default(`<div class="w-e-content-mantle" style="z-index:${e}">\n                <div class="w-e-content-preview w-e-text">${t}</div>\n            </div>`), n.$textContainerElem.append(o), t = n.zIndex.get('menu'), i = l.default(`<div class="w-e-menue-mantle" style="z-index:${t}"></div>`), n.$toolbarElem.append(i), r = !0)
        },
        enable: function() {
          r && (o.remove(), i.remove(), n.$textElem.show(), r = !1)
        }
      }
    }
  }, function(e, t, n) {
    const o = n(21); let i = n(446); var n = { insert: 'head', singleton: !1 }; o(i = typeof (i = i.__esModule ? i.default : i) === 'string' ? [[e.i, i, '']] : i, n); e.exports = i.locals || {}
  }, function(e, t, n) {
    (t = n(22)(!1)).push([e.i, '.w-e-content-mantle {\n  width: 100%;\n  height: 100%;\n  overflow-y: auto;\n}\n.w-e-content-mantle .w-e-content-preview {\n  width: 100%;\n  min-height: 100%;\n  padding: 0 10px;\n  line-height: 1.5;\n}\n.w-e-content-mantle .w-e-content-preview img {\n  cursor: default;\n}\n.w-e-content-mantle .w-e-content-preview img:hover {\n  box-shadow: none;\n}\n.w-e-menue-mantle {\n  position: absolute;\n  height: 100%;\n  width: 100%;\n  top: 0;\n  left: 0;\n}\n', '']), e.exports = t
  }, function(e, t, n) {
    'use strict'; (0, n(0)(n(1)).default)(t, '__esModule', { value: !0 })
  }], i.c = o, i.d = function(e, t, n) {
    i.o(e, t) || Object.defineProperty(e, t, { enumerable: !0, get: n })
  }, i.r = function(e) {
    typeof Symbol !== 'undefined' && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, { value: 'Module' }), Object.defineProperty(e, '__esModule', { value: !0 })
  }, i.t = function(t, e) {
    if (1 & e && (t = i(t)), 8 & e) return t; if (4 & e && typeof t === 'object' && t && t.__esModule) return t; const n = Object.create(null); if (i.r(n), Object.defineProperty(n, 'default', { enumerable: !0, value: t }), 2 & e && typeof t !== 'string') {
      for (const o in t) {
        i.d(n, o, ((e) => {
          return t[e]
        }).bind(null, o))
      }
    } return n
  }, i.n = function(e) {
    const t = e && e.__esModule
      ? function() {
        return e.default
      }
      : function() {
        return e
      }; return i.d(t, 'a', t), t
  }, i.o = function(e, t) {
    return Object.prototype.hasOwnProperty.call(e, t)
  }, i.p = '', i(i.s = 141).default; function i(e) {
    if (o[e]) return o[e].exports; const t = o[e] = { i: e, l: !1, exports: {} }; return n[e].call(t.exports, t, t.exports, i), t.l = !0, t.exports
  } let n; let o
}))
